/* eslint-disable eqeqeq */

AoPS.Community.Models = (function (ComModels) {
	var cmty_ajax,
		Lang = AoPS.Community.Lang,
		Constants = AoPS.Community.Constants,
		Utils = AoPS.Community.Utils;

	cmty_ajax = Utils.cmty_ajax;

	ComModels.Model = Backbone.Model.extend({
		setDefault: function (setting, val) {
			if (!this.has(setting)) {
				this.set(setting, val);
			}
		},
	});

	/**
	 * ComModels.Master is the master model for controlling the ComModels Data
	 *
	 * Properties:
	 *
	 * bookmarked_forum_category : ComModels.Category of the category of bookmarked forums
	 * bookmarked_tag_category : ComModels.Category of the category of bookmarked tags
	 * bookmarked_topic_category : ComModels.Category of the category of bookmarked topics
	 * categories : Backbone collection of ComModels.Category that have been loaded
	 * topics : Backbone collection of ComModels.Topic of topics that have been loaded
	 * topic_lists : Backbone collection of ComModels.TopicList that have been loaded
	 *
	 * topic_data_loaded : boolean tells us if we have any topics loaded
	 * topics_loading : boolean tells us if the topics are in the process of being loaded
	 * feed : ComModels.Feed for the feed for this page.
	 * focus_topic : The topic that is being viewed right now, if any
	 * focus_tag : The tag that is being filtered for right now, if any (for when user selects tag)
	 *      null for none, {item_id, item_text, item_forum_id, item_type } otherwise
	 *
	 * last_topic_fetch_time : The last time at which data was fetched from the server.
	 * ajax_data_queue : Array of objects that get fed to the ajax caller
	 * is_fetching_new_topics: boolean tells us if a new topic load is in progress
	 * watched_users : Array of user ids of users we are watching on the front end
	 * watched_times_short : Array of objects {model, int_time_field, rendered_time_field}
	 *		for times that we are updating live, where the time gets updated each minute
	 * watched_times_long : Array of objects for times we are updating live, but infrequently
	 *		(default times more than 1 hour in past)
	 *
	 *
	 * Triggered Methods
	 *
	 * onChangeFocusTopic()
	 *       Stuff that happens when the focus topic changes
	 *
	 * Fetching Methods
	 *
	 * fetchNewTopics()
	 *		Fetches topics that have been updated since last_topic_fetch_time
	 *
	 * fetchCategory(category_id)
	 *		Returns category object from master's categories Collections
	 *
	 * fetchOrBuildCategory(category_id)
	 *		Checks categories Collection; if nothing, then builds from database
	 *
	 * fetchCategoryColors(category_id)
	 *		Fetch the colors associated with category <category_id>
	 *
	 * fetchFilteredTopicList(obj)
	 *		Fetch a ComModels.FilteredTopicList or create it if it doesn't exist
	 *
	 * fetchTopicById(topic_id)
	 *		Fetch a topic from the topics collection
	 *
	 * fetchTopicByIdBinary(topic_id, first, last, topics_array)
	 *		Binary search for finding a topic in an array of ComModels.Topic models sorted by topic_id
	 *
	 * fetchItemName(category_id, item)
	 *		Digs out the item_text of an item in a category; assumes category is loaded.
	 *
	 *
	 * checkValidPrivateRecipient(username)
	 * 		See if the submitted username is a valid recipient for this sending user.
	 *
	 *
	 * Constructing Methods
	 *
	 * constructNewCategory (obj)
	 *		Construct ComModels.Category object (or extension) from submitted data
	 *
	 * constructTopicListFilter(obj)
	 *		Constructs a filter for a TopicList
	 *
	 * constructBookmarkCategories ()
	 *		Build bookmark categories from bootstrapped data
	 *
	 *
	 * Other Methods
	 *
	 * processTopicTags (topic)
	 * 		Goes through a topic's tags and adds to categories as needed
	 *
	 * parseBBCode (obj)
	 *		Renders a string in the bbcode parser.
	 *
	 * isBookmarked(item)
	 *		Is this item bookmarked?
	 *
	 *
	 *
	 * Submitting stuff to the database
	 *
	 * submitNewTopic (obj)
	 *		Send a new topic to the database
	 *
	 * submitPost (obj)
	 *		Send a post to the database
	 *
	 *
	 * Triggers
	 *
	 *	category_loaded<category_id>
	 *		Passes ComModels.Category model of the category on
	 *		Initial category load complete for category <category_id>,
	 *
	 */
	ComModels.Master = Backbone.Model.extend({
		defaults: {
			all_past_reported_posts_fetched: false,
			loading_post_reports: false,
			topic_data_loaded: false,
			fullscreen_mode: false,
			topics_loading: false,
			focus_topic: null,
			focus_tag: null,
			topic_lists: {},
			ajax_data_queue: [],
			is_fetching_topics: false,
			is_stretch_class: false,
			watched_users: [],
			my_aops: null,
			my_books: null,
			my_classes: null,
			my_forums: null,
			my_bookmarks: null,
			my_collections: null,
			my_blogs: null,
			monitoring_office_hours: false,
			watched_times_short: [],
			watched_times_long: [],
			last_reported_posts_fetch_time: 0,
			in_change_focus_topic: false,
			private_items_fetched: false, // have the items in the private messages been fetched?
			in_community: false, // Are we in the community pages now?
			is_parsing_bbcode: false, // are we parsing bbcode right now?
		},

		initialize: function () {
			var self = this,
				me_user_model,
				category,
				preloaded_permissions = {},
				portal_collection,
				master_collection;
			// TODO : Error if categories not set on initialization

			AoPS.Community.MasterModel = this;

			AoPS.Community.Constants.moment_offset = moment(
				AoPS.bootstrap_data.server_time
			).diff(new Date());

			this.set(
				"topics",
				new (Backbone.Collection.extend({
					model: ComModels.Topic,
				}))()
			);

			this.set(
				"global_announcements",
				new (Backbone.Collection.extend({
					model: ComModels.Topic,
				}))()
			);
			this.listenTo(
				this.get("global_announcements"),
				"change:announce_type",
				this.onGlobalAnnounceDemote
			);

			this.get("topics").comparator = function (topic) {
				return topic.get("topic_id");
			};

			this.set(
				"users",
				new (Backbone.Collection.extend({
					model: ComModels.User,
				}))()
			);
			this.get("users").comparator = function (user_id) {
				return user_id.get("user_id");
			};

			if (typeof AoPS.bootstrap_data.cmty_status === "string") {
				this.set("cmty_status", AoPS.bootstrap_data.cmty_status);
			} else {
				this.set("cmty_status", "normal");
			}
			this.listenTo(this, "change:cmty_status", this.setIntervals);
			this.setIntervals();

			// Start the timer for the posts and topics that have to be watched.
			/*	setInterval(_.bind(function() {
//				var start = new Date().getTime();
				this.rebuildWatchedTimes('watched_times_short');

			}, this), AoPS.Community.Constants.watched_times_short_interval);

			*/

			this.constructIntervalAjax({
				method: function () {
					self.rebuildWatchedTimes("watched_times_short");
				},
				interval_property: "watched_times_short_interval",
			});

			/*setInterval(_.bind(function() {
//				var start = new Date().getTime();
				this.rebuildWatchedTimes('watched_times_long');

			}, this), AoPS.Community.Constants.watched_times_long_interval);
			*/
			this.constructIntervalAjax({
				method: function () {
					self.rebuildWatchedTimes("watched_times_long");
				},
				interval_property: "watched_times_long_interval",
			});

			// The feed often fetches tag ids for filtering.
			//  This caches the results of those fetches.
			this.set("cached_tag_ids", {});

			this.set(
				"topic_lists",
				new (Backbone.Collection.extend({
					model: ComModels.TopicList,
				}))()
			);

			this.set(
				"categories",
				new (Backbone.Collection.extend({
					model: ComModels.Category,
				}))()
			);

			this.set(
				"priv_categories",
				new (Backbone.Collection.extend({
					model: ComModels.CategoryPriv,
				}))()
			);

			this.set(
				"user_search_categories",
				new (Backbone.Collection.extend({
					model: ComModels.Category,
				}))()
			);

			this.set(
				"search_categories",
				new (Backbone.Collection.extend({
					model: ComModels.CategorySearch,
				}))()
			);

			this.set(
				"last_topic_fetch_time",
				parseInt(AoPS.bootstrap_data.init_time)
			);

			var new_item_check_interval_property = "new_item_check_interval";
			if (this.hasLongNewItemInterval()) {
				new_item_check_interval_property = "new_item_check_interval_long";
			}

			this.constructIntervalAjax({
				interval_property: new_item_check_interval_property,
				method: function () {
					self.fetchNewTopics();
				},
			});

			this.set(
				"last_watcher_fetch_time",
				parseInt(AoPS.bootstrap_data.init_time)
			);

			if (AoPS.bootstrap_data.hasOwnProperty("watcher_hash")) {
				this.set("watcher_hash", AoPS.bootstrap_data.watcher_hash);
			} else {
				this.set("watcher_hash", Math.floor(10000000 * Math.random()));
			}

			this.set(
				"permissions",
				AoPS.bootstrap_data.hasOwnProperty("user_global_cmty_permissions")
					? AoPS.bootstrap_data.user_global_cmty_permissions
					: []
			);

			this.set(
				"staff_permissions",
				AoPS.bootstrap_data.hasOwnProperty("user_staff_perms")
					? AoPS.bootstrap_data.user_staff_perms
					: []
			);

			this.constructIntervalAjax({
				interval_property: "watchers_updates_check_interval",
				method: function () {
					self.fetchWatcherUpdates();
				},
			});

			this.on("change:focus_topic", this.onChangeFocusTopic);

			/**
			 * Get user data, build current_user
			 **/
			if (AoPS.bootstrap_data.hasOwnProperty("my_profile")) {
				AoPS.bootstrap_data.my_profile.master = this;

				me_user_model = new AoPS.Community.Models.User(
					AoPS.bootstrap_data.my_profile
				);
				this.get("users").add(me_user_model);
				this.set("current_user", me_user_model);
				this.set("my_avatar", me_user_model.get("avatar"));
				this.listenTo(me_user_model, "change:base_view", function () {
					self.set("base_view", me_user_model.get("base_view"));
				});
			} else {
				this.set(
					"current_user",
					new AoPS.Community.Models.User({
						user_id: 1,
						username: "Anonymous",
					})
				);
			}

			this.set(
				"ebooks_available",
				AoPS.bootstrap_data.hasOwnProperty("ebooks_available")
					? AoPS.bootstrap_data.ebooks_available
					: []
			);
			this.set(
				"base_view",
				AoPS.bootstrap_data.hasOwnProperty("base_view")
					? AoPS.bootstrap_data.base_view
					: "main"
			);

			/**
			 * Build the bookmark fora before the submitted categories because
			 *  some of the submitted categories may be bookmarked!
			 */
			if (AoPS.session.logged_in_and_initialized) {
				self.set(
					"my_aops",
					self.constructNewCategory({
						category_name: "My AoPS",
						no_more_items: true,
						category_type: "folder",
					})
				);
				this.constructBookmarkCategories();

				/**
					Build the two private message categories,
						my_privates for active messages
						my_privates_archive for archived messages
				**/

				this.set(
					"my_privates",
					this.constructNewCategory(
						_.extend(
							{
								category_type: "my_privates",
								category_name: AoPS.Community.Lang["private-category-name"],
							},
							AoPS.bootstrap_data.my_privates_data
						)
					)
				);

				this.set(
					"my_privates_archive",
					this.constructNewCategory({
						category_type: "my_privates",
						is_archive: true,
						special_url: "/my-messages-archive/",
						add_to_master_collection: false,
						category_status: "archived",
						items: this.get("my_privates").get("items"),
						category_name:
							AoPS.Community.Lang["private-archived-category-name"],
						permissions: this.get("my_privates").get("permissions"),
						can_mark_all_read: false,
					})
				);

				this.set(
					"reported_posts",
					new (Backbone.Collection.extend({
						model: ComModels.PostReport,
					}))()
				);
				this.get("reported_posts").comparator = function (reported_post) {
					return -reported_post.get("inserted_at");
				};
			}

			if (AoPS.Community.hasOwnProperty("categories")) {
				// Add permissions to preload categories before building the categories,
				//  because we need the permissions to build some of the categories
				if (
					AoPS.bootstrap_data.hasOwnProperty("toplevel_category_permissions")
				) {
					_.each(
						_.keys(AoPS.bootstrap_data.toplevel_category_permissions),
						function (category_id) {
							preloaded_permissions[category_id] =
								AoPS.bootstrap_data.toplevel_category_permissions[category_id];
						}
					);
				}

				_.each(AoPS.Community.categories, function (preload_category) {
					var category_id = preload_category.category_id;

					if (preloaded_permissions.hasOwnProperty(category_id)) {
						preload_category.permissions =
							preloaded_permissions[preload_category.category_id];
					}

					self.constructNewCategory(preload_category);
				});

				if (AoPS.bootstrap_data.hasOwnProperty("cmty_toplevel_data")) {
					_.each(
						_.keys(AoPS.bootstrap_data.cmty_toplevel_data),
						function (category_id) {
							var fetched_category = self.fetchCategory(parseInt(category_id));
							if (!_.isUndefined(fetched_category)) {
								fetched_category.set(
									AoPS.bootstrap_data.cmty_toplevel_data[category_id]
								);
							}
						}
					);
				}

				/**
				 * Attach Category models to the toplevel collection's items.
				 **/
				master_collection = this.fetchCategory(Constants.master_category_id);
				if (!_.isUndefined(master_collection)) {
					master_collection.fetchMoreCategoryItems({start_idx: 0});
					master_collection.set("all_subcategories_loaded", true);
				}

				/**
				 * Attach Category models to the toplevel portal's items.
				 **/
				portal_collection = this.fetchCategory(Constants.portal_category_id);
				if (!_.isUndefined(portal_collection)) {
					portal_collection.fetchMoreCategoryItems({start_idx: 0});
					portal_collection.set("all_subcategories_loaded", true);
				}

				category = this.fetchCategory(Constants.aops_forums_id);

				if (!_.isUndefined(category)) {
					/**
					 * Attach extra items to the front of the AoPS Forums folder
					 **/
					if (AoPS.bootstrap_data.hasOwnProperty("extra_aops_items_front")) {
						category.addItemsFront(AoPS.bootstrap_data.extra_aops_items_front);
					}

					/**
					 * Attach extra items to AoPS Forums folder
					 **/
					if (AoPS.bootstrap_data.hasOwnProperty("extra_aops_items")) {
						category.addItems(AoPS.bootstrap_data.extra_aops_items);
					}

					/**
					 * Attach extra folders to the front of the AoPS Forums folder
					 **/
					if (AoPS.bootstrap_data.hasOwnProperty("aops_subfolders")) {
						category.addItemsFront(AoPS.bootstrap_data.aops_subfolders);
					}
				}
			}

			if (AoPS.bootstrap_data.hasOwnProperty("global_announcements")) {
				_.each(
					AoPS.bootstrap_data.global_announcements,
					function (announcement) {
						self.processPotentialNewTopic(announcement, true);
					}
				);
			}

			/**
			 * Go get the categories that have been pre-loaded (if any)
			 **/
			if (AoPS.bootstrap_data.hasOwnProperty("preload_category_data")) {
				if (!Array.isArray(AoPS.bootstrap_data.preload_category_data)) {
					AoPS.bootstrap_data.preload_category_data = [
						AoPS.bootstrap_data.preload_category_data,
					];
				}
				_.each(
					AoPS.bootstrap_data.preload_category_data,
					function (category_data) {
						self.constructNewCategory(category_data);
					}
				);
			}

			if (AoPS.hasOwnProperty("preload_topics")) {
				this.fetchPreloadTopicData();
			}

			if (AoPS.bootstrap_data.hasOwnProperty("cmtystats")) {
				this.set("cmtystats", AoPS.bootstrap_data.cmtystats);
			}

			this.listenTo(
				this,
				"change:fullscreen_mode",
				this.onChangeFullscreenMode
			);

			if (AoPS.bootstrap_data.hasOwnProperty("office_hours_people")) {
				this.resetOfficeHoursPeople(AoPS.bootstrap_data.office_hours_people);
				this.set("monitoring_office_hours", true);
				setTimeout(function () {
					self.fetchOfficeHoursData();
				}, 5000);
			}
		},

		/**
		 * Used to set the intervals at which various polling occurs.
		 *  Part of the Community throttle
		 *
		 * https://github.com/aops/aops3/wiki/Community-Throttle
		 **/
		setIntervals: function () {
			var level = this.get("cmty_status");
			if (typeof Constants.intervals[level] !== "object") {
				// bad level sent
				return;
			}
			_.each(_.keys(Constants.intervals[level]), function (key) {
				Constants.intervals.current[key] = Constants.intervals[level][key];
			});
		},

		/**
		 * Wherever we use the community, we will have a fullscreen_mode.
		 *  Changing that mode needs to apply a class to the body.  The watcher
		 *  has to be somewhere in code that will be executed no matter where/how
		 *  the community is used.  That means it has to live in the master model.
		 **/
		onChangeFullscreenMode: function () {
			switch (this.get("fullscreen_mode")) {
				case "none":
					$("body").removeClass("feed-fullscreen fullscreen");
					break;

				case "feed":
					$("body").addClass("feed-fullscreen fullscreen");
					break;

				case "master":
					$("body").addClass("fullscreen");
					break;
			}
		},

		/**
		 * We preload topics in assets/js/community_topics.js,
		 *  and bootstrap user and time-sensitive data.
		 *
		 * If we decide to put the watchers in community_topics.js, we'll have
		 *  to change the preload_watchers below to check and point at AoPS instead
		 * 	of AoPS.bootstrap_data.
		 **/
		fetchPreloadTopicData: function () {
			var has_is_read = false,
				has_bkmk_data = false,
				has_thanks = false,
				thanks,
				is_read_data,
				bkmk_data,
				delete_time_limit =
					parseInt(AoPS.bootstrap_data.init_time) -
					Constants.time_limit_delete_own,
				self = this,
				watchers,
				has_watchers = false;
			if (AoPS.bootstrap_data.hasOwnProperty("preload_topics_is_read")) {
				has_is_read = true;
				is_read_data = AoPS.bootstrap_data.preload_topics_is_read;
			}

			if (AoPS.bootstrap_data.hasOwnProperty("preload_topics_bkmk_data")) {
				has_bkmk_data = true;
				bkmk_data = AoPS.bootstrap_data.preload_topics_bkmk_data;
			}
			if (AoPS.bootstrap_data.hasOwnProperty("preload_watchers")) {
				has_watchers = true;
				watchers = AoPS.bootstrap_data.preload_watchers;
			}
			if (AoPS.bootstrap_data.hasOwnProperty("preload_topics_thanked")) {
				has_thanks = true;
				thanks = AoPS.bootstrap_data.preload_topics_thanked;
			}

			_.each(_.keys(AoPS.preload_topics), function (category_id) {
				var category, category_permissions;
				category = self.fetchCategory(category_id);
				if (category) {
					category_permissions = category.get("permissions");
				}

				if (category_permissions && category.getPermission("c_can_read")) {
					_.each(AoPS.preload_topics[category_id], function (topic) {
						var topic_id = topic.topic_id;
						topic.permissions = category_permissions;
						if (has_is_read && is_read_data.hasOwnProperty(topic_id)) {
							topic.is_read = is_read_data[topic_id].is_read;
							topic.db_mark_time = is_read_data[topic_id].db_mark_time;
						}
						if (has_watchers && watchers.hasOwnProperty(topic_id)) {
							topic.num_watchers = watchers[topic_id].num_watchers;
							topic.watchers_usernames = watchers[topic_id].watchers_usernames;
							topic.watchers_avatars = watchers[topic_id].watchers_avatars;
							topic.num_named_watchers = watchers[topic_id].num_named_watchers;
						}
						if (has_bkmk_data && bkmk_data.hasOwnProperty(topic_id)) {
							topic.is_bookmarked = true;
							topic.is_watched = bkmk_data[topic_id].e === 1;
							topic.in_feed = bkmk_data[topic_id].f === 1;
						} else {
							topic.is_bookmarked = false;
							topic.is_watched = false;
							topic.in_feed = false;
						}

						// Need num_posts has a unique value in cache;
						//  we need to correct for whether or not the user can undelete the posts.
						topic.num_posts =
							topic.comment_count +
							(category.getPermission("c_can_undelete")
								? topic.num_deleted
								: 0);

						if (
							has_thanks &&
							topic.posts_data &&
							topic.posts_data.length > 0 &&
							thanks.hasOwnProperty(topic.posts_data[0].post_id)
						) {
							if (thanks[topic.posts_data[0].post_id] == 1) {
								topic.posts_data[0].is_thanked = true;
							} else {
								topic.posts_data[0].is_nothanked = true;
							}
						}
						if (
							topic.posts_data &&
							topic.posts_data.length > 0 &&
							AoPS.session.logged_in_and_initialized
						) {
							topic.posts_data[0].editable =
								AoPS.session.user_id === topic.posts_data[0].poster_id;
							topic.posts_data[0].deletable =
								AoPS.session.user_id === topic.posts_data[0].poster_id &&
								topic.posts_data[0].post_time > delete_time_limit;
						}
					});
				}

				self.processPotentialNewTopics(AoPS.preload_topics[category_id], true);
			});
		},

		/**
		 * Construct a function call that operates on some interval.
		 *
		 * @param object
		 *		method function : function that we call periodically
		 *		interval_property string : AoPS.Community.Constants property to consult for interval of the call
		 * 		interval_monitor_model Community.Model of some sort
		 *		interval_id_property string : property of interval_monitor_model to which we save the id
		 **/
		constructIntervalAjax: function (obj) {
			var self = this,
				interval_time,
				interval_id;

			if (
				typeof AoPS.Community.Constants.intervals.current[
					obj.interval_property
				] === "number"
			) {
				interval_time =
					AoPS.Community.Constants.intervals.current[obj.interval_property];
			} else {
				// Fallback in case I miss some in the transition to
				//  Constants.intervals
				interval_time = AoPS.Community.Constants[obj.interval_property];
			}
			interval_id = setTimeout(function () {
				if (AoPS.Community.is_active) {
					obj.method();

					// We don't set this up as an interval so that we can intervene
					//  in the timing of the calls by changing the value
					//  on the interval time in AoPS.Community.Constants.
					//  Could also pull this off by using setInterval keeping track of the
					//  setInterval id for each one.  Ick.
					self.constructIntervalAjax(obj);
				}
			}, interval_time);
			if (obj.hasOwnProperty("interval_id_property")) {
				obj.interval_monitor_model.set(obj.interval_id_property, interval_id);
			}
		},

		/**
		 * Start Triggered Methods
		 */

		/**
		 * onChangeFocusTopic consists of the actions that happens whenever we
		 *  change the focus topic.  We start the realtime monitor on the
		 *  new topic, and stop the realtime monitor and viewing on the old one.
		 *
		 * To force the new topic to have all its posts fetched:
		 *
		 * master.set('focus_topic', <new_topic>, { fetch_all : true });
		 */
		onChangeFocusTopic: function (obj) {
			var suppress_ajax =
					arguments.length > 2 &&
					arguments[2].hasOwnProperty("suppress_ajax") &&
					arguments[2].suppress_ajax,
				new_focus = this.get("focus_topic"),
				old_focus = this.previous("focus_topic");

			if (!_.isNull(old_focus) && !_.isUndefined(old_focus)) {
				old_focus.set("is_master_focus", false);
			}

			if (!_.isNull(new_focus) && !_.isUndefined(new_focus)) {
				new_focus.set("is_master_focus", true);
			}

			// We suppress the ajax call on page loads that are going directly to a topic,
			//  because the topic is preloaded.  In these cases, we just start the monitor and mark the topic read
			if (!suppress_ajax) {
				this.makeChangeFocusTopicAjaxCall({
					new_focus: new_focus,
					previous_focus: old_focus,
					source: "master",
					suppress_ajax: suppress_ajax,
					hash: this.get("watcher_hash"),
					fetch_all:
						arguments[2].hasOwnProperty("fetch_all") && arguments[2].fetch_all,
					tag_id: arguments[2].hasOwnProperty("tag_id")
						? arguments[2].tag_id
						: 0,
					tag_forum_id: arguments[2].hasOwnProperty("tag_forum_id")
						? arguments[2].tag_forum_id
						: 0,
				});
			} else {
				if (!_.isNull(new_focus) && !_.isUndefined(new_focus)) {
					new_focus.startRealtimePostMonitor({
						hash: this.get("watcher_hash"),
						source: "master",
					});
					new_focus.set("is_read", true);
					new_focus.set("is_master_focus", true);
				}
			}
		},

		/**
		 * When the focus topic changes, we let the back end know, and
		 *  then process stuff like what's read, watchers, and get topic updates
		 *  as necessary.
		 *
		 * @param obj
		 *		source : 'master' or 'feed'
		 *		hash : string for keeping track of watchers.
		 *		new_focus : null or ComModels.Topic
		 *		previous_focus : empty or ComModelsTopic
		 **/
		makeChangeFocusTopicAjaxCall: function (obj) {
			var settings = {
					topic_fetch: "none",
				},
				self = this;

			this.set("in_change_focus_topic", true);

			if (!_.isNull(obj.new_focus) && !_.isUndefined(obj.new_focus)) {
				obj.new_focus.set("in_onChangeFocus", true);
				obj.new_focus.startRealtimePostMonitor({
					hash: obj.hash,
					source: obj.source,
				});
				obj.new_focus.set("is_read", true);

				settings.new_topic_id = obj.new_focus.get("topic_id");
				settings.new_category_id = obj.new_focus.get("category_id");
				if (obj.hasOwnProperty("tag_id") && obj.tag_id > 0) {
					settings.focus_tag_id = obj.tag_id;
					settings.focus_tag_forum_id = obj.tag_forum_id;
				}
				//	set_mark : AoPS.session.logged_in ? 1 : 0, ALL parsed on back end now
				//	update_watcher : true,
				//	increment_views : true

				if (
					obj.new_focus.get("posts").length === 0 ||
					(obj.new_focus.get("posts").length === 1 &&
						!obj.new_focus.get("all_posts_fetched")) ||
					(obj.new_focus.get("poll_id") > 0 && !obj.new_focus.has("poll_data"))
				) {
					settings.topic_fetch = "initial";
					settings.fetch_first =
						obj.new_focus.get("posts").length === 0 ? 1 : 0;
					settings.fetch_all =
						obj.hasOwnProperty("fetch_all") && obj.fetch_all ? 1 : 0;
				} else {
					settings.topic_fetch = "update";
					settings.last_post_num = obj.new_focus.fetchLastLoadedPostNumber();
					settings.last_update_time = obj.new_focus.get(
						"last_posts_update_time"
					);
				}

				obj.new_focus.set({
					is_fetching_posts: true,
					is_fetching_past_posts: true,
				});
			} else {
				settings.new_topic_id = 0;
				// settings for not having a  new focus_topic here
			}

			if (!_.isEmpty(obj.previous_focus)) {
				obj.previous_focus.stopRealtimePostMonitor({
					hash: obj.hash,
					source: obj.source,
				});

				/*obj.previous_focus.stopViewing({
					'source' : 'master',
					'hash' : this.get('watcher_hash')
				});*/

				settings.old_topic_id = obj.previous_focus.get("topic_id");
			} else {
				settings.old_topic_id = 0;
				//settings for not having a previous focus
			}

			settings.source = obj.source;
			settings.hash = obj.hash;

			settings.is_office_hours = this.get("monitoring_office_hours") ? 1 : 0;
			/*
			settings.pretty_print = true;
			settings.queries = true;
			settings.profiler = true;
			*/
			// This will be its own function, so that the feed can call it too
			cmty_ajax.add({
				a: "change_focus_topic",
				params: settings,
				source: settings.source,
				main_handler: function (ok, msg) {
					var category;
					var old_topic;
					if (ok) {
						if (settings.new_topic_id > 0) {
							obj.new_focus.set("in_onChangeFocus", true);
							// TODO : Can I wrap this in a function that
							//   both this and mark_is_read can call?
							// Do stuff that comes back for new topic.
							if (msg.response.hasOwnProperty("category_mark_time")) {
								if (obj.new_focus.has("category")) {
									category = obj.new_focus.get("category");
								} else {
									category = obj.new_focus
										.get("master")
										.fetchCategory(obj.new_focus.get("category_id"));
								}
								if (!_.isUndefined(category)) {
									obj.new_focus.set("category", category);
									category.set("mark_time", msg.response.category_mark_time);
								}
							}
							obj.new_focus.set("mark_time", msg.response.topic_mark_time);

							/* This stuff is when we are updating watchers */
							if (msg.response.hasOwnProperty("new_topic_settings")) {
								obj.new_focus.set(msg.response.new_topic_settings);
							}
							if (msg.response.hasOwnProperty("old_topic_settings")) {
								old_topic = obj.new_focus
									.get("master")
									.fetchTopicById(msg.response.old_topic_settings.topic_id);

								if (!_.isNull(old_topic)) {
									old_topic.set(msg.response.old_topic_settings);
								}
							}

							if (settings.topic_fetch === "initial") {
								obj.new_focus.processInitialPostFetch(msg.response);
							} else if (settings.topic_fetch === "update") {
								obj.new_focus.onFinishTopicUpdateAjax(
									msg.response.topic_update_data
								);
							}
							obj.new_focus.trigger("topic_updated");
						} else if (settings.old_topic_id > 0) {
							// Bad name here -- "new_topic_settings" means
							//  settings that are new for this topic, which is the
							//  old topic.  Result of changing where this functionality occurs.
							if (msg.response.hasOwnProperty("new_topic_settings")) {
								obj.previous_focus.set(msg.response.new_topic_settings);
							}
						}
						self.set("in_change_focus_topic", false);
						self.trigger("change_topic_post_finish");
						if (self.get("monitoring_office_hours")) {
							if (msg.response.hasOwnProperty("office_hours_people")) {
								self.resetOfficeHoursPeople(msg.response.office_hours_people);
							}
						}
					} else {
						// If the topic is no longer accessible or has been moved out of the user's reach, nuke it.
						//  The front end will know what to do, because it's smart like that
						if (
							msg.error_code === "E_TOPIC_DELETED" ||
							msg.error_code === "E_NO_SUCH_TOPIC" ||
							msg.error_code === "E_NO_PERMISSION"
						) {
							obj.new_focus.set("deleted", true, {
								error_code: msg.error_code,
							});
							obj.new_focus.destroy();
						}
					}
				},
				extra_handlers: {
					onError: function (data) {
						if (data.error_code === "E_AJAX_CANCEL") {
							if (!_.isNull(obj.new_focus)) {
								obj.new_focus.set({
									is_fetching_posts: false,
									is_fetching_past_posts: false,
								});
							}
						}
					},
				},
			});
		},

		/**
		 * fetchNewTopics gets topics from the server that have been updated
		 *  since 'last_topic_fetch_time'.
		 */
		fetchNewTopics: function () {
			var self = this,
				is_stretch_class = false,
				params;

			params = {
				last_topic_fetch_time: this.get("last_topic_fetch_time"),
				watched_users: JSON.stringify(this.get("watched_users")),
				in_community: this.get("in_community") ? 1 : 0,
			};

			if (
				typeof AoPS.Stretch === "object" &&
				typeof AoPS.Stretch.class_id === "number" &&
				typeof AoPS.Stretch.forum_id === "number" &&
				typeof AoPS.Stretch.lesson === "number"
			) {
				params.stretch_class_id = AoPS.Stretch.class_id;
				params.stretch_lesson = AoPS.Stretch.lesson;
				params.stretch_forum_id = AoPS.Stretch.forum_id;
				is_stretch_class = true;
			}

			/**
			 * If we already have a "fetch_topics" in queue, skip.
			 */
			if (!this.get("is_fetching_topics")) {
				this.set("is_fetching_topics", true);

				cmty_ajax.add({
					a: "fetch_new_topics",
					params: params,
					// If there's something running and two things in the queue, we'll skip this one
					queue_limit: 1,
					never_cancel: true,
					main_handler: function (ok, msg) {
						if (ok && msg.response) {
							/**
							 * If ever we mis-set last_topic_fetch_time, we are hosed.
							 */
							if (
								msg.response.hasOwnProperty("topic_fetch_time") &&
								msg.response.topic_fetch_time >
									parseInt(AoPS.bootstrap_data.init_time)
							) {
								self.set(
									"last_topic_fetch_time",
									msg.response.topic_fetch_time
								);
							}

							if (msg.response.deleted_topics.length > 0) {
								_.each(msg.response.deleted_topics, function (topic_id) {
									var del_topic = self.fetchTopicById(topic_id);

									if (!_.isNull(del_topic)) {
										// First trigger all the stuff that needs to happen on delete.
										del_topic.set("deleted", true);
										// Then wipe the model.
										// This triggers remove events in the collection
										del_topic.destroy();
									}

									/**
										Eh, choosing not to correct category counts realtime to account
											for deleted topics.
									**/
								});
							}

							if (msg.response.moved_topics.length > 0) {
								_.each(msg.response.moved_topics, function (moved_topic) {
									var moved_model = self.fetchTopicById(moved_topic.topic_id),
										moved_to_category = self.fetchCategory(
											moved_topic.category_id
										);

									if (!_.isNull(moved_model)) {
										moved_model.parsePotentialMove(moved_topic);
									}
									/** Yeah, we're gonna missed the moved_from; I can live with that :) */
									if (!_.isUndefined(moved_to_category)) {
										moved_to_category.set({
											num_topics: moved_topic.category_num_topics,
											num_posts: moved_topic.category_num_posts,
											num_users: moved_topic.category_num_users,
										});
									}
								});
							}

							// TODO : See if posts before topics is OK
							if (msg.response.posts.length > 0) {
								_.each(msg.response.posts, function (post) {
									var post_topic = self.fetchTopicById(post.topic_id);

									if (!_.isNull(post_topic)) {
										post_topic.parseEditedPost(post);
									}
								});
							}

							if (msg.response.topics.length > 0) {
								_.each(msg.response.topics, function (topic) {
									var category;
									// var curr_topic;

									category = self.fetchCategory(topic.category_id);

									// This topic's category not loaded; skip it.
									//  We'll get the topic later when we load the
									//  category.
									// Consider removing this.  It's not clear why we need this.
									/*if (_.isUndefined(category)) {
										return;
									}*/
									if (!_.isUndefined(category)) {
										category.set({
											num_topics: topic.category_num_topics,
											num_posts: topic.category_num_posts,
											num_users: topic.category_num_users,
										});
									}
									self.processPotentialNewTopic(topic, true);
									/*curr_topic = this.fetchTopicById(topic.topic_id);

									if (_.isNull(curr_topic)) { // topic is not known to master
										this.get('topics').add(new ComModels.Topic(topic), {
											force_to_active : true
										});
									} else { // Topic is known; update.
										curr_topic.processTopicUpdate(topic);
									}*/
								});
							}

							if (msg.response.category_lock_changes.length > 0) {
								_.each(
									msg.response.category_lock_changes,
									function (changed_cat) {
										var category_id = parseInt(changed_cat.category_id),
											category = self.fetchCategory(category_id),
											state = parseInt(changed_cat.is_locked) == 1;

										if (!_.isUndefined(category)) {
											category.set("is_locked", state);
										}
										self.setTopicsForumLockStatus(category_id, state);
									}
								);
							}

							if (msg.response.hasOwnProperty("cmtystats")) {
								self.set("cmtystats", msg.response.cmtystats);
							}

							self.set("is_fetching_topics", false);

							if (msg.response.hasOwnProperty("deleted_categories")) {
								_.each(msg.response.deleted_categories, function (cat) {
									self.deleteCategory(cat);
								});
							}

							if (
								is_stretch_class &&
								msg.response.hasOwnProperty("stretch_data")
							) {
								self.trigger("stretch_data_returned", {
									data: msg.response.stretch_data,
								});
							}
						} else {
							// TODO : ERROR
						}
					},
				});
			}
		},

		deleteCategory: function (cat) {
			var is_forum =
					cat.category_type === "forum" || cat.category_type === "forum_class",
				category = this.fetchCategory(cat.category_id);
			if (!_.isUndefined(category)) {
				category.set("deleted", true);
				if (category === this.get("focus_category")) {
					// TODO : Blow up gracefully
					AoPS.Ui.Modal.showAlert(Lang["category-deleted"], {
						width: "400px",
						onClose: function () {
							window.location.replace("/community");
							//							Backbone.history.navigate('', {trigger : true});
						},
					});
				}
				category.destroy();
			}

			if (is_forum) {
				this.get("topics").each(function (topic) {
					if (topic.get("category_id") === cat.category_id) {
						topic.set("deleted", true);
						topic.destroy();
					}
				});
			}
		},

		/**
		 * Go get a single topic from the database.
		 *
		 * @param obj
		 * 		topic_id int topic to fetch
		 * 		force_to_active bool
		 * 		add_to_category_id id of category to add this topic to
		 */
		fetchTopicFromDb: function (obj) {
			var force_to_active = obj.hasOwnProperty("force_to_active")
				? obj.force_to_active
				: false;
			var add_to_category_id = obj.hasOwnProperty("add_to_category_id")
				? obj.add_to_category_id
				: null;

			cmty_ajax.add({
				a: "fetch_topic",
				params: {
					topic_id: obj.topic_id,
				},
				main_handler: _.bind(function (ok, msg) {
					var topic;
					if (ok) {
						topic = this.processPotentialNewTopic(
							msg.response.topic,
							force_to_active
						);

						// If these optional parameters were updated, immediately add this topic
						// to the list of active toics in the gien category
						if (force_to_active && add_to_category_id) {
							var category = this.fetchCategory(add_to_category_id);
							if (category) {
								category.get("active_topics").add(topic, {});
							}
						}

						this.trigger("single_topic_load", {
							ok: true,
							topic: topic,
							topic_id: obj.topic_id,
						});
						msg.response.topic = topic;
						msg.response.topic_id = obj.topic_id;
						//double check whether or not the topic got added because of those weird cases where it doesn't, if topic is actually there
						try {
							if (
								Object.keys(this.attributes.focus_topic_list._byId).indexOf(
									topic.cid
								) < 0 &&
								topic
							) {
								this.attributes.focus_topic_list.add(topic);
							}
						} catch (e) {
							//just skip if no good
						}
					} else {
						this.trigger("single_topic_load", {
							ok: false,
							error_code: msg.error_code,
							topic_id: obj.topic_id,
						});
					}
				}, this),
				extra_handlers: obj,
			});
		},

		/**
		 * Given a post ID, go find the topic for this post ID.
		 *
		 * @param object
		 *		post_id int (required)
		 *		onFinish function (optional)
		 **/
		fetchTopicFromDbGivenPostId: function (obj) {
			cmty_ajax.add({
				a: "fetch_topic_from_post",
				params: {
					post_id: obj.post_id,
				},
				never_cancel: true,
				main_hander: _.bind(function (ok, msg) {
					var topic;
					if (ok) {
						topic = this.processPotentialNewTopic(msg.response.topic, false);
						msg.response.topic = topic;
					}
				}, this),
				extra_handlers: obj,
			});
		},

		/**
		 * If we are not in the community or school, then we only want to check for new topics
		 *  frequently if the feed is open.  Otherwise, we want to take our time.
		 **/
		hasLongNewItemInterval: function () {
			return (
				!AoPS.hasOwnProperty("router_root") ||
				(AoPS.router_root !== "community" && AoPS.router_root !== "class")
			);
		},

		onGlobalAnnounceDemote: function (topic) {
			if (topic.get("announce_type") !== "global") {
				this.get("global_announcements").remove(topic);
			}
		},

		/**
		 * Used to immediately update the topics in a cateogry. Must pass in
		 * ids of topics to remove from and/or add to the category.
		 * Bypasses any standard topic add/remove checks to force topic addition.
		 *
		 * Added for Office Hours queue updating.
		 *
		 * @param {int} category_id Category to update
		 * @param {int[]} added_topic_ids Ids of topics to add
		 * @param {int[]} removed_topic_ids Ids of topics to remove
		 */
		updateCategoryTopics: function (
			category_id,
			added_topic_ids,
			removed_topic_ids
		) {
			var focus_topic_list = this.get("focus_topic_list");

			for (var removed_id of removed_topic_ids) {
				var topic = this.fetchTopicById(removed_id);

				if (topic) {
					focus_topic_list.removeTopic(topic);
				}
			}

			for (var added_id of added_topic_ids) {
				this.fetchTopicFromDb({
					topic_id: added_id,
					force_to_active: true,
					add_to_category_id: category_id,
				});
			}
		},

		/**
		 * Set a topic's sort priority. (Added for office hours priority sorting)
		 *
		 * @param {int} topic_id topic id
		 * @param {int} sort_value priority for this topic's sorting. sorted in descending order, so higher
		 * values will show up first in the list.
		 */
		setTopicSortValue: function (topic_id, sort_value) {
			var topic = this.fetchTopicById(topic_id);

			if (topic) {
				topic.set("sort_value", sort_value);
			}
		},

		/**
		 * When we get a topic from the database in a fetchNewTopic or in response to posting a new topic,
		 *  we check if it already exists on the front end.  If so, we process possible edits.  If not,
		 *  we add new topic.
		 *
		 * @param object that can be used to construct a new ComModels.Topic
		 * @param boolean Should this topic be forced into active topics for its category?
		 */
		processPotentialNewTopic: function (topic, force_to_active) {
			var curr_topic = this.fetchTopicById(topic.topic_id);

			if (_.isNull(curr_topic)) {
				// topic is not known to master
				topic.master = this;
				topic = this.checkLoadedTopicPermissions(topic);
				curr_topic = new ComModels.Topic(topic);
				this.get("topics").add(curr_topic, {
					force_to_active: force_to_active,
				});
				if (curr_topic.get("announce_type") === "global") {
					this.get("global_announcements").add(curr_topic);
				}
			} else {
				// Topic is known; update.
				curr_topic.processTopicUpdate(topic);
			}
			return curr_topic;
		},

		/**
		 * Check if a just-loaded topic has permissions; if not, then attach
		 *  from the topic's category on the front end.
		 *
		 * Since we pre-load all the toplevel forum permissions,
		 *	we don't send those forward for topics that are in toplevel forums,
		 * 	and we attach them from their parent categories here.
		 *
		 *	(We don't do this for all topics because sometimes topics are
		 *		loaded before their categories are.)
		 */
		checkLoadedTopicPermissions: function (topic) {
			var category;
			if (!topic.hasOwnProperty("permissions")) {
				category = this.fetchCategory(topic.category_id);
				if (_.isUndefined(category)) {
					console.log(
						"uh-ohh; you are parsing a new topic without permissions, and its category has not been loaded yet."
					);
					console.log("Category id is " + topic.category_id);
				} else {
					topic.permissions = category.get("permissions");
				}
			}
			return topic;
		},
		/**
		 * Go through an array of topics data, calling procesPotentialNewTopic for each
		 *
		 * @param array of objects that can be used to construct a new ComModels.Topic
		 * @param boolean Should this topic be forced into active topics for the corresponding category
		 **/
		processPotentialNewTopics: function (topics, force_to_active) {
			var self = this;
			var topics_models = [];

			_.each(topics, function (topic) {
				topics_models.push(
					self.processPotentialNewTopic(topic, force_to_active)
				);
			});

			return topics_models;
		},

		/**
		 * fetchCategory returns the category object from the master's categories
		 * array.  Use this only if you are sure the category has been created.
		 *
		 * Actually, fine to use otherwise!  Then we know that the category doesn't
		 *  exist up front, and we can ignore any topics that are loaded to it.
		 *
		 * @param category_id: id of category
		 * @return category object.  Returns undefined if hasn't been loaded.
		 */
		fetchCategory: function (category_id) {
			var category_obj = this.get("categories").find(function (cat) {
				return cat.get("category_id") === parseInt(category_id);
			});

			if (_.isUndefined(category_obj)) {
				// TODO : Figure out what to do here.
				//	console.log('Uh-oh; fetchCategory called with bad category_id ' + category_id);
			}
			return category_obj;
		},

		/**
		 * fetchPrivCategory returns the category object from the master's priv_categories
		 * array.
		 *
		 * @param category_id: id of user whose priv_category we want
		 * @return category object.  Returns undefined if hasn't been loaded.
		 */
		fetchPrivCategory: function (user_id) {
			var category_obj = this.get("priv_categories").find(function (cat) {
				return cat.get("user_id") === parseInt(user_id);
			});

			if (_.isUndefined(category_obj)) {
				// TODO : Figure out what to do here.
				//	console.log('Uh-oh; fetchCategory called with bad category_id ' + category_id);
			}
			return category_obj;
		},

		/**
		 * Build a priv category given its user id number.
		 *
		 * @param object
		 *		user_id int required
		 *		onFinish function optional -- what to do at end of ajax call
		 *		onError function optional -- what to do if the ajax call wipes out
		 **/
		buildPrivCategory: function (obj) {
			var self = this,
				category_obj;
			cmty_ajax.add({
				a: "fetch_priv_category_data",
				params: {
					user_id: obj.user_id,
				},
				main_handler: function (ok, msg) {
					if (ok) {
						msg.response.category.visited = true;
						// Fix the line below
						msg.response.category.master = self;
						category_obj = new ComModels.CategoryPriv(msg.response.category);
						self.get("priv_categories").add(category_obj);
						/*self.constructNewCategory(msg.response.category);*/
						msg.response.category = category_obj;
					}
				},
				extra_handlers: obj,
			});
		},

		/**
		 * Build a category given its category id number.
		 *
		 * @param object
		 *		category_id int required
		 *		onFinish function optional -- what to do at end of ajax call
		 *		onError function optional -- what to do if the ajax call wipes out
		 **/
		buildCategory: function (obj) {
			var self = this,
				category_obj;
			cmty_ajax.add({
				a: "fetch_category_data",
				params: {
					category_id: obj.category_id,
				},
				main_handler: function (ok, msg) {
					if (ok) {
						msg.response.category.visited = true;
						category_obj = self.constructNewCategory(msg.response.category);
						msg.response.category = category_obj;
					}
				},
				extra_handlers: obj,
			});
		},

		/**
		 * Build a category given its category id number and fetches
		 *	a tag for the submitted text.  Creates new id if the tag is new.
		 *
		 * @param object
		 *		category_id int required
		 *		tag_text string required
		 *		onFinish function optional -- what to do at end of ajax call
		 *		onError function optional -- what to do if the ajax call wipes out
		 *
		 * The tag id is in msg.response.tag_id; you'll need your handler to
		 *	capture it.
		 **/
		buildCategoryAndTag: function (obj) {
			var self = this,
				category_obj;
			cmty_ajax.add({
				a: "fetch_category_and_tag_data",
				params: {
					category_id: obj.category_id,
					tag_text: obj.tag_text,
				},
				main_handler: function (ok, msg) {
					if (ok) {
						category_obj = self.constructNewCategory(msg.response.category);
						msg.response.category = category_obj;
					}
				},
				extra_handlers: obj,
			});
		},

		/**
		 * Fetch the Id number for a tag.  Creates a new id if the tag does
		 *  not already exist.
		 *
		 * @param object
		 *		tag_text string required
		 *		onFinish function optional -- what to do at end of ajax call
		 *		onError function optional -- what to do if the ajax call wipes out
		 *
		 * The tag id is in msg.response.tag_id on return; you'll need your handler to
		 *	deal with it.
		 **/
		fetchTagId: function (obj) {
			var self = this,
				cache = this.get("cached_tag_ids");

			if (cache.hasOwnProperty(obj.tag_text)) {
				if (typeof obj.onFinish === "function") {
					obj.onFinish({
						tag_id: cache[obj.tag_text],
					});
				}
				return;
			}
			cmty_ajax.add({
				a: "fetch_tag_id",
				params: {
					tag_text: obj.tag_text,
				},
				main_handler: function (ok, msg) {
					if (ok) {
						self.get("cached_tag_ids")[obj.tag_text] = parseInt(
							msg.response.tag_id
						);
					}
				},
				extra_handlers: obj,
			});
		},

		/**
		 * fetchCategoryColors returns the colors for a given category.
		 *
		 * @param category_id
		 * @return {main_color, secondary_color} object with the colors of the category.
		 *   Defaults are #000 and #aaa; we use the defaults if the category is not loaded
		 *   This assumes that all AoPS categories are always loaded with the page, and that
		 *   all other categories are the same color.
		 */
		fetchCategoryColors: function (category_id) {
			var category;
			if (
				category_id === null ||
				_.isUndefined((category = this.fetchCategory(category_id)))
			) {
				return {
					main_color: "#000",
					secondary_color: "#aaa",
				};
			} else {
				return {
					main_color: category.get("main_color"),
					secondary_color: category.get("secondary_color"),
				};
			}
		},

		/**
		 * fetch a FilteredTopicList Model.  This consists of a list of topics that
		 *  results from filtering the master list of topics.  The filtered list updates
		 *  whenever we add more topics to the master list.
		 *
		 * This function must be able to do things:
		 *   (1) Return a FilteredTopicList that was created once before
		 *   (2) Construct such a list if needed.
		 *
		 * So, we need simple, unique identifiers to be able to tell if we have already made the list.
		 *
		 * A list is currently defined by a category_id and an optional array of tag_ids {tag_id, category_id}.
		 *   Given these two parameters, the list includes all topics that are in the
		 *   required category and have at least one of the optional array of identifiers.
		 *   Currently only definitely works if the optional array has at most one element.
		 *
		 *   If the category is a view, then we need to pass the whole category in so that we know
		 *   how to find the topics that are in the view.
		 *   If the category is a forum, then we don't need the category object; we just need its id.
		 *
		 * @param obj: parameters for fetching the list.
		 *     category_id: required -- always need a category_id.
		 *     tag_ids: (optional) array of tag_ids.  Omit, send a blank array, or send [0] to say "no tag filtering"
		 *     category : required
		 *
		 *  TODO: Do we need to pass category_id?  Read from category.
		 */
		fetchFilteredTopicList: function (obj) {
			var filter, topic_list;
			obj = _.defaults(obj, {tag_ids: []});

			topic_list = this.get("topic_lists").find(function (maybe_topic_list) {
				/**
				 * Check if we've already made the list by looking for a maybe_topic_list
				 *  that has the same category_id and set of tag_ids
				 */
				var tag_ids, i;

				// RR changed 'category_id' to 'category' in the line below on 6/13/14
				//  to be able to deal with different private messages.
				if (maybe_topic_list.get("category") != obj.category) {
					return false;
				} else if (obj.tag_ids.length > 0) {
					// we have tag_ids to check
					tag_ids = maybe_topic_list.get("tag_ids");
					if (tag_ids.length != obj.tag_ids.length) {
						return false;
					}
					// check each element, assumes tag_ids ordered same way.
					// This is probably not a great assumption, and will need to
					//  get tightened up in prime time.  Right now, we're only
					//  supporting filtering by a single tag, so these arrays
					//  now have at most one element anyway.
					for (i = 0; i < tag_ids.length; i++) {
						if (
							tag_ids[i].tag_forum_id != obj.tag_ids[i].tag_forum_id ||
							tag_ids[i].tag_id != obj.tag_ids[i].tag_id
						) {
							return false;
						}
					}

					return true;
				} else if (maybe_topic_list.get("tag_ids").length === 0) {
					// Neither the obj nor the maybe_topic_list has tag_ids.
					return true;
				}
				return false;
			});

			if (_.isUndefined(topic_list)) {
				filter = this.constructTopicListFilter({
					category: obj.category,
					tag_ids:
						obj.hasOwnProperty("tag_ids") && obj.tag_ids.length > 0
							? obj.tag_ids
							: [],
				});

				topic_list = new ComModels.TopicList({
					master: this,
					filter: filter,
					tag_ids:
						obj.hasOwnProperty("tag_ids") && obj.tag_ids.length > 0
							? obj.tag_ids
							: [],
					category_id: obj.category_id,
					category: obj.category,
				});

				//only caching lists with nonzero category ids and nonzero user_ids
				// TODO : Why restrict?  Don't seem to be locating by id anymore.
				//		if (obj.category_id !== 0 || obj.user_id) {
				this.get("topic_lists").add(topic_list);
				//		}
			}
			return topic_list.get("filtered_topic_list");
		},

		/***
		 * fetchUser fetches a User model from the users collection
		 *
		 * @param user_ident int|string (user_id or username)
		 * @return ComModels.User object or undefined
		 **/
		fetchUser: function (user_ident) {
			var search_by_id = false;
			if (typeof user_ident === "number" || /^\d+$/.test(user_ident)) {
				search_by_id = true;
			}

			if (search_by_id) {
				return this.get("users").find(function (u) {
					return u.get("user_id") === parseInt(user_ident);
				});
			} else {
				return this.get("users").find(function (u) {
					return u.get("username").toLowerCase() === user_ident.toLowerCase();
				});
			}
		},

		/**
		 * Build a user model by fetching data from the database.
		 *
		 * @param object
		 *		user_identifier string required -- can feed a user_id, username, or (if admin) email
		 *		all ajax handlers can be sent, too
		 **/
		buildUser: function (obj) {
			var self = this;
			cmty_ajax.add({
				a: "fetch_user_profile",
				params: {
					user_identifier: obj.user_identifier,
				},
				main_handler: function (ok, msg) {
					var user_model;
					if (ok) {
						// If we are searching for a user by email address, then we
						//  can't search "users" on the front end.  So, when we get the data
						//  back from the back end, we check if this user is already loaded.
						//  This prevents the users collection from having many copies of a user.
						if (obj.user_identifier.indexOf("@") > -1) {
							user_model = self.fetchUser(msg.response.user_data.user_id);
							if (!_.isUndefined(user_model)) {
								msg.response.user_model = user_model;
								return;
							}
						}
						msg.response.user_data.master = self;
						msg.response.user_model = new AoPS.Community.Models.User(
							msg.response.user_data
						);
						self.get("users").add(msg.response.user_model);
					}
				},
				extra_handlers: obj,
			});
		},

		banAsSpammer: function (obj) {
			cmty_ajax.add({
				a: "ban_as_spammer",
				params: {
					user_id: parseInt(obj.user_id),
					is_troll: obj.is_troll || false,
				},
				main_handler: function (ok, data) {
					if (data.error_msg) {
						AoPS.Ui.Modal.showAlert(data.error_msg);
					}
				},
				extra_handlers: obj,
			});
		},

		handleTempBan: function (obj) {
			cmty_ajax.add({
				a: "handle_temp_ban",
				params: {
					user_id: parseInt(obj.user_id),
					action: obj.action,
					reason: obj.reason,
				},
				main_handler: function (ok, data) {
					if (ok) {
						if (_.isFunction(obj.success)) {
							obj.success(data.response.temp_ban);
						}
					} else if (data.error_msg) {
						AoPS.Ui.Modal.showAlert(data.error_msg);
					}
				},
			});
		},

		checkVPN: function (obj) {
			cmty_ajax.add({
				a: "check_vpn",
				params: {
					ip: obj.ip,
				},
				main_handler: function (ok, msg) {
					if (parseFloat(msg.response.probability) > 0.95) {
						$("[data-ip='" + obj.ip + "']").addClass("is-vpn");
					} else {
						$("[data-ip='" + obj.ip + "']").removeClass("is-vpn");
					}
				},
				extra_handlers: obj,
			});
		},

		submitFriendRequest: function (obj) {
			cmty_ajax.add({
				a: "send_friend_request",
				params: {
					new_friend: obj.new_friend,
				},
				main_handler: function (ok, msg) {
					if (ok) {
						// Nothing to do
					} else {
						// here.  All the action is in the extras.
					}
				},
				extra_handlers: obj,
			});
		},

		/**
		 * fetchTopicByID gets a topic out of the topics collection
		 *
		 * @param topic_id
		 * @return ComModels.Topic object.
		 *
		 * TODO: What if the topic doesn't exist in the collection?
		 */
		fetchTopicById: function (topic_id) {
			var topic_collection = this.get("topics");

			topic_id = parseInt(topic_id);

			if (topic_collection.length === 0) {
				return null;
			}

			return this.fetchTopicByIdBinary(
				topic_id,
				0,
				topic_collection.length - 1,
				topic_collection.models
			);
		},

		/**
		 * fetchTopicByIdBinary performs a binary search of an array of ComModels.Topic for
		 *   a given topic_id.
		 *
		 * @param topic_id
		 * @param first : index of first place to start search
		 * @param last : index of last
		 * @param topics_array : array of ComModels.Topic
		 */
		fetchTopicByIdBinary: function (topic_id, first, last, topics) {
			var mid, mid_id;
			if (last < first) {
				return null;
			}
			mid = Math.floor((first + last) / 2);
			mid_id = topics[mid].get("topic_id");
			if (topic_id < mid_id) {
				return this.fetchTopicByIdBinary(topic_id, first, mid - 1, topics);
			} else if (topic_id > mid_id) {
				return this.fetchTopicByIdBinary(topic_id, mid + 1, last, topics);
			} else {
				return topics[mid];
			}
		},

		/**
		 * fetchItemName returns the item name given the category_id of the category and the item (optional).
		 *  Assumes that the category is loaded, and that the item has been
		 *  added to the category (or to its forum if the item is a tag).
		 * Right now, this is only used for getting the name of the focus tag when we head down a new route.
		 * @param int category_id
		 * @param obj {item_id, item_forum_id, item_type}
		 *
		 * TODO : Consider passing category instead of category_id?
		 */
		fetchItemName: function (category_id, item) {
			var category = this.fetchCategory(category_id),
				fetched_item = category.fetchItem(item);

			// If the item isn't in the category, then we look to the forum_id
			//  for the item to get its text.  This will happen
			//  when we are in a view and click a tag on a post that is not
			//  part of that view.  That tag will exist in the forum's item
			//  space, so we can get the name there.
			if (_.isUndefined(fetched_item)) {
				category = self.fetchCategory(item.item_forum_id);
				fetched_item = category.fetchItem(item);
			}
			return fetched_item.item_text;
		},

		/**
		 * Fetch the items (tags) for the private messages and the archive.
		 *  They share the same tagcloud.
		 * @param obj optional object
		 *		onFinish : what to do after finished.
		 **/
		fetchPrivateItems: function (obj) {
			var privates = this.get("my_privates"),
				self = this,
				privates_archive = this.get("my_privates_archive");

			privates.fetchMoreItems({
				onFinish: function () {
					self.set("private_items_fetched", true);
					privates_archive.set("items", privates.get("items"));
					if (obj.hasOwnProperty("onFinish")) {
						obj.onFinish();
					}
				},
			});
		},

		/**
		 * Check if the inputted string is a valid username.
		 * Ajax returns object
		 *		is_valid_recipient boolean
		 *		is_admin 0|1
		 *		user_id 0|valid user id
		 *
		 * @param obj
		 *		username string
		 *		onFinish/onError
		 */
		checkValidPrivateRecipient: function (obj) {
			cmty_ajax.add({
				a: "check_valid_private_recipient",
				params: {
					username: obj.username,
				},
				main_handler: function (ok, msg) {}, //all the action is passed in
				extra_handlers: obj,
			});
		},

		/**
		 * constructNewCategory makes a new category model.
		 *  The model prototype depends on the category_type that is submitted.
		 *  The object category_init_data is passed to the constructor for the category.
		 *
		 * @param category_init_data: object to use in category construction
		 *		include add_to_master_collection : false to prevent adding the category to
		 *		the master collection of categories
		 * @return model for the category if success, null if fail.
		 */
		constructNewCategory: function (category_init_data) {
			var category_model,
				add_to_master_collection = true;

			if (category_init_data.hasOwnProperty("add_to_master_collection")) {
				if (!category_init_data.add_to_master_collection) {
					add_to_master_collection = false;
				}
				delete category_init_data.add_to_master_collection;
			}

			category_model = this.constructTemporaryCategory(category_init_data);

			if (!_.isNull(category_model) && add_to_master_collection) {
				this.get("categories").add(category_model);
			}

			return category_model;
		},

		fetchUserSearchCategory: function (user_id) {
			var category = this.get("user_search_categories").findWhere({
				user_id: user_id,
			});

			if (_.isUndefined(category)) {
				category = this.constructTemporaryCategory({
					category_type: "user_search_posts",
					user_id: user_id,
				});
			}

			this.get("user_search_categories").add(category);
			return category;
		},

		validateSearchInput: function (obj) {
			cmty_ajax.add({
				a: "validate_search_input",
				params: {
					username: obj.username,
					forum: obj.forum,
				},
				main_handler: function (ok, msg) {
					// ALL the action is in the extras
				},
				extra_handlers: obj,
			});
		},

		fetchSearchCategory: function (search_id) {
			var category;

			category = this.get("search_categories").findWhere({
				search_id: search_id,
			});
			return category;
		},

		buildSearchCategory: function (obj) {
			var category,
				settings = {
					category_type: "search",
					master: this,
					search_settings: obj,
				};
			category = this.constructTemporaryCategory(settings);
			this.get("search_categories").add(category);
			return category;
		},

		/**
		 * Build a category, but don't add it to the categories collection,
		 *  so it won't be found in a "fetchCategory".
		 **/
		constructTemporaryCategory: function (category_init_data) {
			var category_constructor, category_model;

			if (category_init_data.hasOwnProperty("category_type")) {
				switch (category_init_data.category_type) {
					case "view_topics":
						category_constructor = ComModels.CategoryViewTopics;
						break;

					case "feed_topics":
						category_constructor = ComModels.CategoryFeedTopics;
						break;

					case "bookmark_topics":
						category_constructor = ComModels.CategoryBookmarkTopics;
						break;

					case "view_tags":
						category_constructor = ComModels.CategoryViewTags;
						break;

					case "bookmark_tags":
						category_constructor = ComModels.CategoryBookmarkTags;
						break;

					case "view_forums":
						category_constructor = ComModels.CategoryViewForums;
						break;

					case "bookmark_forums":
						category_constructor = ComModels.CategoryBookmarkForums;
						break;

					case "forum":
					case "forum_class":
						category_constructor = ComModels.CategoryForum;
						break;

					case "my_privates":
					case "my_privates_archive":
						category_constructor = ComModels.CategoryPrivates;
						break;

					case "user_search_topics":
						category_constructor = ComModels.CategoryUsersTopics;
						break;

					case "user_search_posts":
						category_constructor = ComModels.CategoryUsersPosts;
						break;

					case "search":
						category_constructor = ComModels.CategorySearch;
						break;

					case "blog":
						category_constructor = ComModels.CategoryBlog;
						break;

					case "my_forums":
						category_constructor = ComModels.CategoryMyForums;
						break;

					case "my_blogs":
						category_constructor = ComModels.CategoryMyBlogs;
						break;

					case "my_collections":
						category_constructor = ComModels.CategoryMyCollections;
						break;

					case "my_bookmarks":
						category_constructor = ComModels.CategoryMyBookmarks;
						break;

					case "view_posts":
						category_constructor = ComModels.CategoryViewPosts;
						break;

					case "user":
						category_constructor = ComModels.CategoryUser;
						break;

					default:
						category_constructor = ComModels.Category;
						break;
				}

				category_model = new category_constructor(
					_.defaults(category_init_data, {
						master: this,
					})
				);

				return category_model;
			} else {
				console.log(
					"You tried to build a new category without a category_type."
				);
				console.log(
					'Type "HERE COMES AN ERROR" assumed.  Your wish is my command.'
				);
				console.log(category_init_data);
			}

			return null;
		},

		/**
		 * constructTopicListFilter returns a function that is used to filter topics by
		 *  a set of parameters as described by the input object
		 * @param obj : {category (required), tag_ids (optional)}
		 * @return function
		 *
		 * Logic:
		 *  If obj.tag_ids is set, then only topics that have all of the ids in the tag_ids array may pass.
		 *     (The obj.tag_ids consists of objects with {tag_id, category_id}.)
		 *  We then check if the topic passes the category's filter.
		 *
		 */
		constructTopicListFilter: function (obj_to_fill) {
			// TODO : Check the order of these tests; may want to reverse it.
			return _.partial(function (obj, topic) {
				var i, max;
				/**
				 * If we are filtering by tag_ids, we want only those objects
				 * with those tag_ids.
				 */
				if (obj.hasOwnProperty("tag_ids")) {
					if ((max = obj.tag_ids.length) > 0 && obj.tag_ids[0].tag_id != 0) {
						for (i = 0; i < max; i++) {
							if (
								topic.get("category_id") != obj.tag_ids[i].tag_forum_id ||
								!topic.hasTag(obj.tag_ids[i].tag_id)
							) {
								return false;
							}
						}
					}
				}
				/**
				 * Now check if the topic is in this category.
				 */
				if (!obj.category.filterTopic(topic)) {
					return false;
				}
				// More tests here.
				return true;
			}, obj_to_fill);
		},

		/**
		 * Build the bookmark categories from the bootstrapped data.
		 */
		/**
		 Notes for building the feed.  I think we can do so here.  We build filters
		 of the bookmarked categories for the feed.  Hopefully this will be
		 straightforward.  Construct the filters here, then build the FilteredLists,
		 so these will be available to the feed.

		 **/
		constructBookmarkCategories: function () {
			var self = this;

			if (AoPS.session.logged_in_and_initialized) {
				if (AoPS.bootstrap_data.hasOwnProperty("feed_fora")) {
					_.each(AoPS.bootstrap_data.feed_fora, function (feed_forum) {
						var category,
							type = feed_forum.category_type;

						/** Back end loads all items for the bookmarks **/
						feed_forum.no_more_items = true;

						category = self.constructNewCategory(feed_forum);
						switch (type) {
							case "bookmark_topics":
								self.set("bookmarked_topic_category", category);
								break;

							case "bookmark_tags":
								self.set("bookmarked_tag_category", category);

								break;

							case "bookmark_forums":
								self.set("bookmarked_forum_category", category);
								break;
						}
					});
				}
			}
		},

		/**
		 * processTopicTags adds a topic's tags to its categories tags array if those
		 *  tags do not already exist.
		 * Assumes that this will only be called for topics in categories that have been built.
		 *  That is, we only call this for topics that we fully load (we are assuming here
		 *   that we will only display the tag cloud for topics that are themselves being loaded;
		 *   if that changes, then we will have to build category objects for every topic that
		 *   loads.  That's not such a big deal, and we should probably do it anyway.
		 *   We'll deal with that when we build the topic loader.)
		 *
		 * @param topic: ComModels.Topic object
		 *
		 * This is needed because loading a category from the database will only load
		 *  a subset of its tags.  As we encounter other tags on topics, we want to add
		 *  them to those we know in a category, since the user might click on them, so
		 *  we'll want to know that tag as an object to filter by.
		 *
		 * One example of why we want this occurs when the user clicks on a tag, the next
		 *  route knows only that tag's ID number and forum_id.  It doesn't know the tag's text,
		 *  so we have to go get the text from the tag's category.  (There are other ways around
		 *  this issue, but they're clunky and inelegant.)
		 *
		 * Another reason I want this is that once I see a tag somewhere, I expect to be able to find that
		 *  tag again in a list of a forum's tags.  This will make the tag appear in the forum's
		 *  tag cloud hereafter on this visit to the site.
		 *
		 */
		processTopicTags: function (topic) {
			if (topic) {
				var category, category_tags, category_id, i, max;

				if (topic.get("tags_processed")) {
					return;
				}

				topic.set("tags_processed", true);

				category = this.fetchCategory(topic.get("category_id"));
				/**
				 * Check if this category has been loaded yet.  If not, then we don't have to fret about its tags.
				 **/
				if (_.isUndefined(category)) {
					return;
				}
				category_tags = category.get("items");
				category_id = category.get("category_id");

				/**
				 * For each tag, check if we have already added that tag to the category.
				 *  If so, move on.  If not, add the tag to the category's items array.
				 */
				_.each(topic.get("tags"), function (tag) {
					max = category_tags.length;
					if (tag.hasOwnProperty("is_visible") && !tag.is_visible) {
						return;
					}
					for (i = 0; i < max; i++) {
						if (category_tags[i].item_id === tag.tag_id) {
							return;
						}
					}
					category_tags.push({
						item_id: tag.tag_id,
						item_text: tag.tag_text,
						item_forum_id: category_id,
						item_type: "tag",
						item_main_color: category.get("main_color"),
						item_secondary_color: category.get("secondary_color"),
					});
				});
			}
		},

		/**
		 * parseBBcode renders a string that is sent for parsing.
		 *
		 * @param obj:
		 *     text : text to be parsed
		 *     onFinish : what to do with the result.
		 *			{rendered_text : <bbcode rendered text>} sent to function
		 *	   onError function
		 *
		 */
		parseBBCode: function (obj) {
			var self = this;

			if (this.get("is_parsing_bbcode")) {
				return;
			}

			this.set("is_parsing_bbcode", true);
			cmty_ajax.add({
				a: "parse_post",
				params: {
					text: obj.text,
					post_format: obj.post_format,
				},
				main_handler: _.bind(function (ok, msg) {
					self.set("is_parsing_bbcode", false);
				}, this),
				extra_handlers: obj,
			});
		},

		/**
		 * Check if this item is bookmarked.
		 *
		 * @param object {item_id int, item_forum_id int, item_type}
		 * @return boolean
		 */
		isBookmarked: function (item) {
			var bookmark_category;

			switch (item.item_type) {
				case "tag":
					bookmark_category = "bookmarked_tag_category";
					break;

				case "topic":
					bookmark_category = "bookmarked_topic_category";
					break;

				case "forum":
				case "forum_class":
					bookmark_category = "bookmarked_forum_category";
					break;
			}

			if (this.has(bookmark_category)) {
				return this.get(bookmark_category).hasItem(item);
			} else {
				return false;
			}
		},

		fetchBookmarkStatus: function (item) {
			var bookmarked_item, bookmark_category;

			// No bookmarks for guests or uninitialized users
			if (!AoPS.session.logged_in_and_initialized) {
				return {
					is_bookmarked: false,
					in_feed: false,
					is_watched: false,
				};
			}
			switch (item.item_type) {
				case "tag":
					bookmark_category = "bookmarked_tag_category";
					break;

				case "topic":
					bookmark_category = "bookmarked_topic_category";
					break;

				case "forum":
				case "forum_class":
					bookmark_category = "bookmarked_forum_category";
					break;
			}

			if (this.has(bookmark_category)) {
				bookmarked_item = this.get(bookmark_category).fetchItem(item);

				return _.isUndefined(bookmarked_item)
					? {
							is_bookmarked: false,
							in_feed: false,
							is_watched: false,
						}
					: {
							is_bookmarked: true,
							in_feed: bookmarked_item.in_feed == 1,
							is_watched: bookmarked_item.is_watched == 1,
						};
			} else {
				return false;
			}
		},

		/**
		 * Add a tag bookmark
		 *
		 * @param object
		 *		item object (Itembox item with settings attached)
		 *		onError function optional.
		 **/
		addTagBookmark: function (obj) {
			if (!this.has("bookmarked_tag_category")) {
				return;
			}

			this.get("bookmarked_tag_category").addItem(obj.item);
			this.get("bookmarked_tag_category").addItemDb({
				item: obj.item,
				add_to_client: false,
				onError: obj.hasOwnProperty("onError") ? obj.onError : function () {},
			});
		},

		removeTagBookmark: function (tag) {
			if (!this.has("bookmarked_tag_category")) {
				return;
			}
			this.get("bookmarked_tag_category").removeItem(tag);
			this.get("bookmarked_tag_category").removeItemDb({
				item: tag,
				remove_from_client: false,
			});
		},

		/**
		 * submitNewTopic sends a topic to the database.  Currently assumes that
		 *  whoever is currently logged in is the poster.
		 *
		 * @param obj: object with following parameters:
		 *       category_id : where we are posting this puppy.
		 *		 source : string
		 *		 allow_latex_errors boolean : true to render them in red rather than error
		 *       title : title of the topic
		 *       tags : array of tags for the topic
		 *       post_text : text of the first post, unrendered
		 *
		 */
		submitNewTopic: function (obj) {
			var bookmark_feed = parseExtraOption("bookmark_feed"),
				notify_email = parseExtraOption("notify_email");
			function parseExtraOption(option) {
				return obj.hasOwnProperty(option) && obj[option] ? 1 : 0;
			}

			cmty_ajax.add({
				a: "submit_new_topic",
				params: {
					/*pretty_print : true,
					queries : true,
					profiler : true,*/
					category_id: obj.category_id,
					title: obj.title,
					tags: JSON.stringify(obj.tags),
					linked_tag: obj.linked_tag,
					target_url: obj.target_url,
					target_url_application: obj.target_url_application,
					target_text: obj.target_text,
					source: obj.source,
					post_as_halp: obj.post_as_halp ? 1 : 0,
					pm_as_sheriff: obj.pm_as_sheriff ? 1 : 0,
					allow_latex_errors: obj.allow_latex_errors ? 1 : 0,
					hidden_tags: JSON.stringify(obj.hidden_tags),
					restricted_tags: JSON.stringify(obj.restricted_tags),
					removed_autotags: JSON.stringify(obj.removed_autotags),
					post_text: obj.post_text,
					notify_email: notify_email,
					attachments: JSON.stringify(obj.attachments),
					has_poll: obj.has_poll,
					problem_text: JSON.stringify(obj.problem_text),
					poll_data:
						obj.has_poll === 1
							? JSON.stringify(obj.poll_data)
							: JSON.stringify({}),
					recipients: JSON.stringify(obj.recipients),
					disable_bbcode: parseExtraOption("disable_bbcode"),
					is_local_announcement: parseExtraOption("is_local_announcement"),
					is_global_announcement: parseExtraOption("is_global_announcement"),
					announce_through: obj.hasOwnProperty("announce_through")
						? obj.announce_through
						: "",
				},
				main_handler: _.bind(function (ok, msg) {
					var topic, category;
					if (ok) {
						topic = this.processPotentialNewTopic(msg.response.topic, true);
						if (topic.get("topic_type") !== "blog_post") {
							if (notify_email === 1 || bookmark_feed === 1) {
								topic.setBookmarkState({
									is_bookmarked: true,
									in_feed: bookmark_feed === 1,
									is_watched: notify_email === 1,
								});
							}
						}
						category = this.fetchCategory(topic.get("category_id"));
						if (!_.isUndefined(category)) {
							_.each(topic.get("tags"), function (tag) {
								if (tag.is_visible) {
									category.addTag(tag);
								}
							});
							category.set({
								num_topics: msg.response.topic.category_num_topics,
								num_posts: msg.response.topic.category_num_posts,
								num_users: msg.response.topic.category_num_users,
							});
							AoPS.Community.MasterModel.trigger(
								"this_user_posted_in_community",
								{
									new_topic: true,
									data: msg.response,
									topic_id: topic.get("topic_id"),
								}
							);
						}
						msg.response.topic_model = topic;
					}
				}, this),
				extra_handlers: obj,
				extra_ajax_runner_options: {
					timeout: AoPS.Community.Constants.posting_ajax_timeout,
					queue_at_front: true,
				},
			});
		},

		/**
		 * submitPost sends a post to the database.
		 *
		 * @param obj with the following parameters:
		 *		category_id : forum_id of the topic that we're posting to
		 *		post_text : text of the post
		 *		allow_latex_errors boolean : true to render them in red rather than error
		 *      topic_id : topic_id of the topic
		 *		topic : ComModels.Topic of the topic
		 *
		 *
		 * TODO: Is it enough to send the ComModels.Topic; why bother with category_id
		 *   and topic_id?
		 */
		submitPost: function (obj) {
			var bookmark_feed = parseExtraOption("bookmark_feed"),
				reset_bookmark_state = false,
				notify_email = parseExtraOption("notify_email");

			function parseExtraOption(option) {
				return obj.hasOwnProperty(option) && obj[option] ? 1 : 0;
			}

			if (
				typeof obj.bookmark_feed === "boolean" ||
				typeof obj.notify_email === "boolean"
			) {
				if (
					bookmark_feed != (obj.topic.get("in_feed") ? 1 : 0) ||
					notify_email != (obj.topic.get("is_watched") ? 1 : 0)
				) {
					reset_bookmark_state = true;
				}
			}

			cmty_ajax.add({
				a: "submit_post",
				params: {
					/*pretty_print : true,
					queries : true,
					profiler : true,*/
					attachments: JSON.stringify(obj.attachments),
					post_text: obj.post_text,
					notify_email: notify_email,
					topic_id: obj.topic_id,
					allow_latex_errors:
						obj.hasOwnProperty("allow_latex_errors") && obj.allow_latex_errors
							? 1
							: 0,
					last_post_num: obj.topic.fetchLastLoadedPostNumber(),
					last_update_time: obj.topic.get("last_update_time"),
					disable_bbcode: parseExtraOption("disable_bbcode"),
					is_announcement: parseExtraOption("is_announcement"),
				},
				main_handler: _.bind(function (ok, msg) {
					if (ok) {
						if (
							msg.response.hasOwnProperty("new_data") &&
							msg.response.new_data
						) {
							obj.topic.processTopicUpdate(msg.response);
							obj.topic.trigger("new_post_processed", {
								post_id: msg.response.posts_data[0].post_id,
							});
						}

						AoPS.Community.MasterModel.trigger(
							"this_user_posted_in_community",
							{
								new_topic: false,
								data: msg.response,
								topic_id: obj.topic_id,
							}
						);
						if (reset_bookmark_state) {
							obj.topic.resetBookmarkState({
								is_bookmarked: true,
								in_feed: bookmark_feed === 1,
								is_watched: notify_email === 1,
							});
						}
					}
				}, this),
				extra_handlers: obj,
				extra_ajax_runner_options: {
					timeout: AoPS.Community.Constants.posting_ajax_timeout,
					queue_at_front: true,
				},
			});
		},

		fetchMyAopsCategory: function (obj) {
			var self = this;

			cmty_ajax.add({
				a: "fetch_my_aops_category",
				params: {
					/*pretty_print : true,
					queries : true,
					profiler : true,*/
					category: obj.category,
				},
				main_handler: function (ok, msg) {
					var category_model,
						new_category = false,
						category_items;
					if (ok) {
						category_model = self.constructNewCategory(
							msg.response.category_data.category
						);
						self.set(obj.category, category_model);
						if (msg.response.category_data.hasOwnProperty("items_categories")) {
							category_items = category_model.get("items");
							_.each(
								msg.response.category_data.items_categories,
								function (cat_obj) {
									var item_category, add_to_item;

									if (cat_obj.category_id > 0) {
										item_category = self.fetchCategory(cat_obj.category_id);
										if (_.isUndefined(item_category)) {
											item_category = self.constructNewCategory(cat_obj);
											new_category = true;
										}
									} else {
										item_category = self.constructNewCategory(cat_obj);
									}

									add_to_item = _.findWhere(category_items, {
										item_id: cat_obj.category_id,
									});

									if (!_.isUndefined(add_to_item) && !new_category) {
										// This should never fail.
										// Takes care of blogs and topic views.
										//  TODO : Add to master's topics if we ever need realtime update
										//   of blog topics outside the blog.
										if (
											cat_obj.hasOwnProperty("topics_data") &&
											item_category.get("category_type") !== "blog"
										) {
											//
											/*_.each(cat_obj.topics_data, function (topic) {
											if (!topic.hasOwnProperty('permissions')) {
												topic.permissions = item_category.get('permissions');
											}
										});*/
											item_category
												.get("active_topics")
												.add(
													self.processPotentialNewTopics(
														cat_obj.topics_data,
														false
													)
												);
											if (cat_obj.all_topics_loaded) {
												item_category.set(
													"all_topics_loaded",
													cat_obj.all_topics_loaded
												);
											}
										}

										add_to_item.category = item_category;
									}
								}
							);
						}
						msg.response.constructed_category = category_model;
					} else {
					}
				},
				extra_handlers: obj,
			});
		},

		/** Start Watched Times **/

		/**
		 * Check if a given time setting should be added to one of the watched_time
		 *  arrays that tracks times that need to update in realtime.
		 *
		 * @param obj
		 *		time_data obj
		 *			model : Backbone Model we are tracking.
		 *			int_time_field string: field that has time as an int.
		 *			rendered_time_field string: field of rendered time that we update
		 *						if we are watching it.
		 *		is_already_watched boolean that tells us if we're already watching this on
		 * @return boolean : did we add this to one of the lists?
		 **/
		checkAddToWatchTimes: function (obj) {
			var now = parseInt(moment().format("X")),
				data = obj.time_data;

			if (
				now - data.model.get(data.int_time_field) <
				AoPS.Community.Constants.time_limits.watched_times_long
			) {
				if (obj.is_already_watched) {
					this.updateLocationOnWatchedTimes(data);
				} else {
					this.addToWatchedTimes(data);
				}
				return true;
			}
			return false;
		},

		/**
		 * Add a time setting to one of the watched_times arrays.
		 *
		 * @param obj:
		 *		model : Backbone Model we are tracking.
		 *		int_time_field string: field that has time as an int.
		 *		rendered_time_field string: field of rendered time that we update
		 *						if we are watching it.
		 **/
		addToWatchedTimes: function (obj) {
			var now = parseInt(moment().format("X")),
				short_cutoff = AoPS.Community.Constants.time_limits.watched_times_short;
			if (now - obj.model.get(obj.int_time_field) < short_cutoff) {
				this.get("watched_times_short").push(obj);
			} else {
				this.get("watched_times_long").push(obj);
			}
		},

		/**
		 * We're adding a time that was added earlier.  We don't want to add
		 *  it to the same list twice.
		 *
		 * Assumes we are
		 *
		 * @param obj:
		 *		model : Backbone Model we are tracking.
		 *		int_time_field string: field that has time as an int.
		 *		rendered_time_field string: field of rendered time that we update
		 *						if we are watching it.
		 **/
		updateLocationOnWatchedTimes: function (obj) {
			var now = parseInt(moment().format("X")),
				list_to_add,
				list_to_remove,
				short_cutoff = AoPS.Community.Constants.time_limits.watched_times_short;

			// TODO : Time profile this function.
			if (now - obj.model.get(obj.int_time_field) < short_cutoff) {
				list_to_add = "watched_times_short";
				list_to_remove = "watched_times_long";
				// Choosing not to care if a time is on both short and long lists.
				//  Just don't want it on the short list twice.
			} else {
				list_to_add = "watched_times_long";
				list_to_remove = "watched_times_long";
			}
			if (_.isUndefined(_.findWhere(this.get(list_to_add), obj))) {
				this.get(list_to_add).push(obj);
				this.set(list_to_remove, _.without(this.get(list_to_remove), obj));
			} else {
				// Yay!  We didn't add the object twice.  Here is where you'll
				//  put console.log statements to test that.
			}
		},

		/**
		 * Set rendered times of topics and posts that are on the timer.
		 **/
		rebuildWatchedTimes: function (list) {
			var shorten_from_now_time = false;
			// TODO; fix below.
			if (
				this.get(list).length >
				AoPS.Community.Constants.max_times_to_watch[list]
			) {
				shorten_from_now_time = true;
				AoPS.Community.Constants.time_limits[list] = Math.floor(
					0.7 * AoPS.Community.Constants.time_limits[list]
				);
			}
			_.each(this.get(list), function (watched_time) {
				watched_time.model.set(
					watched_time.rendered_time_field,
					AoPS.Community.Utils.makePrettyTime(
						watched_time.model.get(watched_time.int_time_field)
					)
				);
			});

			if (shorten_from_now_time) {
				this.filteredWatchedTimes(list);
			}
		},

		/**
		 * Filter the watched times removes watched times that have moved outside the
		 *  window during which their times are computed relative to now.
		 **/
		filteredWatchedTimes: function (list) {
			var cutoff =
					parseInt(moment().format("X")) -
					AoPS.Community.Constants.time_limits[list],
				removed_watch_times = [];

			// The -5 is a little slop that makes sure we don't
			//  drop something from the collection that just had its
			//  time rendered as relative.  That would be bad.
			_.each(this.get(list), function (watched_time) {
				if (watched_time.model.get(watched_time.int_time_field) <= cutoff - 5) {
					removed_watch_times.push(watched_time);
				}
			});

			this.set(list, _.without(this.get(list), removed_watch_times));

			// If we are curtailing the short times list, then we need to tack on
			//  the removed ones to the long list.
			//   Next time the long list rebuilder fires,  we'll probably curtail that, too...
			if (list === "watched_times_short") {
				this.set(
					"watched_times_long",
					this.get("watched_times_long").concat(removed_watch_times)
				);
			}

			// Perhaps todo someday if we're really ambitious : go back to original
			//  models and tell them that the time isn't on the list anymore for removed items.
			//  Trouble there is that Post models have two different times being watched.

			//TODO : take an afternoon and test this filtering
		},

		/**
		 * Fetch updates of all of the watcher data.
		 *
		 * We set queue_limit to -1, so we only fetch this data if there are no other
		 *		Ajax calls currently happening.
		 */
		fetchWatcherUpdates: function () {
			var self = this;

			cmty_ajax.add({
				a: "fetch_watcher_changes",
				params: {
					last_watcher_fetch_time: this.get("last_watcher_fetch_time"),
				},
				main_handler: function (ok, msg) {
					if (ok) {
						self.set("last_watcher_fetch_time", msg.response.watch_time);
						_.each(msg.response.watcher_data, function (topic) {
							var topic_model = self.fetchTopicById(topic.topic_id);

							if (!_.isNull(topic_model)) {
								topic_model.set(topic);
							}
						});
					} else {
					}
				},
				queue_limit: -1,
			});
		},

		/**
		 * Set the bookmark state of a topic or a forum.
		 *
		 * @param obj
		 *		category_string string of property of master for the bookmark category
		 *		bookmarked_item ComModels.CategoryForum or Topic
		 *		item_id int
		 *		item_type string forum or topic
		 *		item_text string
		 */
		setBookmarkState: function (obj) {
			// Must use the new state for adds, and the old state for removes.
			var item_state_for_processing,
				submit_item_obj,
				topic,
				bookmark_category = this.get(obj.category_string),
				new_state;
			obj = _.defaults(obj, {
				item_main_color: "",
				item_secondary_color: "",
				item_subtitle: "",
			});

			if (!this.has(obj.category_string)) {
				return false; // This shouldn't ever happen
			}
			if (!obj.state.is_bookmarked) {
				item_state_for_processing = {
					is_watched: obj.bookmarked_item.get("is_watched"),
					in_feed: obj.bookmarked_item.get("in_feed"),
				};
				new_state = {
					is_bookmarked: false,
					in_feed: false,
					is_watched: false,
				};
			} else {
				item_state_for_processing = obj.state;
				new_state = obj.state;
			}
			obj.bookmarked_item.set(new_state);

			/***
			 * If we are changing the bookmark status of a topic,
			 *  we remove it from the master list and re-add it,
			 *  so that it will get added/removed to the feed and to the bookmarks
			 *  categories appropriately.
			 *
			 * We have an additional complication : if the topic is in search results,
			 *  we don't want to deal with it directly.  We want to deal with its
			 *  doppleganger in the master list, if it has one.
			 **/
			if (obj.item_type === "topic") {
				topic = this.fetchTopicById(obj.item_id);
				if (!_.isUndefined(topic) && !_.isNull(topic)) {
					if (topic !== obj.bookmarked_item) {
						topic.set(new_state);
					}
					//	if (obj.state.is_bookmarked) {
					this.get("topics").remove(topic, {
						removed_by: "topic_update",
					});
					this.get("topics").add(topic, {
						added_by: "topic_update",
					});
					//	}
				}
			}

			submit_item_obj = {
				item: {
					item_id: obj.item_id,
					item_forum_id: 0,
					item_type: obj.item_type,
					item_text: obj.item_text,
					in_feed: item_state_for_processing.in_feed ? 1 : 0,
					is_watched: item_state_for_processing.is_watched ? 1 : 0,
					item_main_color: obj.item_main_color,
					item_secondary_color: obj.item_secondary_color,
					item_subtitle: obj.item_subtitle,
				},
			};

			if (obj.hasOwnProperty("onError")) {
				submit_item_obj.onError = obj.onError;
			}

			if (obj.hasOwnProperty("onFinish")) {
				submit_item_obj.onFinish = obj.onFinish;
			}

			bookmark_category[
				obj.bookmarked_item.get("is_bookmarked") ? "addItemDb" : "removeItemDb"
			](submit_item_obj);

			return true;
		},

		/**
		 * If we ever get to the point of piping in topics from bookmarked
		 *  users en masse, like with the other bookmarked categories,
		 *  then we'll fold this into the function above.
		 **/
		setUserBookmarkState: function (obj) {
			var submit_item_obj,
				adding_bookmark,
				self = this;
			obj.user.set("is_bookmarked", !obj.user.get("is_bookmarked"));
			adding_bookmark = obj.user.get("is_bookmarked");
			if (adding_bookmark) {
				submit_item_obj = {
					item_id: obj.user.get("user_id"),
					item_forum_id: 0,
					item_type: "user",
					item_text: obj.user.get("username"),
					in_feed: 0,
					is_watched: 0,
					item_main_color: Constants.community_main_color,
					item_secondary_color: Constants.community_secondary_color,
					item_subtitle: "",
					last_active: obj.user.get("last_visit"),
					avatar: obj.user.get("avatar"),
				};
			}
			cmty_ajax.add({
				a: "bookmark_user",
				params: {
					bookmarked_user_id: obj.user.get("user_id"),
					bookmark_action: obj.user.get("is_bookmarked") ? 1 : 0,
				},
				main_handler: function (ok, msg) {
					var bookmark_users, cat_id;
					if (ok) {
						if (self.get("current_user").has("bookmark_users")) {
							cat_id = self.get("current_user").get("bookmark_users");
							if (cat_id > 0) {
								bookmark_users = self.fetchCategory(
									self.get("current_user").get("bookmark_users")
								);
								if (!_.isUndefined(bookmark_users)) {
									if (adding_bookmark) {
										bookmark_users.addItem(submit_item_obj);
									} else {
										bookmark_users.removeItem({
											item_id: obj.user.get("user_id"),
											item_forum_id: 0,
											item_type: "user",
										});
									}
								}
							}
						}
					} else {
						// On error, flip bit, throw modal, have listener on front end to toggle
						if (
							typeof Lang["user-bookmark-err-" + msg.error_code] === "string"
						) {
							AoPS.Community.Views.showError(
								Lang["user-bookmark-err-" + msg.error_code]
							);
						} else {
							AoPS.Community.Views.showError(
								Lang["unexpected-error-code"] + msg.error_code
							);
						}
						obj.user.set("is_bookmarked", false);
					}
				},
			});
		},

		/**
		 * When we add a forum via the Bookmark Forum Admin page, the forum
		 *  may or may not already be loaded to the front end.  If loaded,
		 *  we need to process the item add from that object.  If not, then
		 *  we need to spoof it.
		 *
		 * @param object Output of the AoPS.Community.Views.fireBookmarkModal()
		 *
		 */
		addBookmarkForumViaAdmin: function (obj) {
			var category,
				item = obj.item;

			if (item.item_type !== "forum") {
				console.log(
					"You sent the wrong type of item to addBookmarkForum.  You\
					deserve the error report this user will give you."
				);
			}

			category = this.fetchCategory(parseInt(item.item_id));
			if (_.isUndefined(category)) {
				category = this.constructTemporaryCategory({
					category_type: "forum",
				});
			}

			item.bookmarked_item = category;
			if (obj.hasOwnProperty("onError")) {
				item.onError = obj.onError;
			}

			item.category_string = "bookmarked_forum_category";
			this.setBookmarkState(item);
		},

		/**
		 * Fetch data about reported posts.
		 *
		 * There are three ways this function gets called.
		 *
		 * 1) Upon the first time we hit the reported_posts.  For this,
		 *		last_fetch_time will equal 0, and we'll get the most recently
		 *		reported posts. However, we still want to check if there were
		 *  	any post reports resolved between the page load (the init time) and now,
		 *  	so that we can send that info to the front end to remove the reported posts
		 *  	notifications on the topics and posts.  So, we fetch the
		 *		resolved reports, too.
		 *
		 * 2) While on the page, there's a cron that calls this function to see if there
		 *	  	were more recent reports or anything has been resolved.
		 *
		 * 3) If we scroll to the bottom of the page, then fetch_before is set in
		 *		the Ajax call, and we go get older reported posts.
		 *
		 *
		 * @param obj
		 *		fetch_before int optional
		 **/
		fetchReportedPosts: function (obj) {
			var self = this,
				fetch_before = 0;
			if (arguments.length > 0) {
				fetch_before = obj.hasOwnProperty("fetch_before")
					? obj.fetch_before
					: 0;
			} else {
				obj = {};
			}

			// We're already fetching some, thanks....
			if (this.get("loading_post_reports")) {
				return;
			}

			this.set("loading_post_reports", true);
			if (AoPS.session.logged_in_and_initialized) {
				var found_new_report = false;
				cmty_ajax.add({
					a: "fetch_reported_posts",
					params: {
						last_reported_posts_fetch_time: this.get(
							"last_reported_posts_fetch_time"
						),
						init_time: parseInt(AoPS.bootstrap_data.init_time),
						fetch_before: fetch_before,
					},
					main_handler: function (ok, msg) {
						if (ok) {
							_.each(msg.response.reported_posts, function (reported_post) {
								var topic;
								/**
								 * If the database gets jacked up and a reported_post is
								 *  unresolved for a topic that has been deleted, then
								 *  the reported post will come back without a topic attached.
								 *  We want to ignore those.
								 **/
								if (reported_post.hasOwnProperty("topic")) {
									if (
										_.isUndefined(
											self.get("reported_posts").findWhere({
												id: reported_post.id,
											})
										)
									) {
										found_new_report = true;
										reported_post.topic.master = self;

										/* The topic models are needed
											for building the posts in the PostReport View
											We keep these separate from the master thread
											for simplicity sake; keeps us from dropping
											post records in the middle of existing topic
											posts collections, etc. */
										topic = new AoPS.Community.Models.Topic(
											reported_post.topic
										);

										/** Attach the post to this topic **/
										reported_post.post_data.topic = topic;
										topic.get("posts").add(reported_post.post_data);

										/** Attach the Post model to the Reported post object **/
										reported_post.post = topic.get("posts").models[0];

										/** Don't need the topic property in the reported post **/
										delete reported_post.topic;

										self.get("reported_posts").add(reported_post);
									}
								}
							});
							if (fetch_before == 0) {
								self.set(
									"last_reported_posts_fetch_time",
									msg.response.fetch_time
								);
							}
							if (msg.response.hasOwnProperty("resolved_reports")) {
								_.each(msg.response.resolved_reports, function (report) {
									var post_report = self.get("reported_posts").findWhere({
										id: report.id,
									});

									if (!_.isUndefined(post_report)) {
										post_report.set("status", "resolved");
									}
									self.resetTopicReports({
										topic_id: report.topic_id,
										post_id: report.post_id,
										topic_num_reports: -1,
									});
								});
							}
						}
						self.trigger("post_reports_fetched");
						if (fetch_before > 0 && !found_new_report) {
							self.set("all_past_reported_posts_fetched", true);
						}
						self.set("loading_post_reports", false);
					},
					extra_handlers: obj,
				});
			}
		},

		/**
		 * Reset the topic report data for a post and topic.
		 *
		 * @param object
		 *		topic_id : topic that has had a report settled
		 *		post_id : id of post that has been settled
		 *		topic_num_reports : new number of reported for this topic (set to -1 to decrement existing by 1)
		 *
		 * We have the "decrement by 1" to deal with the fetch of resolved reports in
		 *  fetchReportedPosts.  We may eventually do something more precise, but that would
		 *  probably be overkill.
		 **/
		resetTopicReports: function (obj) {
			var topic = this.fetchTopicById(obj.topic_id),
				post;

			if (_.isNull(topic)) {
				// this topic not loaded
				return;
			}

			post = topic.get("posts").findWhere({post_id: obj.post_id});
			if (!_.isUndefined(post)) {
				post.set("reported", false);
			}
			if (obj.topic_num_reports == -1) {
				topic.set("num_reports", topic.get("num_reports") - 1);
			} else {
				topic.set("num_reports", obj.topic_num_reports);
			}

			if (obj.hasOwnProperty("remove_report") && obj.remove_report) {
				this.get("reported_posts").remove(obj.report);
			}
		},

		/**
		 * Close out all post reports with this post id.
		 * @param int post id.
		 **/
		closePostReports: function (post_id) {
			var reports = this.get("reported_posts").where({
				post_id: post_id,
			});

			_.each(reports, function (report) {
				report.set("status", "resolved");
			});

			this.get("reported_posts").remove(reports);
		},

		/**
		 * Fetch global cmty permission for this user.
		 *
		 * @param string permission key
		 * @return boolean default false
		 *
		 * Permissions are passed in through the bootstrap property
		 *	'user_global_cmty_permissions'.
		 **/
		fetchPermission: function (key) {
			var permissions = this.get("permissions");
			return permissions.hasOwnProperty(key) && permissions[key];
		},

		/**
		 * Fetch staff permission for this user.
		 *
		 * @param string permission key
		 * @return boolean default false
		 *
		 * Permissions are passed in through the bootstrap property
		 *	'user_staff_perms'.
		 **/
		fetchStaffPermission: function (key) {
			var permissions = this.get("staff_permissions");
			return permissions.hasOwnProperty(key) && permissions[key];
		},

		/**
		 * Can this user construct this type of category?
		 *
		 * @param object
		 *		type string 'view_tags', 'folder', 'view_topics', 'forum', 'blog'
		 *		onError function optional
		 **/
		validateConstructCategory: function (obj) {
			var perm_setting;

			function sendError(code) {
				if (obj.hasOwnProperty("onError")) {
					obj.onError(code);
				}
			}

			switch (obj.type) {
				case "forum":
				case "view_tags":
				case "view_topics":
				case "view_posts":
				case "folder":
				case "blogroll":
					perm_setting = "can_create_category";
					break;

				case "blog":
					perm_setting = "can_create_blog";
					break;

				default:
					sendError("E_BAD_TYPE");
					return false;
			}

			if (!this.fetchPermission(perm_setting)) {
				sendError("E_NO_PERMISSION");
				return false;
			}
			return true;
		},

		/**
		 * Get the default containers for a container we're building on the admin page.
		 *
		 * @param string 'forum', 'view_tags', 'folder', 'blogroll'
		 **/
		getDefaultContainers: function (category_type) {
			var containers = [];
			switch (category_type) {
				case "forum":
					/*
					category = this.fetchCategory(AoPS.Community.Constants['other_forums_id']);
					containers.push(category.convertToContainer({
							can_remove : true
						}));
		*/
					break;

				case "view_tags":
				case "folder":
					/*
					category = this.fetchCategory(AoPS.Community.Constants['special_collections_id']);
					containers.push(category.convertToContainer({
							can_remove : true
						}));
*/
					break;

				case "blogroll":
					break;
			}

			return containers;
		},

		/**
		 * Go through all the topics and find the ones with this category id,
		 *  and set the forum_locked according to the new state.
		 *
		 * @param int category id
		 * @param boolean new state
		 **/
		setTopicsForumLockStatus: function (category_id, state) {
			var i,
				topics = this.get("topics").models,
				n_topics = topics.length;

			for (i = 0; i < n_topics; i++) {
				if (topics[i].get("category_id") === category_id) {
					topics[i].set("forum_locked", state);
				}
			}
		},

		/**
		 * Lock/unlock this category on the front end only.
		 *
		 * @param int category id
		 * @param boolean state
		 **/
		setCategoryLockStatus: function (category_id, state) {
			var category = this.fetchCategory(category_id);
			if (!_.isUndefined(category)) {
				category.setFrontEndLocked(state);
			}
		},

		/**
		 * Reset the topics in a category, except for the announcements,
		 *  which will get added back in.
		 *
		 * Used in the school to deal with suddenly having access to topics upon
		 *  answering homework problems.  That gives tag permission for conversations
		 *  attached to the solution to the problem, so we have to clean out the category in order
		 *  to re-fetch topics that might have been previously filtered out.
		 *
		 *  @param int category id
		 *  @param bool force_all if true, will also reset announcements
		 **/
		resetCategory: function (category_id, force_all = false) {
			var category = this.fetchCategory(category_id),
				active_topics,
				announcements = [];

			if (!_.isUndefined(category)) {
				active_topics = category.get("active_topics");
				announcements = active_topics.filter(function (topic) {
					return topic.get("announce_type") !== "none";
				});

				active_topics.reset();

				if (!force_all) {
					active_topics.add(announcements);
				}
			}
		},

		/**
		 * Fetch results for the moderator log.
		 *
		 * @param object
		 * 		last_id int last log_id previously fetched (send 0 for default behavior)
		 **/
		fetchLogResults: function (obj) {
			var self = this;

			cmty_ajax.add({
				a: "fetch_log",
				params: obj.params,
				main_handler: function (ok, msg) {
					if (ok) {
						if (msg.response.all_fetched) {
							self.trigger("all_log_entries_fetched");
						}
						self.trigger("log_entry_fetch_time", {
							time: msg.response.fetch_time,
						});
					}
				},
				extra_handlers: obj,
			});
		},

		revertActions: function (obj) {
			cmty_ajax.add({
				a: "revert_actions",
				params: {
					log_ids: JSON.stringify(obj.log_ids),
					table_type: obj.table_type,
				},
				main_handler: function (ok, msg) {
					if (ok) {
						if (msg.response.all_fetched) {
							self.trigger("all_log_entries_fetched");
						}
					}
				},
				extra_handlers: obj,
			});
		},

		validateAdmin: function (obj) {
			cmty_ajax.add({
				a: "validate_admin",
				params: {
					pwd: obj.pwd,
				},
				main_handler: function (ok, msg) {},
				extra_handlers: obj,
			});
		},

		sendPolymathConfirm: function (obj) {
			cmty_ajax.add({
				a: "send_polymath_confirm",
				params: {
					category_id: obj.category_id,
					selected_option: obj.selected_option,
					student_type: obj.student_type,
				},
				main_handler: function (ok, msg) {},
				extra_handlers: obj,
			});
		},

		/**
		 * Parse the locations of people in office hours.
		 *
		 * @param array of objects (user_id, topic_id)
		 **/
		resetOfficeHoursPeople: function (office_hours_people) {
			var self = this;

			this.trigger("reset_office_hours_topics");

			_.each(office_hours_people, function (data) {
				var user_id = parseInt(data.user_id),
					username = data.username,
					avatar = data.avatar,
					topic_id = parseInt(data.topic_id),
					is_typing = parseInt(data.is_typing),
					topic;

				topic = self.fetchTopicById(topic_id);

				if (!_.isNull(topic)) {
					topic.trigger("office_hours_person_here", {
						user_id: user_id,
						username: username,
						avatar: avatar,
						is_typing: is_typing,
					});
				}
			});
		},

		getFocusedTopicIds: function () {
			var result = {
				master: 0,
				feed: 0,
			};

			if (
				!_.isNull(this.get("focus_topic")) &&
				!_.isUndefined(this.get("focus_topic"))
			) {
				result.master = this.get("focus_topic").get("topic_id");
			}

			if (this.has("feed")) {
				if (
					!_.isNull(this.get("feed").get("focus_topic")) &&
					!_.isUndefined(this.get("feed").get("focus_topic"))
				) {
					result.feed = this.get("feed").get("focus_topic").get("topic_id");
				}
			}

			return result;
		},

		fetchOfficeHoursData: function (once) {
			var self = this;
			var focused_topic_ids = this.getFocusedTopicIds();

			cmty_ajax.add({
				a: "fetch_office_hours_locations",
				params: {
					master_focus_topic_id: focused_topic_ids.master,
					feed_focus_topic_id: focused_topic_ids.feed,
				},
				main_handler: function (ok, msg) {
					if (ok) {
						if (msg.response.office_hours_active) {
							self.resetOfficeHoursPeople(msg.response.office_hours_people);
							if (!once) {
								setTimeout(function () {
									self.fetchOfficeHoursData();
								}, Constants.fetch_office_hours_interval);
							}
						} else {
							self.trigger("reset_office_hours_topics");
						}
					}
				},
			});
		},

		resetThanks: function (e) {
			var self = this,
				user = e.currentTarget;

			if (user) {
				cmty_ajax.add({
					a: "delete-thanks",
					params: {
						user_id: user.getAttribute("user_id"),
					},
					main_handler: function (ok, data) {
						if (data.error_code) {
							self.trigger("error", {error_code: data.error_code});
							AoPS.Ui.Flyout.display(data.error_code);
						} else {
							self.trigger("posts-resynced", data.response);
							AoPS.Ui.Flyout.display(Lang["cat-admin-thanks-reset"]);
						}
					},
				});
			}
		},

		/**
		 * Mark the current user as typing in this topic if they are monitoring.
		 *
		 * topic: The ComModels.Topic object where the user is located.
		 * is_typing: 1 if the user is typing. 0 if they are not.
		 */
		updateIsTyping: function (topic, is_typing) {
			cmty_ajax.add({
				a: "log_is_typing",
				params: {
					topic_id: topic.get("topic_id"),
					is_typing: is_typing ? 1 : 0,
				},
				main_handler: function (ok, msg) {},
			});
		},
	});
	// END MASTER MODEL

	/**
	 * ComModels.Feed is the model that manages the feed.
	 *
	 * Properties
	 *
	 * master : The ComModels.Master object for the community.
	 * focus_topic : topic that the feed is focused on.
	 * focus_topic_show_from : show_from_top or show_from_bottom for the focus topic
	 *
	 */
	ComModels.Feed = Backbone.Model.extend({
		defaults: {
			initialized: false,
			focus_topic_show_from: "show_from_start",
			feed_setting: AoPS.bootstrap_data.hasOwnProperty("feed_init_setting")
				? AoPS.bootstrap_data["feed_init_setting"]
				: 7,
			focus_topic: null,
			global_feed_type: "full",
			on_initial_feed_fetch: false,
		},

		initialize: function () {
			this.get("master").set("feed", this);
			this.set("page_subfeed_settings", {});
			this.on("change:focus_topic", this.onChangeFocusTopic);
			this.on("change:feed_setting", this.onChangeFeedSetting);

			if (AoPS.bootstrap_data.hasOwnProperty("global_feed_settings")) {
				this.set(
					"global_feed_type",
					AoPS.bootstrap_data.global_feed_settings.global_feed_type
				);
				if (this.get("global_feed_type") === "custom") {
					if (
						AoPS.bootstrap_data.global_feed_settings.hasOwnProperty(
							"global_feed_fora"
						) &&
						AoPS.bootstrap_data.global_feed_settings.global_feed_fora.length > 0
					) {
						this.set(
							"global_feed_fora",
							AoPS.bootstrap_data.global_feed_settings.global_feed_fora
						);
					} else {
						this.set("global_feed_type", "full");
					}
				}
			}
		},

		/**
		 * onChangeFocusTopic consists of the actions that happens whenever we
		 *  change the focus topic.  We start the realtime monitor on the
		 *  new topic, and stop the realtime monitor and viewing on the old one.
		 */
		onChangeFocusTopic: function (obj) {
			var new_focus = this.get("focus_topic"),
				old_focus = this.previous("focus_topic");
			if (
				arguments.length !== 3 ||
				!arguments[2].hasOwnProperty("no_ajax_override") ||
				!arguments[2].no_ajax_override
			) {
				cmty_ajax.cancelAll({cancel_type: "feed"});
			}

			if (!_.isNull(old_focus)) {
				old_focus.set("is_feed_focus", false);
			}

			if (!_.isNull(new_focus)) {
				new_focus.set("is_feed_focus", true);
			}
			this.get("master").makeChangeFocusTopicAjaxCall({
				new_focus: new_focus,
				previous_focus: old_focus,
				source: "feed",
				hash: this.get("master").get("watcher_hash"),
			});
		},

		onChangeFeedSetting: function () {
			cmty_ajax.add({
				a: "change_feed_setting",
				params: {
					feed_setting: this.get("feed_setting"),
				},
				main_handler: function (ok, msg) {
					return;
				},
			});
		},

		/**
		 * Make an initial fetch of the subfeed topics.
		 *
		 * @param array of objects, each of which is
		 *		an object we could pass to cmty_ajax.add.
		 *
		 * TODO someday : on the back end, we may be able to use
		 *  the CmtyTopic caching to speed things up a bit.
		 **/
		fetchInitialSubfeedTopics: function (subfeed_data) {
			var params = _.map(subfeed_data, function (obj) {
					obj.params.a = obj.a;
					return obj.params;
				}),
				index,
				self = this,
				len = subfeed_data.length;

			this.set("on_initial_feed_fetch", true);
			cmty_ajax.add({
				a: "run_multiple_ajax_calls",
				params: {
					/*
					pretty_print : true,
					queries : true,
					profiler : true,*/
					type: "initial_feed_fetch",
					data: JSON.stringify(params),
				},
				never_cancel: true,
				main_handler: function (ok, msg) {
					if (ok) {
						self.set("initialized", true);
						for (index = 0; index < len; index++) {
							subfeed_data[index].main_handler(true, {
								response: msg.response.results[index],
							});
						}
					}
				},
				extra_handlers: {
					onFinish: function (data) {
						for (index = 0; index < len; index++) {
							if (
								subfeed_data[index].hasOwnProperty("extra_handlers") &&
								subfeed_data[index].extra_handlers.hasOwnProperty("onFinish")
							) {
								subfeed_data[index].extra_handlers.onFinish(
									data.results[index]
								);
							}
						}
						self.set("on_initial_feed_fetch", false);
					},
					onError: function (data) {
						for (index = 0; index < len; index++) {
							if (
								subfeed_data[index].hasOwnProperty("extra_handlers") &&
								subfeed_data[index].extra_handlers.hasOwnProperty("onError")
							) {
								subfeed_data[index].extra_handlers.onError(data);
							}
						}
					},
				},
				source: "feed",
			});
		},
	});

	ComModels.UserList = Backbone.Model.extend({
		defaults: {
			all_fetched: false,
			is_loading: false,
			/**
			 * Default sort can't be last_visit, since hidden users won't be listed
			 *  for last_visit, lest we reveal that they are online.
			 **/
			sort_column: "joined_at",
			sort_direction: "DESC",
			start_from: 0,
			stub: "",
		},

		initialize: function () {
			if (!this.has("users")) {
				this.set("users", []);
			}
		},

		fetchMoreUsers: function (obj) {
			var self = this;
			if (this.get("all_fetched") || this.get("is_loading")) {
				return;
			}
			this.set("is_loading", true);

			cmty_ajax.add({
				a: "fetch_more_users",
				params: {
					stub: this.get("stub"),
					sort_column: this.get("sort_column"),
					sort_direction: this.get("sort_direction"),
					start_from: this.get("start_from"),
				},
				main_handler: function (ok, msg) {
					var data,
						i,
						n_users,
						new_users = [];
					if (ok) {
						data = msg.response;

						if (data.num_parsed == 0) {
							self.set("all_fetched", true);
						} else {
							n_users = self.get("users").length;
							if (n_users == 0) {
								new_users = data.users;
							} else {
								for (i = 0; i < n_users; i++) {
									if (!self.isUserFetched(data.users[i])) {
										new_users = data.users.slice(i);
										break;
									}
								}
							}

							_.each(new_users, function (user) {
								if (user.last_visit > 0) {
									user.last_visit = Utils.makePrettyTime(user.last_visit);
								} else {
									user.last_visit = "";
								}
								user.joined_at = Utils.makePrettyTime(user.joined_at);
							});
							self.get("users").push(new_users);
							msg.response.new_users = new_users;
							self.set("start_from", self.get("start_from") + data.num_parsed);
						}
					}
					self.set("is_loading", false);
				},
				extra_handlers: obj,
			});
		},

		isUserFetched: function (user) {
			var users = this.get("users"),
				n_users = users.length,
				min = Math.max(0, n_users - 15);

			for (var i = n_users - 1; i >= min; i--) {
				if (users[i].user_id === user.user_id) {
					return true;
				}
			}
			return false;
		},
	});

	/**
	 * ComModels.Category is the model for a category.  This model has many children.
	 *
	 * Properties:
	 * can_add : User can add items to this category manually (My Forums and My Collections, eg)
	 * category_name: Short name that is the category's label
	 * permissions : Object holding permissions for this category.
	 * short_description : Description for use in the forum header (or maybe in alt tags)
	 * long_description : Longer description for use in the Category cell box for categories without topics.
	 * num_posts : Number of posts in the category if it is a forum
	 * num_users : Number of people who are looking at the category if it is a forum
	 * category_id :
	 * is_bookmark_category : is this a category that consists of bookmarks?
	 * is_bookmarked : true if this is bookmarked, false otherwise
	 * main_color : Primary color of the category
	 * secondary_color : Light version of the category's color
	 * category_type: What kind of category am I?
	 * subcategories_data_loaded : boolean describes if we've loaded the data for category's items (if the category is a folder)
	 * items: Array of items in the category.
	 *   {item_id, item_type, item_forum_id, item_text}
	 * categories: If the category is a folder, then categories is a collection of ComModels.Category models
	 *    for the items in that folder.
	 * no_more_items : true if we've pulled everything out of the database
	 *
	 * Methods
	 *
	 *
	 * Fetching Methods
	 *
	 * fetchItemsByType(type)
	 *		Fetches those items with the given type.  (May ultimately be irrelevant if we
	 *       split views into tag_views and forum_views
	 *
	 * fetchItem(item)
	 *		Fetches a particular item by item_id, item_forum_id, item_type
	 *
	 * fetchMoreItems()
	 *		Get more items from the database.
	 *
	 * Other Methods
	 *
	 * hasItem (item)
	 *		Tells whether or not this category has this particular item
	 *
	 * hasOwnTopics()
	 *		True if the category is used to view topics (forums, views, private_conversations will fit)
	 *
	 * fillCategoriesCollection()
	 *		For Categories that are "Folders", this method fills out the categories collection.
	 *
	 * addItem (new_item)
	 *		Add an item to this category, or overwrite an existing if there's a name change
	 *
	 * addItemDb (object)
	 *  	Add an item to this category in the database, then on the front end
	 *
	 * removeItem (removed_item_obj)
	 * 		Remove this item from the front end
	 *
	 * removeItemDb (removed_item_obj)
	 * 		Remove this item from the front and back ends.
	 *
	 * hasItems ()
	 *		Tells whether or not this category has items.
	 *
	 */
	ComModels.Category = ComModels.Model.extend({
		defaults: {
			// Move to Folder ?
			all_subcategories_loaded: false,
			can_add: false,
			can_add_type: "none", // What type of category can I add direct from here?
			can_own_topics: false,
			can_mark_all_read: false,
			can_post: false,
			can_remove_self: true,
			can_target: false,
			category_id: 0,
			category_name: "",
			category_type: "",
			deleted: false,
			has_halp: false,
			has_source: false,
			has_tag_filter: false,
			has_topics: false,
			hide_desc_on_phone: false,
			in_feed: 0,
			is_forum: false,
			is_bookmark_category: false,
			is_bookmarked: false,
			is_locked: false,
			is_my_category: false,
			is_my_private: false,
			is_post_search: false, // true for user post search and general search
			is_private: false,
			is_public: true,
			is_watched: 0,
			last_item_level: 0,
			last_item_score: 0,
			loading_subcategories: false,
			main_color: "#000000",
			no_more_items: false,
			reset_on_items_change: false, // Do we rebuild the topics when an Item is added? (yes for views)
			secondary_color: "#6c6c6c",
			short_description: "",
			special_url: "",
			subcategories_data_loaded: false,
			visited: false,
		},

		/** Usually overwritten in children **/
		initialize: function () {
			this.setDefault("forum_ids", []);
			this.setDefault("items", []);
			this.setDefault("users", []);
			this.setDefault("forums", {});
			/*	this.set({
				'items' : [],
				'users' : [],
				'forums' : {},// Loaded forums, keys are the category_id of each forum
				'forum_ids' : []// Array of forums that this category holds (if category is a folder)
			});*/
		},

		/**
		 * Set the lock status for this category on the front end.
		 *
		 * @param boolean
		 **/
		setFrontEndLocked: function (state) {
			this.set("is_locked", state);

			if (this.get("can_own_topics")) {
				this.get("master").setTopicsForumLockStatus(
					this.get("category_id"),
					state
				);
			}
		},
		/**
		 *

		setDefault : function (setting, val) {
			if (!this.has(setting)) {
				this.set(setting, val);
			}
		},
		*/

		/**
		 * Fetch the permission associated with the given key.
		 *
		 * @param key :
		 * TODO : Behavior if key is not set.
		 **/
		getPermission: function (key) {
			if (!this.has("permissions")) {
				console.log(
					"Permission sought before permissions set for category " +
						this.get("category_name")
				);
			}

			if (_.isUndefined(this.get("permissions")[key])) {
				console.log(
					"Permissions have not been set for key " +
						key +
						" of Category " +
						this.get("category_name")
				);
			}

			return this.get("permissions")[key];
		},

		/**
		 * fetchItemsByType returns an array of items whose type matches the
		 *  submitted type
		 * @param requested_type : string
		 * @return array of item objects {item_id, item_type, item_forum_id, item_text}
		 */
		fetchItemsByType: function (requested_type) {
			return _.where(this.get("items"), {
				item_type: requested_type,
			});
		},

		/**
		 * Fetch a single item from the database for this category.
		 *
		 * @param int Item ID
		 * @param int Item's forum id
		 * @param string Item type
		 *
		 * Adds item to this category on load, which triggers
		 *  the 'item_added' event (which passes this item as an argument)
		 *
		 * Triggers 'item_db_fetch_failed' if there is no such item in the database.
		 */
		fetchItemFromDb: function (obj) {
			cmty_ajax.add({
				a: "fetch_specific_item",
				params: {
					category_id: this.get("category_id"),
					item_id: obj.item_id,
					item_forum_id: obj.forum_id,
					item_type: obj.item_type,
				},
				main_handler: _.bind(function (ok, msg) {
					if (ok) {
						if (msg.response.success) {
							this.addItem(msg.response.item);
						} else {
						}
					} else {
						this.trigger("item_db_fetch_failed");
					}
				}, this),
				extra_handlers: obj,
			});
		},

		/**
		 * Fetch more items for this category.
		 */
		fetchMoreItems: function (obj) {
			var self = this,
				settings = arguments.length === 0 ? {} : obj;

			if (this.get("fetching_items")) {
				return;
			}
			this.set("fetching_items", true);
			if (!this.get("no_more_items")) {
				cmty_ajax.add({
					a: "fetch_more_items",
					params: {
						category_id: this.get("category_id"),
						last_item_score: this.get("last_item_score"),
						last_item_level: this.get("last_item_level"),
						last_item_text: this.get("last_item_text"),
						log_visit: this.get("visited") ? 0 : 1,
						start_num: this.get("items").length,
						fetch_all: obj.hasOwnProperty("fetch_all") && obj.fetch_all ? 1 : 0,
					},
					main_handler: function (ok, msg) {
						var item_added = false;
						if (ok) {
							if (msg.response.hasOwnProperty("items")) {
								_.each(msg.response.items, function (item) {
									item_added = self.addItem(item) || item_added;
								});

								if (!item_added) {
									self.set("no_more_items", true);
								} else if (msg.response.hasOwnProperty("no_more_items")) {
									self.set("no_more_items", msg.response.no_more_items);
								}
								self.set("last_item_score", msg.response.last_item_score);
								self.set("last_item_text", msg.response.last_item_text);
							}
						}
						self.set("fetching_items", false);
					},
					extra_handlers: settings,
				});

				this.set("visited", true);
			}
		},

		fetchItemsForEdit: function (obj) {
			var self = this;

			cmty_ajax.add({
				a: "fetch_items_for_edit",
				params: {
					category_id: this.get("category_id"),
				},
				main_handler: function (ok, msg) {
					var available_items = [];
					if (ok) {
						_.each(msg.response.items_for_edit, function (item) {
							item.edit_state = "saved";
						});
						self.set("items_for_edit", msg.response.items_for_edit);
						if (msg.response.hasOwnProperty("available_items")) {
							_.each(msg.response.available_items, function (item) {
								if (!self.hasItem(item)) {
									available_items.push(item);
								}
							});
							self.set("available_items", available_items);
						}
					}
				},
				extra_handlers: obj,
			});
		},

		canAddEditItems: function () {
			var total = 0;
			if (!this.has("item_limit") || this.get("item_limit") === 0) {
				return true;
			} else {
				_.each(this.get("items_for_edit"), function (item) {
					if (item.edit_state !== "deleted") {
						total++;
					}
				});

				return total < this.get("item_limit");
			}
		},

		getSortDescription: function (type) {
			if (this.get("category_id") === Constants.other_forums_id) {
				return Lang["cat-admin-sort-type-system-other_forums"];
			}
			if (type === "system") {
				if (
					typeof Lang[
						"cat-admin-sort-type-system-" + this.get("category_type")
					] === "string"
				) {
					return Lang[
						"cat-admin-sort-type-system-" + this.get("category_type")
					];
				} else {
					return Lang["cat-admin-sort-type-system-default"];
				}
			} else {
				return Lang["cat-admin-sort-type-" + type];
			}
		},

		/**
		 * When editing a collection, we load the items_for_edit array.
		 *  "My Forums", "My Collections", "My Blogs" also have available_items array,
		 *	which are the items the user has permission to add.
		 *
		 *  As we edit the items of the collection, we keep track of the actions
		 *  in the items_for_edit array.  Each item, as it is added, deleted,
		 *  or pulled into the active items from the available_items, has
		 *  an edit_state
		 *  saved = this item was in the collection at page load
		 *  deleted = this item was in the collection at page load, and user wants
		 *		to delete it.
		 *	available = this item is not in the collection, but is available
		 *		to add (see above).
		 *	added = this item was not in the collection at the start, but has been added.
		 **/
		deleteEditItem: function (item) {
			if (item.edit_state === "saved") {
				// add 'edited' if we have that state
				item.edit_state = "deleted";
				return false;
			} else {
				item.edit_state = "available";
				this.set("items_for_edit", _.without(this.get("items_for_edit"), item));
				return true;
			}
		},

		isActiveEditItem: function (item) {
			var edit_item = _.findWhere(this.get("items_for_edit"), {
				item_id: item.item_id,
				item_forum_id: item.item_forum_id,
				item_type: item.item_type,
			});

			return !_.isUndefined(edit_item);
		},

		/**
		 * Fetch an item_for_edit item for a view of topics
		 **/
		fetchTopicEditItem: function (obj) {
			cmty_ajax.add({
				a: "fetch_topic_for_view",
				params: {
					category_id: this.get("category_id"),
					topic_id: obj.topic_id,
				},
				main_handler: function (ok, msg) {},
				extra_handlers: obj,
			});
		},

		fetchAvailableItem: function (item) {
			return _.findWhere(this.get("available_items"), {
				item_id: item.item_id,
				item_forum_id: item.item_forum_id,
				item_type: item.item_type,
			});
		},

		/**
		 * Fetch a member of the items_for_edit array.
		 **/
		fetchEditItem: function (item) {
			return _.findWhere(this.get("items_for_edit"), {
				item_id: item.item_id,
				item_forum_id: item.item_forum_id,
				item_type: item.item_type,
			});
		},

		/**
		 * Add this item to the "items_for_edit" array, which are the
		 *  items we need to process on the back end.
		 **/
		addToEditItems: function (item) {
			var edit_item = this.fetchEditItem(item);
			if (_.isUndefined(edit_item)) {
				this.get("items_for_edit").push(item);
			}
		},

		/**
		 * Remove this item from available items
		 **/
		removeAvailableItem: function (item) {
			var available_item = this.fetchAvailableItem(item);

			if (!_.isUndefined(available_item)) {
				this.set(
					"available_items",
					_.without(this.get("available_items"), available_item)
				);
			}
		},

		/**
		 * Add this item to the available items if it's not already there
		 **/
		addToAvailableItems: function (item) {
			var available_item = this.fetchAvailableItem(item);
			if (_.isUndefined(available_item)) {
				this.get("available_items").push(item);
			}
		},

		saveItemEdits: function (obj) {
			var items_to_edit = [];

			_.each(this.get("items_for_edit"), function (item) {
				if (item.edit_state !== "added") {
					items_to_edit.push(_.omit(item, "post_data")); // Don't want to send back all the post_data for a view_posts; id is enough
				} else {
					items_to_edit.push(item); // But we need the post_data for brand-new user-created posts
				}
			});

			cmty_ajax.add({
				a: "save_item_edits",
				params: {
					change_sort_type: obj.change_sort_type ? 1 : 0,
					sort_type: obj.sort_type,
					edited_items: JSON.stringify(items_to_edit), //JSON.stringify(this.get('items_for_edit')),
					category_id: this.get("category_id"),
				},
				main_handler: function (ok, msg) {
					// All action in the extras
				},
				extra_handlers: obj,
			});
		},

		/**
		 * Does this category have this item
		 *
		 * @param obj {item_id, item_forum_id}
		 *
		 * TODO : Should we be including item_type here?  Search hasItem and fetchItem usage and see
		 */
		hasItem: function (item) {
			return !_.isUndefined(this.fetchItem(item));
		},

		/***
		 * Make an object that I can jam in an itembox to
		 *  put this category in the itembox.
		 **/
		makeItemOfThis: function () {
			return {
				category_id: this.get("category_id"),
				category_type: this.get("category_type"),
				is_visible: true,
				item_forum_id: 0,
				label: this.get("category_name"),
				main_color: this.get("main_color"),
				secondary_color: this.get("category_color"),
				short_description: this.get("short_description"),
				value: this.get("category_name"),
			};
		},

		// TODO : On added item, check if category present; if not, then mark subcategories not
		//  all loaded.
		fetchMoreCategoryItems: function (obj) {
			var start_idx = obj.start_idx,
				i,
				len,
				item,
				ajax_settings,
				items = this.get("items"),
				categories_to_load = [],
				n_categories = 0,
				category,
				self = this,
				master = this.get("master");

			if (
				this.get("all_subcategories_loaded") ||
				this.get("loading_subcategories")
			) {
				return;
			}

			len = items.length;

			for (
				i = start_idx;
				i < len &&
				n_categories < AoPS.Community.Constants.max_categories_to_load;
				i++
			) {
				item = items[i];

				if (!item.hasOwnProperty("category")) {
					// Currently assuming that only categories with
					//  ids can be placed inside collections.  Let's keep it that way...

					if (item.item_type === "user") {
						categories_to_load.push(item);
						n_categories++;
					} else {
						category = master.fetchCategory(item.item_id);
						if (!_.isUndefined(category)) {
							item.category = category;
						} else {
							categories_to_load.push(item);
							n_categories++;
						}
					}
				}
			}

			ajax_settings = {
				sought_category_ids: JSON.stringify(
					_.pluck(categories_to_load, "item_id")
				),
				parent_category_id: this.get("category_id"),
				seek_items: 0,
			};

			if (
				n_categories < AoPS.Community.Constants.max_categories_to_load &&
				!this.get("no_more_items")
			) {
				ajax_settings.seek_items = 1;
				ajax_settings.start_num = this.get("items").length; // HERE is where to break out item_number
			}

			if (this.get("no_more_items") && n_categories === 0) {
				this.set("all_subcategories_loaded", true);
				self.trigger("subcategories_loaded");
				return;
			}

			ajax_settings.log_visit = this.get("visited") ? 0 : 1;
			this.set("visited", true);

			this.set("loading_subcategories", true);

			/*
			ajax_settings.pretty_print = true;
			ajax_settings.queries = true;
			ajax_settings.profiler = true;
			*/
			cmty_ajax.add({
				a: "fetch_items_categories",
				params: ajax_settings,
				main_handler: function (ok, msg) {
					if (ok) {
						if (msg.response.hasOwnProperty("categories")) {
							_.each(msg.response.categories, function (category_data) {
								var new_category = master.constructNewCategory(category_data);

								// Takes care of blogs, which will have topics attached on the way back
								//  TODO : Add to master's topics if we ever need realtime update
								//   of blog topics outside the blog.
								/*if (category_data.hasOwnProperty('topics_data')) {
									_.each(category_data.topics_data, function (topic) {
										topic.master = self.get('master');
										topic.permissions = new_category.get('permissions');
										new_category.get('active_topics').add(topic);
									});
								}*/
								var found_item = _.findWhere(categories_to_load, {
									item_id:
										self.get("category_type") === "bookmark_users"
											? category_data.user_id
											: category_data.category_id,
								});

								if (!_.isUndefined(found_item)) {
									found_item.category = new_category;
								}
							});

							if (msg.response.categories.length < categories_to_load.length) {
								_.each(categories_to_load, function (cat_item) {
									var loaded_cat = _.findWhere(msg.response.categories, {
										category_id: cat_item.item_id,
									});
									if (_.isUndefined(loaded_cat)) {
										self.removeItem(cat_item);
									}
								});
							}
						}
						if (msg.response.hasOwnProperty("new_items")) {
							_.each(msg.response.new_items, function (new_item) {
								if (new_item && new_item.category) {
									var fetched_category = master.fetchCategory(
										new_item.category.category_id
									);

									if (!_.isUndefined(fetched_category)) {
										// Category already built; stop here.
										new_item.category = fetched_category;
									} else {
										fetched_category = master.constructNewCategory(
											new_item.category
										);
										new_item.category = fetched_category;
									}
									self.addItem(new_item);
								}
							});
						}
						if (msg.response.hasOwnProperty("no_more_items")) {
							self.set("no_more_items", msg.response.no_more_items);
						}
						self.set("loading_subcategories", false);
						self.trigger("subcategories_loaded");
					}
				},
			});
			// TODO : A function that determines whether or not
			//  more fetching is needed, and where to start.

			// Save item_number, for fetching.  That's gonna be hard.
			//  There's not a unique item number; we just have to keep track
			//   as they come out of the database, basing off our start_number.
		},

		/**
		 * Fetch the num_users data for each forum that this category holds.
		 *  This is pretty unimportant, so we only execute it
		 *  if there are no current ajax calls.
		 */
		fetchUsersData: function () {
			var forum_ids = [],
				forums = {};
			if (!this.has("items") || this.get("items").length === 0) {
				return;
			}

			_.each(this.get("items"), function (item) {
				if (item.item_type === "forum" && item.hasOwnProperty("category")) {
					forum_ids.push(item.item_id);
					forums[item.item_id] = item.category;
				}
			});

			if (forum_ids.length > AoPS.Community.Constants.max_forums_user_update) {
				return;
			}
			cmty_ajax.add({
				a: "fetch_forum_users",
				params: {
					forum_ids: forum_ids.join(","),
				},
				main_handler: function (ok, msg) {
					if (ok) {
						_.each(msg.response.forum_data, function (forum) {
							if (forums.hasOwnProperty(forum.forum_id)) {
								forums[forum.forum_id].set("num_users", forum.num_users);
							}
						});
					}
				},
				queue_limit: -1,
			});
		},

		/**
		 * addItem adds an item to this category, or overwrites an existing if there's a
		 *   name change.  Only acts on the client, not the database.
		 *
		 * @param new_item: Object with the following:
		 *		item_id int
		 *		item_type string
		 *		item_forum_id int
		 *		item_text string
		 *		item_subtitle
		 *		item_main_color
		 *		item_secondary_color
		 * @param object optional
		 *		no_check_existing boolean default false -- set true to force add without checking already present
		 * 		add_to_front boolean default false -- add to the front of the list.
		 * @return boolean true if item added, false if already there.
		 *
		 * For now, assumes that if item_id, item_type, item_forum_id match,
		 *  then we should overwrite what's there with the new item.
		 */
		addItem: function (new_item) {
			var matching_item;
			// Skip the check of existing item if no_check_existing is true in the second argument
			if (
				arguments.length === 1 ||
				!arguments[1].hasOwnProperty("no_check_existing") ||
				!arguments[1].no_check_existing
			) {
				matching_item = this.fetchItem(new_item);

				if (!_.isUndefined(matching_item) && !_.isNull(matching_item)) {
					if (matching_item.item_text === new_item.item_text) {
						// already here
						return false;
					}
					this.set("items", _.without(this.get("items"), matching_item));
				}
			}
			// Will need to worry about order at some point, probably.
			if (
				arguments.length === 2 &&
				arguments[1].hasOwnProperty("add_to_front") &&
				arguments[1].add_to_front
			) {
				this.get("items").unshift(new_item);
			} else {
				this.get("items").push(new_item);
			}
			if (!new_item.hasOwnProperty("category")) {
				this.set("all_subcategories_loaded", false);
			}
			this.trigger("item_added", new_item);
			return true;
		},

		/**
		 * Add an array of items to this category.
		 **/
		addItems: function (arr) {
			var self = this;
			_.each(arr, function (item) {
				self.addItem(item);
			});
		},

		/**
		 * Add an array of items to the front of this category.
		 **/
		addItemsFront: function (arr) {
			var self = this,
				i,
				num_items = arr.length;
			for (i = num_items - 1; i >= 0; i--) {
				self.addItem(arr[i], {
					add_to_front: true,
				});
			}
		},

		/**
		 * Fetch an item from this category's items array.
		 *
		 * @param object with at least the following:
		 *		item_id int
		 *		item_type string
		 *		item_forum_id int
		 *
		 * @return object or undefined if item not present.
		 **/
		fetchItem: function (sought_item) {
			var new_item = _.find(this.get("items"), function (item) {
				return (
					item.item_id === sought_item.item_id &&
					item.item_forum_id === sought_item.item_forum_id &&
					item.item_type === sought_item.item_type
				);
			});

			return new_item;
		},

		/**
		 * Add an item to this category in the database, adds it on the front
		 *  end upon completing the back-end add (can turn off client add).
		 *
		 * @param object
		 *		item (required) : {item_id, item_forum_id, item_type, item_text}
		 *		add_to_client (optional, default true)
		 *
		 * Didn't just pass item directly because I might want an optional onFinish
		 *  at some point.
		 */
		addItemDb: function (obj) {
			var settings = _.extend(
				{
					in_feed: false,
					is_watched: false,
				},
				obj.item
			);
			obj = _.defaults(obj, {
				add_to_client: true,
				add_to_client_immediately: false,
			});
			if (obj.add_to_client_immediately) {
				this.addItem(obj.item);
			}

			settings.in_feed = settings.in_feed ? 1 : 0;
			settings.is_watched = settings.is_watched ? 1 : 0;

			cmty_ajax.add({
				a: "add_item_to_category",
				params: _.extend(
					{
						category_id: this.get("category_id"),
					},
					settings
				),
				main_handler: _.bind(function (ok, msg) {
					var item;
					if (ok) {
						if (obj.add_to_client && !obj.add_to_client_immediately) {
							this.addItem(obj.item);
						}
					} else {
						if (msg.error_code === "E_ITEM_NUM_LIMITED") {
							AoPS.Ui.Flyout.display(Lang["err-bookmark-limit-reached"]);
							if (obj.item.item_type === "topic") {
								item = this.get("master").fetchTopicById(
									parseInt(obj.item.item_id)
								);
								if (!_.isNull(item)) {
									item.set({
										is_bookmarked: false,
										in_feed: false,
										is_watched: false,
									});
								}
							} else if (obj.item.item_type === "forum") {
								item = this.get("master").fetchCategory(
									parseInt(obj.item.item_id)
								);
								if (!_.isUndefined(item)) {
									item.set({
										is_bookmarked: false,
										in_feed: false,
										is_watched: false,
									});
								}
							} else if (obj.item.item_type === "tag") {
								item = this.get("master").fetchCategory(
									parseInt(obj.item.item_forum_id)
								);
								if (!_.isUndefined(item)) {
									this.get("master")
										.get("bookmarked_tag_category")
										.removeItem(obj.item);
									item.trigger("reset_tag_bookmark");
								}
							}
						} else {
							AoPS.Ui.Flyout.display(msg.error_code);
						}
					}
				}, this),
				extra_handlers: obj,
			});
		},

		/**
		 * removeItem removes an item from this category. Only acts on the client, not the database.
		 *
		 * @param new_item: Object with the following:
		 *		item_id int
		 *		item_type string
		 *		item_forum_id int
		 *		item_text string
		 *
		 * For now, assumes that if item_id, item_type, item_forum_id match,
		 *  then we should delete.
		 */
		removeItem: function (new_item) {
			var matching_item = this.fetchItem(new_item);

			if (!_.isUndefined(matching_item) && !_.isNull(matching_item)) {
				this.set("items", _.without(this.get("items"), matching_item));

				// The line below originally had 'new_item' in place of 'matching_item'.
				//  I don't know if there are any applications anywhere that
				//  want that.  I know there are some that want the match.
				//  Changed on 8/12.
				this.trigger("item_removed", matching_item);
			}
		},

		/**
		 * Remove an item from this category in the database, remove it on the front
		 *  end upon completing the back-end add.
		 *
		 * @param object
		 *		item (required) : {item_id, item_forum_id, item_type, item_text}
		 *		remove_from_client (optional, default true, set to false if you remove
		 *			separately, such as with bookmarks.)
		 *		remove_from_client_immediately (optional, default false,
		 *			used when you don't want a delay on the front end.)
		 *
		 * Didn't just pass item directly because I might want an optional onFinish
		 *  at some point.
		 */
		removeItemDb: function (settings) {
			var obj = _.extend(
				{
					remove_from_client: true,
					remove_from_client_immediately: false,
				},
				settings
			);

			if (obj.remove_from_client_immediately) {
				this.removeItem(obj.item);
			}

			if (obj.item.hasOwnProperty("category")) {
				// Bad stuff happens if you try to send category to Ajax :)  Don't do it.
				delete obj.item.category;
			}
			cmty_ajax.add({
				a: "remove_item_from_category",
				params: _.extend(
					{
						category_id: this.get("category_id"),
					},
					obj.item
				),
				main_handler: _.bind(function (ok, msg) {
					if (ok) {
						if (obj.remove_from_client && !obj.remove_from_client_immediately) {
							this.removeItem(obj.item);
						}
					} else {
						AoPS.Ui.Flyout.display(msg.error_code);
					}
				}, this),
				extra_handlers: obj,
			});
		},

		/**
		 * Tells whether or not this category has items.  May be overwritten in children classes.
		 */
		hasItems: function () {
			return this.has("items") && this.get("items").length > 0;
		},

		makeItemAutocompleteCall: function (call, params, obj) {
			cmty_ajax.clearCallsOfType(call);
			cmty_ajax.add({
				a: call,
				params: params,
				main_handler: _.bind(function (ok, msg) {
					var data;
					if (ok) {
						if (obj.hasOwnProperty("checkSquelch") && obj.checkSquelch()) {
							obj.response([]);
							return;
						}
						data = _.map(msg.response.items, function (item) {
							return _.defaults(item, {
								label: item.value,
							});
						});
						if (
							obj.hasOwnProperty("checkInputExists") &&
							obj.checkInputExists()
						) {
							obj.response(data);
							if (data.length === 0 && obj.hasOwnProperty("onNoMatch")) {
								obj.onNoMatch();
							}
							if (data.length > 0 && obj.hasOwnProperty("onMatch")) {
								obj.onMatch();
							}
						} else {
							// else eat the return data
						}
					} else {
						obj.response([]);
					}
				}, this),
			});
		},

		fetchItemAutocompleteMatches: function (obj) {
			this.makeItemAutocompleteCall(
				"fetch_item_autocomplete_matches",
				{
					tag_stub: obj.request.term,
					category_id: this.get("category_id"),
				},
				obj
			);
		},

		/**
		 * Mark a category visited for the purpose of topic notifications.
		 *  Really only relevant for fora and blogs.
		 **/
		markVisited: function () {
			// If user not watching this forum and user is not monitor, then no need to
			//  go to the back end.
			if (
				!this.get("is_forum") ||
				!AoPS.session.logged_in_and_initialized ||
				(!this.get("is_watched") &&
					(!this.get("is_monitored") || !this.getPermission("c_can_monitor")))
			) {
				return;
			}

			cmty_ajax.add({
				a: "mark_category_visited",
				params: {
					category_id: this.get("category_id"),
				},
				main_handler: function (ok, msg) {},
			});
		},

		checkUserRole: function (username) {
			var username_lc = username.toLowerCase(),
				user = _.find(this.get("users"), function (user_obj) {
					return user_obj.username.toLowerCase() === username_lc;
				});

			if (_.isUndefined(user)) {
				return {
					role: "none",
				};
			} else {
				return user;
			}
		},

		/**
		 * Update the role of a user in this category (model and database).
		 *
		 * @param obj {user_id is only required}
		 * @param string : new role
		 **/
		updateUserRole: function (user, role) {
			if (this.get("category_id") > 0) {
				cmty_ajax.add({
					a: "update_category_user",
					params: {
						category_id: this.get("category_id"),
						user_id: user.user_id,
						role: role,
					},
					main_handler: function (ok, msg) {
						/**
						 * For now, we aren't going to check on the front end
						 * that the add was successful on the back end.
						 * Permission failures will probably always be hack
						 * attempts, and login/out failures will have a
						 * notification thrown at a higher level.
						 **/
					},
				});
			}

			this.updateUserRoleInModel(user, role);
		},

		/**
		 * Update the role of a user in this model
		 *
		 * @param obj {user_id is only required, onFinish and onError handlers optional}
		 * @param string : new role
		 **/
		updateUserRoleInModel: function (user, role) {
			var updated_user = _.findWhere(this.get("users"), {
				user_id: parseInt(user.user_id),
			});

			if (!_.isUndefined(updated_user)) {
				updated_user.role = role;
			}
			this.trigger("users_changed");
		},

		checkAddedUsername: function (obj) {
			cmty_ajax.add({
				a: "check_username_added_to_category",
				params: {
					username: obj.username,
				},
				main_handler: function (ok, msg) {
					// All the action is in the extra handlers
				},
				extra_handlers: obj,
			});
		},

		/**
		 * Add a user to this category.  Only changes the model
		 *  if the database insert is successful.
		 *
		 * @param object
		 *		user_id int
		 *		role string
		 */
		addUser: function (user) {
			if (this.get("category_id") > 0) {
				cmty_ajax.add({
					a: "add_category_user",
					params: {
						category_id: this.get("category_id"),
						user_id: user.user_id,
						role: user.role,
					},
					main_handler: function (ok, msg) {
						/**
						   For now, we aren't going to check on the front end that the
						   add was successful on the back end.  Permission failures will probably
						   always be hack attempts, and login/out failures will have a notification
						   thrown at a higher level.
						 **/
					},
				});
			}
			this.addUserToModel(user);
		},

		/**
		 * Assumes the users are in alphabetical order.
		 *
		 * @param obj {user_id, username, role, is_admin}
		 * @trigger 'users_changed'
		 **/
		addUserToModel: function (user) {
			var current_users = this.get("users"),
				i,
				compare_val,
				inserted = false,
				username_lc = user.username.toLowerCase(),
				max = current_users.length,
				new_user_data = {
					user_id: parseInt(user.user_id),
					username: user.username,
					role: user.role,
					is_admin: parseInt(user.is_admin),
				};

			for (i = max - 1; i >= 0; i--) {
				compare_val = username_lc.localeCompare(
					current_users[i].username.toLowerCase()
				);

				if (compare_val === 0) {
					return false; // TODO : How to fail?
				}

				if (compare_val > 0) {
					current_users.splice(i + 1, 0, new_user_data);
					inserted = true;
					break;
				}
			}

			if (!inserted) {
				current_users.splice(0, 0, new_user_data);
			}

			this.trigger("users_changed");
		},

		/**
		 * Remove a user from this category (model and database).
		 *
		 * @param obj {user_id is only required}
		 **/
		removeUser: function (obj) {
			var current_users = this.get("users"),
				remove_user;
			remove_user = _.findWhere(current_users, {
				user_id: parseInt(obj.user_id),
			});
			if (!_.isUndefined(remove_user)) {
				if (this.get("category_id") > 0) {
					cmty_ajax.add({
						a: "remove_category_user",
						params: {
							category_id: this.get("category_id"),
							user_id: remove_user.user_id,
						},
						main_handler: function (ok, msg) {
							/**
							   For now, we aren't going to check on the front end that the
							   add was successful on the back end.  Permission failures will probably
							   always be hack attempts, and login/out failures will have a notification
							   thrown at a higher level.
							 **/
						},
						extra_handlers: obj,
					});
				}
				this.removeUserFromModel(remove_user);
			}
		},

		/**
		 * Remove a user from this category model.
		 *
		 * @param obj {user_id is only required}
		 **/
		removeUserFromModel: function (user) {
			this.set("users", _.without(this.get("users"), user));
			this.trigger("users_changed");
		},

		/**
		 * Remove users with a certain role from the category
		 **/
		removeUsersByRole: function (role) {
			this.set(
				"users",
				_.reject(this.get("users"), function (user) {
					return user.role === role;
				})
			);

			// TODO : Ajax call, when we make blogs able to have their public/private changed.
		},

		/**
		 * Lock or unlock a category
		 *
		 * @param object
		 * 		is_locked : boolean
		 *		onFinish (optional) function
		 *		onError (optional) function
		 **/
		setLockedStatus: function (obj) {
			var self = this;

			if (this.get("category_id") > 0) {
				cmty_ajax.add({
					a: "set_category_lock_status",
					params: {
						category_id: this.get("category_id"),
						is_locked: obj.is_locked ? 1 : 0,
					},
					main_handler: function (ok, msg) {
						if (ok) {
							self.setFrontEndLocked(obj.is_locked);
						}
					},
					extra_handlers: obj,
				});
			} else {
				this.set("is_locked", obj.is_locked);
			}
		},

		/**
		 * Toggle the is_public setting of this category
		 *
		 * @param obj: the usual handlers are all that can be sent in
		 ***/
		toggleIsPublic: function (obj) {
			if (this.get("category_id") > 0) {
				cmty_ajax.add({
					a: "set_is_public",
					params: {
						category_id: this.get("category_id"),
						is_public: this.get("is_public") ? 0 : 1,
					},
					main_handler: function (ok, msg) {},
					extra_handlers: obj,
				});
			}
		},

		/**
		 * Set the has_source field on this category.
		 *
		 * @param obj
		 *		has_source : boolean
		 **/
		setHasSource: function (obj) {
			cmty_ajax.add({
				a: "set_has_source",
				params: {
					category_id: this.get("category_id"),
					has_source: obj.has_source ? 1 : 0,
				},
				main_handler: function (ok, msg) {},
			});
			this.set("has_source", obj.has_source);
		},

		/**
		 * In the category create/admin pages, the words
		 *  are a little different for different category types.
		 *  This gives a flag that we use in calling Community.Lang
		 *  to get language entries.
		 *
		 * @return string
		 **/
		getAdminLangType: function () {
			switch (this.get("category_type")) {
				case "forum":
				case "forum_class":
					return "forum";

				case "blog":
					return "blog";

				default:
					return "collection";
			}
		},

		/**
		 * Set one of the admin-only items for this category.
		 *  Currently only include_in_count, include_in_nothank,
		 *	include_in_thank.
		 *
		 * @param object
		 *		setting string
		 *		value int 0|1
		 **/
		setAdminItemSetting: function (obj) {
			cmty_ajax.add({
				a: "set_category_admin_item",
				params: {
					category_id: this.get("category_id"),
					setting: obj.setting,
					value: obj.value,
				},
				main_handler: function (ok, msg) {},
			});
		},

		/**
		 * Submit this category to the back end as a new category.
		 *
		 */
		burnNewCategory: function (obj) {
			var settings,
				blog_settings,
				self = this;

			// TODO : Error checking to block the submit
			settings = {
				category_type: this.get("category_type"),
				category_name: this.get("category_name"),
				short_description: this.get("short_description"),
				role_inheritance_parent:
					this.has("role_inheritance_parent") &&
					!_.isNull(this.get("role_inheritance_parent"))
						? parseInt(this.get("role_inheritance_parent").item_id)
						: 0,
				users: JSON.stringify(this.get("users")),
				//'containers' : JSON.stringify(this.get('container_model').get('items')),
				is_public: this.get("is_public") ? 1 : 0,
				is_locked: this.get("is_locked") ? 1 : 0,
				has_items: 0,
				has_source: this.get("has_source") ? 1 : 0,
			};

			if (this.get("category_type") === "blog") {
				blog_settings = {};
				_.each(
					[
						"show_profile_info",
						"show_stats",
						"show_shoutbox",
						"show_contributors",
						"show_tags",
						"blog_post_comment_text",
						"blog_comments_text",
						"blog_one_comment_text",
						"blog_no_comments_text",
					],
					function (setting) {
						var value = self.get(setting);

						if (typeof value === "boolean") {
							value = value ? 1 : 0;
						}
						blog_settings[setting] = value;
					}
				);
				settings.blog_settings = JSON.stringify(blog_settings);
				settings.is_primary_blog = self.get("is_primary_blog") ? 1 : 0;
			}

			if (this.get("items").length > 0) {
				settings.has_items = 1;
				settings.items = JSON.stringify(this.get("items"));
			}

			cmty_ajax.add({
				a: "build_new_category",
				params: settings,
				main_handler: function (ok, msg) {
					// Page reloads on build new category
				},
				extra_handlers: obj,
			});
		},

		/**
		 * Save basic descriptive data to database (from category admin)
		 *
		 * @param object
		 *		onFinish function optional
		 *		onError function optional
		 */
		saveCoreDataToDb: function (obj) {
			cmty_ajax.add({
				a: "save_core_data",
				params: {
					category_id: this.get("category_id"),
					category_name: this.get("category_name"),
					short_description: this.get("short_description"),
				},
				main_handler: function (ok, msg) {
					// All the action is in the extra handlers
				},
				extra_handlers: obj,
			});
		},

		removeInheritanceParent: function () {
			cmty_ajax.add({
				a: "remove_inheritance_parent",
				params: {
					category_id: this.get("category_id"),
				},
				main_handler: function (ok, msg) {},
			});
		},

		/**
		 * Set the category from which this category inherits roles.
		 *
		 * @param
		 *		parent_id int
		 *		onFinish, onError
		 **/
		setRoleInheritanceParent: function (obj) {
			cmty_ajax.add({
				a: "set_inheritance_parent",
				params: {
					category_id: this.get("category_id"),
					parent_id: obj.parent_id,
				},
				main_handler: function (ok, msg) {},
				extra_handlers: obj,
			});
		},

		/**
		 * Fetch data needed to administrate this category.
		 */
		fetchCategoryAdminData: function (obj) {
			var self = this;

			cmty_ajax.add({
				a: "fetch_category_admin_data",
				params: {
					category_id: this.get("category_id"),
					get_items: self.get("no_more_items") ? 0 : 1,
					start_item_num: this.get("items").length,
				},
				main_handler: function (ok, msg) {
					if (ok) {
						self.set("users", msg.response.users);

						// TODO : experiment with just setting 'items' to what comes back,
						//  rather than doing this.  Might make a mess out of views
						//  that need the trigger elsewhere.  Probably stay
						//  with this.
						if (msg.response.hasOwnProperty("items")) {
							_.each(msg.response.items, function (item) {
								self.addItem(item);
							});
						}
						if (msg.response.hasOwnProperty("containers")) {
							self.constructContainersModel(msg.response.containers);
						}

						if (msg.response.hasOwnProperty("role_inheritance_parent")) {
							self.set(
								"role_inheritance_parent",
								msg.response.role_inheritance_parent
							);
						}

						if (msg.response.hasOwnProperty("allowed_item_sort_types")) {
							self.set(
								"allowed_item_sort_types",
								msg.response.allowed_item_sort_types
							);
						}

						if (msg.response.hasOwnProperty("item_limit")) {
							self.set("item_limit", msg.response.item_limit);
						}

						if (self.get("category_type") === "forum_class") {
							if (msg.response.hasOwnProperty("class_id")) {
								self.set("class_id", msg.response.class_id);
							}
						}
					}
				},
				extra_handlers: obj,
			});
		},

		convertToContainer: function (overrides) {
			return _.extend(
				{
					category_id: this.get("category_id"),
					category_name: this.get("category_name"),
					short_description: this.get("short_description"),
					can_remove: 0,
					main_color: this.get("main_color"),
					secondary_color: this.get("secondary_color"),
				},
				overrides
			);
		},

		constructContainersModel: function (containers) {
			var items = _.map(containers, function (container) {
					return {
						item_id: container.category_id,
						item_forum_id: 0,
						item_type: "folder",
						item_text: container.category_name,
						item_subtitle: container.short_description,
						item_can_remove: container.can_remove,
						item_main_color: container.main_color,
						item_secondary_color: container.secondary_color,
					};
				}),
				container_model;

			container_model = new ComModels.ContainerHolder({
				category_id: this.get("category_id"),
				category_type: this.get("category_type"),
				category_name: this.get("category_name"),
				category: this,
				items: items,
			});

			this.set("container_model", container_model);
		},

		/**
		 * For folders and views, permission to add or delete an
		 *  item depends on whether or not the category itself is
		 *  locked.
		 **/
		canAddItem: function () {
			if (this.get("is_locked")) {
				return this.getPermission("c_can_override_lock");
			} else {
				return this.getPermission("c_can_add_item");
			}
		},

		canRemoveItem: function () {
			if (this.get("is_locked")) {
				return this.getPermission("c_can_override_lock");
			} else {
				return this.getPermission("c_can_remove_item");
			}
		},

		startUsersMonitoring: function () {
			var self = this;
			this.get("master").constructIntervalAjax({
				interval_monitor_model: this,
				interval_id_property: "forums_users_monitor",
				interval_property: "fetch_forum_users_interval",
				method: function () {
					self.fetchUsersData();
				},
			});
		},

		stopUsersMonitoring: function () {
			if (this.has("forums_users_monitor")) {
				clearTimeout(this.get("forums_users_monitor"));
			}
		},

		/**
		 * Update whether or not this category is in the global feed
		 *
		 * @param obj
		 *		new_setting int 0|1
		 **/
		updateGlobalFeedSetting: function (obj) {
			cmty_ajax.add({
				a: "change_cat_global_feed",
				params: {
					category_id: this.get("category_id"),
					new_setting: obj.new_setting,
				},
				main_handler: function (ok, msg) {
					// Page will reload on OK
				},
				extra_handlers: obj,
			});
		},

		delete: function (obj) {
			cmty_ajax.add({
				a: "delete_category",
				params: {
					category_id: this.get("category_id"),
					delete_type: obj.delete_type,
				},
				main_handler: function (ok, msg) {},
				extra_handlers: obj,
			});
		},
	});

	ComModels.CategoryMyForums = ComModels.Category.extend({
		defaults: _.defaults(
			{
				can_add_type: "forum",
				is_my_category: true,
				category_type: "my_forums",
			},
			ComModels.Category.prototype.defaults
		),

		initialize: function () {
			ComModels.Category.prototype.initialize.apply(this);
			if (this.get("master").get("current_user").get("is_new_user")) {
				this.set(
					"long_description",
					this.get("long_description") + Lang["new-user-my-forums"]
				);
			}
		},
	});

	ComModels.CategoryMyBlogs = ComModels.Category.extend({
		defaults: _.defaults(
			{
				can_add_type: "blog",
				is_my_category: true,
				category_type: "my_blogs",
			},
			ComModels.Category.prototype.defaults
		),

		initialize: function () {
			ComModels.Category.prototype.initialize.apply(this);
			if (this.get("master").get("current_user").get("is_new_user")) {
				this.set(
					"long_description",
					this.get("long_description") + Lang["new-user-my-blogs"]
				);
			}
		},
	});

	ComModels.CategoryMyCollections = ComModels.Category.extend({
		defaults: _.defaults(
			{
				can_add_type: "collection",
				is_my_category: true,
				category_type: "my_collections",
			},
			ComModels.Category.prototype.defaults
		),

		initialize: function () {
			ComModels.Category.prototype.initialize.apply(this);
			if (this.get("master").get("current_user").get("is_new_user")) {
				this.set(
					"long_description",
					this.get("long_description") + Lang["new-user-my-collections"]
				);
			}
		},
	});

	ComModels.CategoryViewPosts = ComModels.Category.extend({
		defaults: _.defaults(
			{
				category_type: "view_posts",
			},
			ComModels.Category.prototype.defaults
		),

		createViewPostItem: function (obj) {
			cmty_ajax.add({
				a: "create_view_posts_item",
				params: {
					category_id: this.get("category_id"),
					post_type: obj.post_type,
					post_label: obj.post_label,
					post_id: obj.post_id,
					hide_label: obj.hide_label,
					custom_text: obj.custom_text,
				},
				main_handler: function (ok, msg) {},
				extra_handlers: obj,
			});
		},
	});

	/**
	 * ComModels.CategoryWithTopics is an extension of ComModels.Category for any
	 *  category that holds topics (views and forums currently).
	 *
	 * Send in array topics_data of objects to initialize topics
	 *	in order to pre-populate category with topics
	 *
	 * Additional properties:
	 * active_topics : collection of the topics that have been loaded and should be visible
	 *   if this category is chosen.  (Sorted by last_post_time)
	 * all_topics_loaded : boolean have all the topics for this category been loaded
	 *
	 *
	 * TODO : Move creation of the posts collection into the initialize
	 *
	 *
	 *
	 * Triggered Methods
	 *
	 * onRemoveMasterTopic (topic)
	 *		When topic removed from master list, remove from this category
	 *
	 * onAddMasterTopic (topic)
	 *		When topic added to master list, see if we should add to this category's
	 *		active_topics
	 *
	 * Fetching Methods
	 *
	 * fetchTopics (options)
	 *		Fetches topics that satisfy the submitted options.
	 *
	 * Other Methods
	 *
	 * buildTopicsCollections ()
	 *		Constructs the active_topics collections initially.
	 *
	 * filterTopic(topic)
	 *		Check if the topic fits this category (usually overwritten by children)
	 *
	 * fetchFetchTopicParameters()
	 *  	Fetch the parameters used to get more topics for this category (usually overwritten)
	 *
	 */
	ComModels.CategoryWithTopics = ComModels.Category.extend({
		defaults: _.defaults(
			{
				all_topics_loaded: false,
				are_announcements_fetched: true,
				has_topics: true,
				show_announcements: false,
			},
			ComModels.Category.prototype.defaults
		),

		initialize: function () {
			var master_topics = this.get("master").get("topics");
			ComModels.Category.prototype.initialize.apply(this);
			this.buildTopicsCollections();
			this.listenTo(master_topics, "add", this.onAddMasterTopic);

			this.listenTo(master_topics, "remove", this.onRemoveMasterTopic);
		},

		/**
		 * onRemoveMasterTopic removes a topic from this category when the topic
		 *  is removed from the master topics collection.
		 *
		 * @param topic : ComModels.Topic of topic to remove
		 */
		onRemoveMasterTopic: function (topic, collection, extra_options) {
			this.get("active_topics").remove(topic, extra_options);
		},

		/**
		 * onAddMasterTopic is called automatically whenever a topic is
		 *  added to master's topics list, which happens whenever a topic is
		 *  loaded from the database.
		 *
		 * When we add the topic to the master's topics list, we pass an argument
		 *  'fetching_category' to identify what category made the call that fetched the
		 *  topic.  That category will add the topic to active_topics upon
		 *  fetching from the database.
		 *
		 *
		 * @param topic: topic object that is added
		 * @param master_list: list to which it is added (this is passed automatically to this function by
		 *   the watcher we're using to trigger this).
		 * @param options: options object we choose to pass on adding the topic (see this.fetchTopics())
		 *
		 * We add to active_topics if force_to_active is true, or if the last_post_time
		 *		of the topic is >= the last_post_time of the last topic in active_topics
		 *
		 * force_to_active is needed here for the following situation:
		 *  User navigates straight to page with a tag focus, thereby never
		 *   building the active_topics for that category.  New topics then come in.
		 *   There's no active_topics, so the post won't get added to active_topics,
		 *   and therefore the page with the tag focus will never get it, since it
		 *   will only add things that have been added to active_topics.  So,
		 *   we have to be able to add straight to active_topics.
		 *
		 */
		onAddMasterTopic: function (topic, master_list, options) {
			var active_topics = this.get("active_topics");

			if (
				(!options.hasOwnProperty("fetching_category") ||
					options.fetching_category != this.get("category_id")) &&
				this.filterTopic(topic)
			) {
				if (
					(options.hasOwnProperty("force_to_active") &&
						options.force_to_active) ||
					this.get("all_topics_loaded") || // Added for archiving private messages; not sure what effect it will have elsewhere!
					(active_topics.length > 0 &&
						-this.topicsComparator(topic) >=
							-this.topicsComparator(this.get("active_topics").last()))
				) {
					// ||
					this.get("active_topics").add(topic, options);
				}
				/*				if ((options.hasOwnProperty('force_to_active') && options.force_to_active)
					|| (active_topics.length > 0  && ((topic.get('last_post_time') >= this.get('active_topics').last().get('last_post_time'))))){// ||
					this.get('active_topics').add(topic, options);
				} */
			}
		},

		/**
		 * Create the object we'll pass to cmty_ajax.add to make the Ajax call
		 *  to fetch more topics.  We separate this from the Ajax call itself
		 *	so that we can aggregate this call with others in a run_multiple_ajax_calls
		 *	call.
		 *
		 * @param options: object describes what to go get.
		 *    category_id
		 *    tag_ids (array) if not null, then must have all tags.
		 *    fetch_before : only get topics from before this time
		 *	  calling_list (optional) : FilteredTopicList that triggered this fetch_topics call.
		 *			See documentation of FilteredTopicList.constructFetchMoreTopicsParams
		 *    onFinish function optional : fires when everything is loaded and processed
		 */
		constructFetchTopicsArguments: function (options) {
			var master_topics_collection = this.get("master").get("topics"),
				has_filtering =
					options.hasOwnProperty("tag_ids") && options.tag_ids.length > 0,
				new_topics = [],
				self = this,
				return_data = {};

			return_data.a = "fetch_topics";

			/**
			 * TODO : Consider fetching announcements only if unfiltered.
			 *  Probably a bad idea; imagine an Announcement that is AMC-specific.
			 *  We want that to load in a direct link to AMC.
			 **/
			return_data.params = _.defaults(
				{
					category_type: this.get("category_type"),
					/*
				pretty_print : true,
				queries : true,
				profiler : true,*/
					log_visit: this.get("visited") ? 0 : 1,
					required_tag: has_filtering
						? options.tag_ids[0].tag_forum_id + "_" + options.tag_ids[0].tag_id
						: "", // just supports one tag to filter by,
					fetch_before: options.fetch_before,
					user_id:
						this.get("category_type") === "priv" ? this.get("user_id") : 0,
					fetch_by_field: options.fetch_by_field,
					fetch_archived:
						this.get("is_private") && this.get("is_archive") ? 1 : 0,
					fetch_announcements: !this.get("are_announcements_fetched") ? 1 : 0,
				},
				this.fetchFetchTopicParameters()
			);

			this.set("visited", true);

			return_data.never_cancel =
				typeof options.never_cancel === "boolean"
					? options.never_cancel
					: false;

			if (options.hasOwnProperty("source")) {
				return_data.source = options.source;
			}
			return_data.main_handler = function (ok, msg) {
				var most_recent_normal_topic,
					most_recent_topic_time = Constants.very_large_time,
					calling_list;
				calling_list = options.hasOwnProperty("calling_list")
					? options.calling_list
					: {};
				if (ok) {
					msg = msg.response;
					if (has_filtering) {
						most_recent_normal_topic = self.get("active_topics").findWhere({
							announce_type: "none",
						});
						if (!_.isUndefined(most_recent_normal_topic)) {
							most_recent_topic_time =
								most_recent_normal_topic.get("last_post_time");
						}
					}
					self.set("are_announcements_fetched", true);
					// This bit of trickery is to get the PM notification to
					//  trigger on the most recent message, not the oldest message
					//  fetched on the initial feed load.
					if (self.get("is_private") && !self.get("is_archive")) {
						if (self.get("master").get("feed").get("on_initial_feed_fetch")) {
							msg.topics.reverse();
						}
					}

					_.each(msg.topics, function (topic) {
						var new_topic,
							add_to_active_topics = true,
							focus_post_id,
							focus_topic;

						if (self.get("is_post_search")) {
							focus_post_id = topic.focus_post_data.post_id;
							focus_topic = self.get("active_topics").findWhere({
								focus_post_id: focus_post_id,
							});

							if (!_.isUndefined(focus_topic)) {
								return;
							}

							topic.master = self.get("master");
							topic = self.get("master").checkLoadedTopicPermissions(topic);
							topic.search_settings = self.get("search_settings");
							topic.is_search_result = true;
							//topic.in_master_topics = false;
							new_topic = new ComModels.Topic(topic);
							self.get("active_topics").add(new_topic, {
								calling_list: calling_list,
							});
							new_topics.push(new_topic);
						} else {
							/**
							 * Check if we've already loaded the topic before...
							 */
							if (
								_.isNull(
									(new_topic = self
										.get("master")
										.fetchTopicById(parseInt(topic.topic_id)))
								)
							) {
								if (topic.category_id === self.get("category_id")) {
									topic.category = self;
								}
								topic.master = self.get("master");

								topic = self.get("master").checkLoadedTopicPermissions(topic);
								new_topic = new ComModels.Topic(topic);

								if (has_filtering) {
									// we are getting a particular tag here,
									// so we don't add this to the category's active_topics, but merely
									// add it to new_topics so that it is included in the filteredTopicList
									// for that filter.
									//
									// However, announcements for a category are loaded on any initial load
									// of the category.  So, if a user travels direct to a filtered list
									// (filtered by tag), some announcements will come back that we need
									// to peel off and add to active_topics rather than direct to that filtered
									// list.
									if (new_topic.get("announce_type") === "none") {
										new_topics.push(new_topic);
										if (
											new_topic.get("last_post_time") < most_recent_topic_time
										) {
											add_to_active_topics = false;
										} else {
											// Newer than most recent in this category.
											// Have to add to active topics for the category
											// This tackles the case of "User fetches topics for tag
											// that hasn't had any topics loaded yet.
											// System sends back a topic that has just been posted,
											// put hadn't been fetched by the fetch_new_topics
											// interval call.  This topic has to be added to
											// its forum, because it will just be ignored
											// when fetch_new_topics happens
										}
									} else {
										/**
										 * Any time a forum fetches topics for the first time,
										 *  its announcements will come back.  If these
										 *  announcements pass the filter for the calling_list,
										 *  then we need to
										 *  add them to that list.  Otherwise,
										 *  we ignore them for this list (but they'll get added
										 *  to the master list so they'll find their way to
										 *  their forum).
										 *
										 * This handles the case of direct-to-tag navigation
										 *  (forum not priorly loaded), both when the
										 *  announcement has that tag and when it doesn't.
										 *
										 * I pity the fool that has to debug this code when I am dead.
										 ***/
										if (calling_list.filter(new_topic)) {
											new_topics.push(new_topic);
										}
									}
								} else {
									new_topics.push(new_topic);
								}

								if (add_to_active_topics) {
									self.get("active_topics").add(new_topic, {
										calling_list: calling_list,
									});
								}

								// New topic has been retrieved; add to master list of
								//  topics.  There's a trigger on views and forums to
								//  check if new topics should be added to their active_topics.
								//  (See the onAddMasterTopic method.)
								//	We set the fetching_category to this category so that method
								//  will know it can ignore this topic.
								//  This allows us to take topics that are read by a
								//  view or forum and add them to other views or forums.

								master_topics_collection.add(new_topic, {
									fetching_category: self.get("category_id"),
								});
							} else {
								// We have loaded this topic before...
								if (self.get("category_type") === "user_search_topics") {
									new_topic.addParticipants(topic.participants);
								}

								// Add announcements immediately.  We can't use the 'calling_list' here
								// because announcements get filtered out of the new_topics (see note below),
								// so they won't get added on the front end by the bulk adder.  So we add them
								// manually here.
								if (new_topic.get("announce_type") !== "none") {
									self.get("active_topics").add(new_topic);
								} else if (!has_filtering) {
									// If we aren't filtering by tag, then this topic gets immediately
									//  added to this category's active_topics.

									self.get("active_topics").add(new_topic, {
										calling_list: calling_list,
									});
								}

								if (new_topic.get("category_id") !== topic.category_id) {
									new_topic.parsePotentialMove({
										new_category_id: topic.category_id,
										category_name: topic.category_name,
										category_main_color: topic.category_main_color,
										category_secondary_color: topic.category_secondary_color,
										can_read: true,
										extra_data: {
											calling_list: calling_list,
										},
									});
								}
								/**
								 * Don't automatically put announcements in new_topics,
								 *  because filtered fetches grab announcements, too, but
								 *  the announcements may not pass the filter.  The announcements
								 *  automatically get added to the forum's active_topics,
								 *  so they'll get added to the FilteredTopicList if they
								 *  pass the filter then (rather than here).
								 **/
								if (new_topic.get("announce_type") === "none") {
									new_topics.push(new_topic);
								}
							}
						}
					});
					/** Check if this category has finished loading all its topics.
					 Can only trigger if we are not filtering for tags. **/
					if (!has_filtering) {
						if (msg.no_more_topics) {
							self.set("all_topics_loaded", true);
						}
					}
					if (msg.hasOwnProperty("num_search_results")) {
						self.set(
							"num_posts_fetched",
							self.get("num_posts_fetched") + msg.num_search_results
						);
					}
					msg.topics_found =
						msg.hasOwnProperty("topics") &&
						!_.isNull(msg.topics) &&
						msg.topics.length > 0;
					msg.new_topics = new_topics;
				}
			};

			return_data.extra_handlers = options;

			return return_data;
		},

		/**
		 * fetchTopics gets more topics that satisfy a set of options.
		 *
		 * @param options: object describes what to go get.
		 *    category_id
		 *    tag_ids (array) if not null, then must have all tags.
		 *    fetch_before : only get topics from before this time
		 *    onFinish function optional : fires when everything is loaded and processed
		 *
		 *  There were a bunch more notes here before I ripped topic_queue out of the community models...
		 */
		fetchTopics: function (options) {
			cmty_ajax.add(this.constructFetchTopicsArguments(options));
		},

		/**
		 * buildTopicsCollections constructs the initial active_topics
		 *  collection for this category.
		 *
		 * The filterTopic function is defined in the children classes; the
		 *		filters are one of the fundamental differentiators between the children classes.
		 */
		buildTopicsCollections: function () {
			var self = this,
				permissions,
				active_topics;
			/**
			 * Go look at the master list of topics and see what fits in this category.
			 */
			this.set(
				"active_topics",
				new (Backbone.Collection.extend({
					model: ComModels.Topic,
				}))()
			);
			this.get("active_topics").comparator = this.topicsComparator;
			if (this.has("topics_data")) {
				active_topics = this.get("active_topics");
				if (self.get("category_type") === "blog") {
					permissions = this.get("permissions");
					_.each(this.get("topics_data"), function (topic) {
						topic.master = self.get("master");
						topic.permissions = permissions;
						active_topics.add(topic);
					});
				} else {
					if (
						self.get("category_type") === "forum" ||
						self.get("category_type") === "forum_class"
					) {
						permissions = this.get("permissions");
						_.each(this.get("topics_data"), function (topic) {
							topic.permissions = permissions;
						});
					}

					active_topics.add(
						self
							.get("master")
							.processPotentialNewTopics(this.get("topics_data"), false)
					);
				}

				/*_.each(this.get('topics_data'), function (topic) {
					if (self.get('category_type') === 'blog') {
						topic.master = self.get('master');
						topic.permissions = permissions;
//						active_topics.add(topic);
					} else {
						if (!topic.hasOwnProperty('permissions')) {
							topic.permissions = self.get('permissions');
						}
						topic.master = self.get('master');
						active_topics.add(topic.master.processPotentialNewTopics(cat_obj.topics_data, false));

					}
				});*/
				//			this.unset('topics_data');
			}
		},

		/**
		 * Function used to sort the topics in this category's active_topics.
		 *  Also used to sort the topics in any FilteredTopicList based on this category.
		 *
		 * @param ComModels.Topic
		 **/
		topicsComparator: function (topic) {
			// sort_value should only be set if someone is trying to manually control the order
			// of topics (like for office hours priority)
			if (topic.get("sort_value")) {
				return -topic.get("sort_value");
			}
			return -topic.get("last_post_time");
		},

		/**
		 * filterTopic tells whether or not the topic is in this category.
		 *  This should always be overwritten by the child classes, so the function
		 *  below should not be executed.
		 *
		 * @param ComModels.Topic
		 */
		filterTopic: function (topic) {
			return false;
		},

		/**
		 * fetchFetchTopicParameters the object parameters needed to fetch topics for this category.
		 *  Will be overwritten by most extensions.
		 */
		fetchFetchTopicParameters: function () {
			return {};
		},

		/**
		 *
		 * Get the 'fetch_before' value for a collection that is a filtering of this category.
		 *  For all non-blogs, we sort by last_post_time.
		 *
		 * @param Backbone.Collection of Topics in this category
		 * @return object
		 *  	value int the topic id to search before.
		 *
		 * Originally we passed a 'field' value (which was 'topic_id' here), but
		 *  we are handling determining the field on the back end.
		 *
		 * If this category shows announcements stapled to top, then it may have loaded
		 *  announcements and no regular topics yet.  In this case, we don't
		 *  want to set fetch_before to the last topic (we don't want to set it at all),
		 *  because there may be topics with later last_post_time that have not been
		 *  loaded (the announcements are loaded first).
		 *
		 * However, if the category does not show announcements (like the feed),
		 *  then the announcements are treated as regular topics (not loaded first), so it's OK
		 *  for the last fetched topic to be an announcement and to use its
		 *  last fetched model for its time.
		 **/
		getCollectionFetchBefore: function (collection) {
			var last_model, value;
			if (collection.length === 0) {
				value = 0;
			} else {
				last_model = collection.models[collection.length - 1];

				if (collection.category.get("is_post_search")) {
					value = last_model.get("focus_post").get("post_time");
				} else {
					if (
						last_model.get("announce_type") === "none" ||
						!this.get("show_announcements")
					) {
						value = last_model.get("last_post_time");
					} else {
						value = 0;
					}
				}
			}
			return {
				value: value,
			};
		},
	});

	/**
	 * ComModels.CategoryViewForums extends ComModels.CategoryWithTopics
	 *  for categories that are views of sets of forums.
	 *
	 * New properties
	 * forums_array : string of tags to use for fetching topics from the database.
	 *
	 * Methods:
	 *
	 * filterTopic (topic)
	 *		Checks if topic fits this view.
	 *
	 * fetchFetchTopicParameters ()
	 *		Fetch the parameters needed to fetch topics for this view.
	 *
	 */
	ComModels.CategoryViewForums = ComModels.CategoryWithTopics.extend({
		initialize: function () {
			// Build the string of tags that we use
			// to fetch topics for this view.
			this.buildForumsArray();

			this.set({
				category_type: "view_forums",
				hide_desc_on_phone: true,
				reset_on_items_change: true,
			});

			ComModels.CategoryWithTopics.prototype.initialize.apply(this);
			// TODO : loadForums on initialize
			// Need to do that after we have a query queue?

			this.listenTo(this, "item_added item_removed", this.onItemsChange);
		},

		/**
		 * filterTopic checks if the input topic fits in this category.
		 *
		 * @param ComModels.Topic
		 */
		filterTopic: function (topic) {
			return _.indexOf(this.get("forums_array"), topic.get("category_id")) > -1;
		},

		/**
		 * fetchFetchTopicParameters the object parameters needed to fetch topics for this particular
		 *  view.
		 */
		fetchFetchTopicParameters: function () {
			return {forums_string: this.get("forums_array").join(",")};
		},

		/**
		 * Construct the forums_array parameter from the items.
		 **/
		buildForumsArray: function () {
			this.set(
				"forums_array",
				_.map(this.get("items"), function (item) {
					return item.item_id;
				})
			);
		},

		/**
		 * When the items are changed (a forum is added or deleted),
		 *  we reset the topics collection and rebuild the forums_array.
		 *
		 * If we're really ambitious, we can try to rebuild the active_topics
		 *  to adjust for the added or removed forum, but that may be
		 *  more trouble than it's worth.  (Not terribly hard for forums or topics,
		 *  but will get tricky for ViewTags and for CategoryConglomerations.)
		 **/
		onItemsChange: function () {
			this.buildForumsArray();
			this.set("all_topics_loaded", false);
			this.get("active_topics").reset();
		},

		/**
		 * loadForums loads all the forums contained in this view.  First,
		 *  it checks the master categories collection for the forum,
		 *  then goes to the database for the missing forums.
		 *
		 */
		loadForums: function (obj) {
			var missing_categories = [],
				master_categories = this.get("master").get("categories"),
				category_obj,
				settings = arguments.length > 0 ? obj : {},
				self = this;

			_.each(this.get("forums_array"), function (forum_id) {
				// May need to put in limits for large views
				category_obj = master_categories.find(function (category) {
					return category.get("category_id") === forum_id;
				});
				if (_.isUndefined(category_obj)) {
					missing_categories.push(forum_id);
				}
			});

			if (missing_categories.length > 0) {
				cmty_ajax.add({
					a: "fetch_categories_data",
					params: {
						category_ids: JSON.stringify(missing_categories),
					},
					main_handler: function (ok, msg) {
						if (ok) {
							_.each(msg.categories, function (category) {
								self.get("master").constructNewCategory(category);
							});
							self.trigger("view_forums_loaded");
							self.set("forums_loaded", true);
						} else {
						}
					},
					extra_handlers: settings,
				});
			} else {
				this.trigger("view_forums_loaded");
				this.set("forums_loaded", true);
				if (settings.hasOwnProperty("onFinish")) {
					settings.onFinish();
				}
			}
		},
	});

	/**
	 * Category of bookmarked forums.  Essentially view_forums with
	 *  an extra flag set as a bookmark category.
	 */
	ComModels.CategoryBookmarkForums = ComModels.CategoryViewForums.extend({
		initialize: function () {
			ComModels.CategoryViewForums.prototype.initialize.apply(this);
			this.set("category_type", "bookmark_forums");
			this.set("is_bookmark_category", true);
			//	this.set('can_add', false);
		},
	});

	/**
	 * Category of bookmark categories.
	 */
	ComModels.CategoryMyBookmarks = ComModels.Category.extend({
		defaults: _.defaults(
			{
				no_more_items: true,
				category_type: "my_bookmarks",
				long_description: AoPS.Community.Lang["my-bookmarks-long-desc"],
			},
			ComModels.Category.prototype.defaults
		),
	});

	/**
	 *  Category of global topics.  That is, every topic is included
	 *   here.  Used for the global feed.
	 *
	 *  Extension of CategoryWithTopics
	 *
	 *  Properties (overwriting CategoryWithTopics properties):
	 *
	 *  Methods (overwriting CategoryWithTopics properties)
	 *  filterTopic(topic):
	 *      Filter a topic for this category.
	 *
	 * TODO: Add an 'excluded_forums' property that allows user to block
	 * certain fora.
	 */
	ComModels.CategoryGlobal = ComModels.CategoryWithTopics.extend({
		initialize: function () {
			ComModels.CategoryWithTopics.prototype.initialize.apply(this);
			this.set({
				category_type: "global",
			});

			if (
				!AoPS.Community.MasterModel.has("feed") ||
				AoPS.Community.MasterModel.get("feed").get("global_feed_type") ===
					"full"
			) {
				this.set("filter_topic_function", this.filterTopicFullFeed);
			} else {
				this.set("filter_topic_function", this.filterTopicCustomFeed);
				this.set(
					"global_feed_fora",
					AoPS.Community.MasterModel.get("feed").get("global_feed_fora")
				);
			}
		},

		/**
		 * At some point, we'll add a way to block certain topics from
		 *  getting added, to make this "Global minus".
		 *
		 * @param ComModels.Topic
		 */
		filterTopic: function (topic) {
			return this.get("filter_topic_function").apply(this, [topic]);
		},

		filterTopicFullFeed: function (topic) {
			return topic.get("topic_type") === "forum";
		},

		filterTopicCustomFeed: function (topic) {
			return (
				_.indexOf(this.get("global_feed_fora"), topic.get("category_id")) > -1
			);
		},
	});

	/**
	 * Category consisting of topics that a given user has posted in.
	 *
	 * Properties (In addition to those of CategoryWithTopics):
	 *
	 * user_id int : user_id of user we're watching
	 *
	 * Methods
	 * filterTopic (topic):
	 *     Filter a topic for this category
	 *
	 */
	ComModels.CategoryUsersTopics = ComModels.CategoryWithTopics.extend({
		initialize: function () {
			ComModels.CategoryWithTopics.prototype.initialize.apply(this);
			this.set({
				category_type: "user_search_topics",
			});
			if (!this.has("user_id")) {
				console.log(
					"You created a CategoryUsersTopics without specifying a user id.  Bad."
				);
			}

			// Add this user to the masters "watched users" category, so we know
			//  which participants to look for on topic updates.
			this.get("master").get("watched_users").push(this.get("user_id"));
		},

		/**
		 * Filter the topic to see if it fits in this category.
		 */
		filterTopic: function (topic) {
			return (
				topic.has("participants") &&
				topic.get("topic_type") === "forum" &&
				!_.isUndefined(
					_.findWhere(topic.get("participants"), {
						user_id: this.get("user_id"),
						removed: false,
					})
				)
			);
		},

		/**
		 * Parameters needed to fetch topics for this category.  (Overwrites
		 *  dummy function from CategoryWithTopics.
		 */
		fetchFetchTopicParameters: function () {
			return {
				fetched_user_id: this.get("user_id"),
			};
		},
	});

	/**
	 * Category of search results.
	 *
	 * Additional properties
	 *
	 * search_id int : id for searching the master 'searches' collection.
	 *
	 *
	 * The topics in a category that consists of search results are not part
	 *  of the master collections of topics.  In these categories, each Community
	 *  topic can appear multiple times, with distinct focus_post values.  (That is,
	 *  we create a distinct Topic model for each search result, even if multiple
	 *  results hit the same topic due to, say, the user posting multiple times in the
	 *  topic.)  This keeps the topic lists and router working properly.
	 */
	ComModels.CategorySearch = ComModels.CategoryWithTopics.extend({
		defaults: _.defaults(
			{
				category_name: Lang["Search-Results"],
				num_posts_fetched: 0, // Number of posts fetched from the server; not all passed forward due to perms
				is_post_search: true,
			},
			ComModels.CategoryWithTopics.prototype.defaults
		),

		initialize: function () {
			var master = this.get("master"),
				settings;
			if (this.has("search_settings")) {
				settings = this.get("search_settings");
				if (
					settings.hasOwnProperty("forums") &&
					settings.forums.length == 1 &&
					settings.forums[0] == Constants.private_messages_id
				) {
					this.set("category_name", Lang["private-search-results"]);
				}
			}

			ComModels.CategoryWithTopics.prototype.initialize.apply(this);

			master.get("search_categories").add(this);
			this.set("search_id", master.get("search_categories").length);

			this.listenTo(this.get("active_topics"), "add", this.onAddSearchTopic);
		},

		/**
		 * Whenever we add a topic to this collection, it is newly-created just for
		 *  this search, and is not part of master_topics.  Therefore, we flag it
		 *	as not a master_topics.  This is particularly important when the topic is updated,
		 *  say on a reply.  In that case, we don't want to do the "remove then re-add to master"
		 **/
		onAddSearchTopic: function (topic, collection, options) {
			topic.set("in_master_topics", false);
		},

		/**
		 * Function used to sort the topics in this category's active_topics.
		 *  Also used to sort the topics in any FilteredTopicList based on this category.
		 *
		 * @param ComModels.Topic
		 **/
		topicsComparator: function (topic) {
			return topic.get("search_id");
			//return -topic.get('focus_post').get('post_time');
		},

		onAddMasterTopic: function (topic) {
			return;
		},

		onRemoveMasterTopic: function (topic) {
			return;
		},

		/**
		 * Parameters needed to fetch topics for this category.  (Overwrites
		 *  dummy function from CategoryWithTopics.
		 */
		fetchFetchTopicParameters: function () {
			return {
				search_settings: JSON.stringify(this.get("search_settings")),
				start_search_id: this.get("num_posts_fetched"),
			};
		},

		/** We'll only test for inclusion in this category when searching for this category **/
		filterTopic: function () {
			return true;
		},
	});

	/**
	 * Category consisting of topics that a given user has posted in,
	 *	with one topic per post.
	 *
	 * Properties (In addition to those of CategoryWithTopics):
	 *
	 * user_id int : user_id of user we're watching
	 *
	 * Methods
	 * fetchFetchTopicParameters (topic):
	 *     How to fetch a topic for this category
	 *
	 * See CategorySearch above for more details about search-based categories.
	 **/
	ComModels.CategoryUsersPosts = ComModels.CategoryWithTopics.extend({
		initialize: function () {
			var user;
			this.set("is_post_search", true);

			ComModels.CategoryWithTopics.prototype.initialize.apply(this);

			if (!this.has("username")) {
				user = this.get("master").fetchUser(this.get("user_id"));
				if (!_.isUndefined(user)) {
					this.set("username", user.get("username"));
				}
			}

			if (this.has("username")) {
				this.set(
					"category_name",
					Utils.formatString(Lang["user-search-posts-category-username"], [
						this.get("username"),
					])
				);
			} else {
				this.set(
					"category_name",
					Utils.formatString(Lang["user-search-posts-category-user-id"], [
						this.get("user_id"),
					])
				);
			}

			this.listenTo(this.get("active_topics"), "add", this.onAddSearchTopic);
		},

		/**
		 * Whenever we add a topic to this collection, it is newly-created just for
		 *  this search, and is not part of master_topics.  Therefore, we flag it
		 *	as not a master_topics.  This is particularly important when the topic is updated,
		 *  say on a reply.  In that case, we don't want to do the "remove then re-add to master"
		 **/
		onAddSearchTopic: ComModels.CategorySearch.prototype.onAddSearchTopic,

		/**
		 * Function used to sort the topics in this category's active_topics.
		 *  Also used to sort the topics in any FilteredTopicList based on this category.
		 *
		 * @param ComModels.Topic
		 **/
		topicsComparator: function (topic) {
			return -topic.get("focus_post").get("post_time");
		},
		/**
		 * Filter the topic to see if it fits in this category.
		 */
		filterTopic: function (topic) {
			return (
				topic &&
				topic.has("focus_post") &&
				topic.get("focus_post").get("poster_id") === this.get("user_id")
			);
		},

		/**
		 * Parameters needed to fetch topics for this category.  (Overwrites
		 *  dummy function from CategoryWithTopics.
		 */
		fetchFetchTopicParameters: function () {
			return {
				fetched_user_id: this.get("user_id"),
			};
		},

		onAddMasterTopic: function (topic) {
			return;
		},

		onRemoveMasterTopic: function (topic) {
			return;
		},
	});

	/**
	 * Category consisting of multiple categories.
	 *
	 * Properties:
	 *
	 * categories array : Array of Category models that together make up this model
	 *
	 * Methods
	 *
	 * onAddTopic(topic)
	 *		What to do when a topic is added to this category (add to all the categories in the conglomeration)
	 *
	 * filterTopic (topic):
	 *     Filter a topic for this category
	 *
	 * fetchFetchTopicParameters()
	 *     Fetch the parameters needed to fetch topics for this category from the database.
	 *
	 * hasItems()
	 *  	Tells whether or not this category has any items at all.
	 *
	 */
	ComModels.CategoryConglomeration = ComModels.CategoryWithTopics.extend({
		initialize: function () {
			var self = this;
			ComModels.CategoryWithTopics.prototype.initialize.apply(this);
			this.set("category_type", "conglomeration");
			this.listenTo(this.get("active_topics"), "add", this.onAddTopic);

			_.each(this.get("categories"), function (category) {
				// Some categories need to have their topics reset when an
				//  item is added (views, bookmarks)
				if (category.get("reset_on_items_change")) {
					self.listenTo(
						category,
						"item_added item_removed",
						self.resetTopicsCollection
					);
				}
			});
		},

		resetTopicsCollection: function () {
			this.set("all_topics_loaded", false);
			this.get("active_topics").reset();
		},

		/**
		 * When a topic is added to this category, it gets added to all
		 *  of the categories that make up this CategoryConglomeration for which
		 *  the topic passes the category's filter.
		 *
		 * @param topic: Community.Models.Topic of topic that was just added to 'active_topics'
		 */
		onAddTopic: function (topic) {
			_.each(this.get("categories"), function (category) {
				if (category.filterTopic(topic)) {
					category.get("active_topics").add(topic);
				}
			});
		},

		/**
		 * See if a given topic fits in this category.
		 */
		filterTopic: function (topic) {
			var i,
				categories = this.get("categories"),
				max = categories.length;

			// todo: go through the categories and if any are hit, then it is in.
			for (i = 0; i < max; i++) {
				if (categories[i].filterTopic(topic)) {
					return true;
				}
			}
			return false;
		},

		/**
		 * Fetch the parameters used to fetch more topics for this conglomeration.
		 *
		 * Loop through the categories in the conglomeration and aggregate their settings.
		 *   Currently supports conglomerations of CategoryView and CategoryTopicList.
		 */
		fetchFetchTopicParameters: function () {
			var categories_data = [];

			_.each(this.get("categories"), function (category) {
				var cat_params = category.fetchFetchTopicParameters();
				cat_params.category_type = category.get("category_type");
				categories_data.push(cat_params);
			});

			return {
				categories_data: JSON.stringify(categories_data),
			};
		},

		/**
		 * If any category in this conglomeration has items, then this category has items.
		 *
		 * Overwrites a method in a parent class.
		 *
		 * @return boolean tells whether or not this conglomeration has items in any of its categories.
		 */
		hasItems: function () {
			var i,
				categories = this.get("categories"),
				max = categories.length;

			for (i = 0; i < max; i++) {
				if (categories[i].hasItems()) {
					return true;
				}
			}

			return false;
		},
	});

	/**
	 * A CategoryViewTopics is defined by a list of topic_id's.
	 *
	 *
	 * topic_ids array : Array of topic_ids that form this TopicList.
	 *
	 * Methods
	 * filterTopic (topic):
	 *     Filter a topic for this category
	 *
	 * fetchFetchTopicParameters():
	 *		Set the parameters used to fetch more topics for this category.
	 */
	ComModels.CategoryViewTopics = ComModels.CategoryWithTopics.extend({
		initialize: function () {
			/**
			 * Think a lot more about all this when we start making view_topic categories.
			 *  I don't think we'll be changing the items of a view_topics dynamically --
			 *  all the action is in the active_topics.
			 *  We don't need to reset the collection if something is added, since that something will go
			 *  straight into the topics if it supposed to and otherwise will get fetched when we scroll down further
			 *  in the view.
			 *
			 * If you decide to bring the commented-out lines below back, then you'll have to think more
			 *  about how to deal with the conglomerations in the feed so they don't reset upon
			 *  changes to bookmarked topics.
			 *
			 * If you delete these lines entirely, then delete the functions they call.
			 **/
			/*this.set({
			//	'reset_on_items_change' : true
			});
			this.listenTo(this, 'item_added item_removed', this.onItemsChange);
			this.buildTopicIds();
			*/
			ComModels.CategoryWithTopics.prototype.initialize.apply(this);
			this.set("category_type", "view_topics");
		},

		/**
		 * See if a given topic fits in this category.
		 *
		 * @param Community.Models.Topic
		 */
		filterTopic: function (topic) {
			return !_.isUndefined(
				this.get("active_topics").findWhere({
					topic_id: topic.get("topic_id"),
				})
			);
			//			return (this.get('topic_ids').indexOf(topic.get('topic_id')) > -1);
		},

		/**
		 * Fetch the parameters used to fetch more topics for this category.
		 */
		fetchFetchTopicParameters: function () {
			return {
				category_id: this.get("category_id"),
			};
		},

		/**
		 * When the items are changed (a topic is added or deleted),
		 *  we reset the topics collection and rebuild the topics_ids.
		 *
		 * Can probably pull this off without resetting active_topics like
		 *  this, but would require a bit of extra code to deal with adding
		 *  or removing the topic in question.  Would get much trickier for
		 *  Conglomerations that are on top of this View.  Probably not worth the effort.
		 **/
		onItemsChange: function () {
			/*this.buildTopicIds();
			this.set('all_topics_loaded', false);
			this.get('active_topics').reset();*/
			return;
		},
	});

	/**
	 * Category of bookmarked topics.  Essentially view_topics with
	 *  an extra flag set as a bookmark category, and with a different filter.
	 */
	ComModels.CategoryBookmarkTopics = ComModels.CategoryViewTopics.extend({
		initialize: function () {
			ComModels.CategoryViewTopics.prototype.initialize.apply(this);
			this.set("category_type", "bookmark_topics");
			this.set("is_bookmark_category", true);
		},

		filterTopic: function (topic) {
			return topic.get("is_bookmarked");
		},

		onItemsChange: function () {
			return;
		},
	});

	/**
	 * Category of topics in the feed.  Essentially view_topics with
	 *  an extra flag set as a bookmark category.
	 */
	ComModels.CategoryFeedTopics = ComModels.CategoryViewTopics.extend({
		initialize: function () {
			ComModels.CategoryViewTopics.prototype.initialize.apply(this);
			this.set("category_type", "feed_topics");
			this.set("is_bookmark_category", true);
		},

		filterTopic: function (topic) {
			return topic.get("in_feed");
		},

		hasItems: function () {
			return true;
		},

		onItemsChange: function () {
			return;
		},

		/**
		 * Fetch the parameters used to fetch more topics for this category.
		 */
		fetchFetchTopicParameters: function () {
			return {
				category_id: this.get("bookmark_topic_category_id"),
			};
		},
	});

	/*************
	 * ComModels.CategoryForum is an extension of CategoryWithTopics for categories that
	 * are forums.
	 *
	 * New Properties:
	 *
	 * Methods:
	 *
	 * filterTopic(topic)
	 *		Checks if the topic fits this category
	 *
	 * fetchFetchTopicParameters()
	 *		Fetch the parameters needed to get topics for this forum.
	 *
	 * addTag (tag)
	 *		Add a tag to this forum
	 *
	 * markAllTopicsRead()
	 * 		Mark all topics in this forum read.
	 *
	 * toggleBookmarkStatus()
	 *		Flip the bookmark status for this forum.
	 *
	 * Triggers
	 */
	ComModels.CategoryForum = ComModels.CategoryWithTopics.extend({
		defaults: _.defaults(
			{
				all_read: false,
				allow_autotag: true,
				are_announcements_fetched: false, // first fetch of topics in a forum will get announcements too
				can_start_topic: true,
				can_own_topics: true,
				can_mark_all_read: true,
				category_type: "forum",
				has_tag_filter: true,
				mark_time: 0,
				last_post_time: 0,
				is_forum: true,
				show_announcements: true,
			},
			ComModels.CategoryWithTopics.prototype.defaults
		),

		initialize: function () {
			var bookmarked_tags,
				self = this;

			ComModels.CategoryWithTopics.prototype.initialize.apply(this);

			this.set(
				this.get("master").fetchBookmarkStatus({
					item_id: this.get("category_id"),
					item_type: this.get("category_type"),
					item_forum_id: 0,
				})
			);
			if (AoPS.session.logged_in_and_initialized) {
				this.on(
					"change:mark_time change:last_post_time change:all_topics_loaded",
					this.parseMarkTime
				);
				this.listenTo(this.get("active_topics"), "add", this.onAddTopic);
				this.listenTo(
					this.get("active_topics"),
					"change:is_read",
					this.onTopicRead
				);
				this.parseMarkTime();
			}

			if (this.get("is_monitored") && this.getPermission("c_can_monitor")) {
				this.addMonitorTags();
			}

			/**
			 * Here we check for bookmarked tags in this forum, and move them to
			 *  the front of the list.
			 **/
			if (this.get("master").get("bookmarked_tag_category")) {
				bookmarked_tags = this.get("master").get("bookmarked_tag_category");
				_.each(bookmarked_tags.get("items"), function (item) {
					// We don't want to add the monitor tags here; they were already added,
					//  and with /open, /closed, /not_monitored.  That is, if
					//  we went ahead and pushed the bookmarked system tag to the front,
					//  we would replace /open with /open <forum name>, which is
					//  redundant sitting here in that forum's tag cloud
					if (
						item.item_forum_id === self.get("category_id") &&
						_.indexOf(Constants.monitoring_tag_id_array, item.item_id) == -1
					) {
						self.removeItem(item);
						self.addItem(item, {
							no_check_existing: true,
							add_to_front: true,
						});
					}
				});
			}

			if (this.get("show_announcements")) {
				this.get("active_topics").add(
					this.get("master").get("global_announcements").models
				);
			}

			if (this.get("category_type") === "forum_class") {
				this.set("can_remove_self", false);
			}
		},

		addMonitorTags: function () {
			var self = this,
				category_id = this.get("category_id"),
				main_color = this.get("main_color"),
				secondary_color = this.get("secondary_color");

			_.each(Constants.monitor_tags, function (tag) {
				self.addItem(
					{
						item_id: tag.item_id,
						item_type: "tag",
						item_forum_id: category_id,
						item_text: tag.item_text,
						item_subtitle: "",
						item_main_color: main_color,
						item_secondary_color: secondary_color,
					},
					{
						no_check_existing: true,
						add_to_front: true,
					}
				);
			});
		},

		/**
		 * Get tag dictionary for term-tag map.  Mainly a placeholder for the day when
		 *  we make custom dictionaries.
		 **/
		getTermTagDictionary: function () {
			return AoPS.Community.hasOwnProperty("term_tag_map")
				? AoPS.Community.term_tag_map
				: {};
		},

		/**
		 * Comparator function that is used for the topics collection for this category
		 *  and for any filteredTopicList that is built on this category.
		 *
		 * @param ComModels.Topic
		 * @return value for sorting the topic.
		 **/
		topicsComparator: function (topic) {
			return (
				-topic.get("last_post_time") - topic.get("announce_factor") * 1000000000
			);
		},

		/**
		 * When a topic is marked read, we want to check if we can set all as marked read.
		 *  However, we don't want to perform this check when we have clicked "Mark All Read",
		 *  since that will cause us to run this check many times in a row.  The check will be
		 *  triggered separately upon Mark All Read by a change in mark_time.
		 */
		onTopicRead: function () {
			if (arguments[2].hasOwnProperty("mark_all") && arguments[2].mark_all) {
				return;
			} else {
				this.parseMarkTime();
			}
		},

		/**
		 * Check if the category should be marked all_read or not.  We check both mark_time and
		 *  filter through the topics to make this determination.
		 */
		parseMarkTime: function () {
			if (this.get("mark_time") >= this.get("last_post_time")) {
				this.set("all_read", true);
			} else {
				this.set("all_read", false);
			}
		},

		/**
		 * Actions to take when a topic is added: check if we need to update the last_post_time,
		 *  then see if we need to change the mark time.
		 */
		onAddTopic: function (topic) {
			/** Reset last post time if this topic is more recent than category's last_post_time **/
			if (topic.get("last_post_time") > this.get("last_post_time")) {
				this.set("last_post_time", topic.get("last_post_time"));
			}

			/** If we grab an old topic that is unread and its mark time is before the mark_time
			    of this forum, then we need to reset the mark_time.  This is particularly necessary
				for when users are added to private conversations.  If it is expensive,
				we can just add this to the privates category.  It's probably useful in
				the case of moving topics around between categories. **/
			if (
				!topic.get("is_read") &&
				topic.get("last_post_time") < this.get("mark_time")
			) {
				this.set("mark_time", topic.get("last_post_time") - 1);
			}
		},

		/**
		 * filterTopic checks if the input topic fits in this category.
		 *
		 * @param ComModels.Topic
		 */
		filterTopic: function (topic) {
			return (
				topic.get("category_id") === this.get("category_id") ||
				(this.get("show_announcements") &&
					topic.get("announce_type") === "global")
			);
		},

		/**
		 * fetchFetchTopicParameters fetches the object parameters needed to
		 * fetch topics for this particular forum.
		 */
		fetchFetchTopicParameters: function () {
			return {
				category_id: this.get("category_id"),
			};
		},

		/**
		 * addTag adds a tag to this category, using parent addItem function (in
		 *   ComModels.Category
		 *
		 * @param obj:
		 *		tag_id int
		 *		tag_text text
		 */
		addTag: function (tag) {
			this.addItem({
				item_id: tag.tag_id,
				item_forum_id: this.get("category_id"),
				item_text: tag.tag_text,
				item_type: "tag",
				item_main_color: this.get("main_color"),
				item_secondary_color: this.get("secondary_color"),
			});
		},

		/**
		 * Mark all topics in this category read.
		 */
		markAllTopicsRead: function () {
			if (AoPS.session.logged_in_and_initialized) {
				cmty_ajax.add({
					a: "mark_forum_read",
					params: {
						category_id: this.get("category_id"),
					},
					main_handler: _.bind(function (ok, msg) {
						if (ok) {
							this.set("mark_time", msg.response.mark_time);
							this.get("active_topics").each(function (topic) {
								topic.set("is_read", true, {mark_all: true});
							});
						}
					}, this),
				});
			}
		},

		/**
		 * Toggle the bookmark status of this forum.
		 *
		 * @return boolean false if there are no bookmarks for topics for this user.
		 */
		setBookmarkState: function (state) {
			return this.get("master").setBookmarkState({
				state: state,
				category_string: "bookmarked_forum_category",
				bookmarked_item: this,
				item_id: this.get("category_id"),
				item_type: this.get("category_type"),
				item_text: this.get("category_name"),
				item_main_color: this.get("main_color"),
				item_secondary_color: this.get("secondary_color"),
				item_subtitle: this.get("short_description"),
			});
		},
	});

	ComModels.CategoryPriv = ComModels.CategoryForum.extend({
		defaults: _.defaults(
			{
				show_announcements: false,
				is_private: true,
				category_id: AoPS.Community.Constants.private_messages_id,
				category_type: "priv",
				has_tag_filter: true,
				are_announcements_fetched: true, // Say the announcements are fetched, so back end won't return them.
				is_archive: false,
			},
			ComModels.CategoryForum.prototype.defaults
		),

		initialize: function () {
			this.set("main_color", AoPS.Community.Constants.privates_main_color);
			this.set(
				"secondary_color",
				AoPS.Community.Constants.privates_secondary_color
			);
			this.set({
				category_name: this.get("username") + " Private Messages",
				category_type: "priv",
			});
			ComModels.CategoryForum.prototype.initialize.apply(this);

			// A couple little shortcuts
			//this.set('current_user', this.get('master').get('current_user'));
		},

		topicsComparator: function (topic) {
			return -topic.get("last_post_time");
		},

		/**
		 * filterTopic checks if the input topic fits in this category.
		 *
		 * @param ComModels.Topic
		 */
		filterTopic: function (topic) {
			var user_id;
			if (topic.get("category_id") !== Constants.private_messages_id) {
				return false;
			}
			user_id = this.get("user_id");
			return !_.isUndefined(
				_.findWhere(topic.get("participants"), {
					user_id: user_id,
				})
			);
		},
	});

	/**
	 * Category of Private Conversations, extends Category Forum.
	 *
	 * On the back end, we route some of the ajax calls based on
	 *  whether or not we are going after private conversations.
	 *
	 * This category assumes that we will never push forward
	 *    private conversations that are not intended for the logged in user.
	 *
	 */
	ComModels.CategoryPrivates = ComModels.CategoryForum.extend({
		defaults: _.defaults(
			{
				show_announcements: false,
				is_private: true,
				is_my_private: true,
				category_id: AoPS.Community.Constants.private_messages_id,
				category_status: "active",
				category_type: "my_privates",
				has_tag_filter: true,
				are_announcements_fetched: true, // Say the announcements are fetched, so back end won't return them.
				is_archive: false,
				pm_notification_open: false, // Is this the category of archived messages?
			},
			ComModels.CategoryForum.prototype.defaults
		),

		initialize: function () {
			this.set("main_color", AoPS.Community.Constants.privates_main_color);
			this.set(
				"secondary_color",
				AoPS.Community.Constants.privates_secondary_color
			);
			ComModels.CategoryForum.prototype.initialize.apply(this);

			// A couple little shortcuts
			this.set("current_user", this.get("master").get("current_user"));
			this.set("user_id", this.get("current_user").get("user_id"));

			if (!this.get("is_archive")) {
				this.setupLiveNotification();
				this.listenTo(
					this.get("current_user"),
					"change:pm_live_notify",
					this.setupLiveNotification
				);
			}
		},

		topicsComparator: function (topic) {
			return -topic.get("last_post_time");
		},

		/**
		 * filterTopic checks if the input topic fits in this category.
		 *
		 * @param ComModels.Topic
		 */
		filterTopic: function (topic) {
			return (
				topic.get("category_id") === this.get("category_id") &&
				topic.get("status") === this.get("category_status")
			);
		},

		/**
		 * Set up live notification for PMs based on the user's settings.
		 **/
		setupLiveNotification: function () {
			if (this.has("new_pm_notification")) {
				this.stopListening(
					this.get("active_topics"),
					"add",
					this.get("new_pm_notification")
				);
			}
			switch (this.get("current_user").get("pm_live_notify")) {
				case "modal":
				case "flyout":
					this.set(
						"new_pm_notification",
						this.listenTo(
							this.get("active_topics"),
							"add",
							this.notifyNewMessage
						)
					);
					break;
			}
		},

		/**
		 * Notification for a new private message.
		 *
		 * Won't stack modals, and won't stack flyouts for messages received
		 *  less than 5 seconds apart.
		 **/
		notifyNewMessage: function () {
			var topic = arguments[0],
				current_user = this.get("current_user"),
				self = this;
			if (
				topic.get("is_read") ||
				topic.get("last_poster_id") === this.get("user_id") ||
				this.get("pm_notification_open")
			) {
				return;
			}

			if (
				topic.get("last_post_time") < parseInt(AoPS.bootstrap_data.init_time) &&
				(!this.get("master").get("feed").get("on_initial_feed_fetch") ||
					!current_user.get("has_new_pm"))
			) {
				return;
			}

			this.set("pm_notification_open", true);
			current_user.set("has_new_pm", false);

			if (
				!AoPS.bootstrap_data.hasOwnProperty("in_academy") ||
				AoPS.bootstrap_data.in_academy == 0
			) {
				if (current_user.get("pm_live_notify") === "modal") {
					AoPS.Ui.Modal.showConfirm(
						Utils.formatString(Lang["pm-notify"], [
							topic.get("last_poster_name"),
							topic.get("topic_title"),
						]),
						function (ok) {
							if (ok) {
								if (
									typeof AoPS.router_root === "string" &&
									AoPS.router_root === "community"
								) {
									Backbone.history.navigate("/c1h" + topic.get("topic_id"), {
										trigger: true,
									});
								} else {
									window.location.href =
										"/community/c1h" + topic.get("topic_id");
								}
							}
						},
						{
							title: Lang["pm-notify-title"],
							width: "500px",
							confirm_button_ok: Lang["pm-notify-btn-OK"],
							confirm_button_cancel: Lang["pm-notify-btn-cancel"],
							onClose: function () {
								self.set("pm_notification_open", false);
							},
						}
					);
				} else {
					AoPS.Ui.Flyout.display(
						Utils.formatString(Lang["pm-notify-flyout"], [
							topic.get("last_poster_name"),
							topic.get("topic_title"),
							topic.get("topic_id"),
						])
					);
					setTimeout(function () {
						self.set("pm_notification_open", false);
					}, 5000);
				}
			}
			cmty_ajax.add({
				a: "set_profile_field",
				params: {
					user_id: current_user.get("user_id"),
					field: "has_new_pm",
					value: 0,
				},
				main_handler: function (ok, msg) {},
			});
		},

		fireNewMessageFlyout: function () {},

		/**
		 * Check if the inputted string is a valid username.
		 * Ajax returns object
		 *		is_valid_recipient boolean
		 *		is_admin 0|1
		 *		user_id 0|valid user id
		 *
		 * @param obj
		 *		username string
		 *		onFinish/onError
		 */
		checkValidPrivateRecipient: function (obj) {
			cmty_ajax.add({
				a: "check_valid_private_recipient",
				params: {
					username: obj.username,
				},
				main_handler: function (ok, msg) {}, //all the action is passed in
				extra_handlers: obj,
			});
		},
	});

	ComModels.CategoryBlog = ComModels.CategoryForum.extend({
		defaults: _.defaults(
			{
				all_read: false,
				allow_autotag: false,
				are_announcements_fetched: false, // first fetch of topics in a forum will get announcements too
				can_mark_all_read: true,
				can_start_topic: true,
				category_type: "blog",
				creator_location: "",
				last_post_time: 0,
				mark_time: 0,
				show_announcements: false,
				show_contributors: true,
				show_custom_block: true,
				show_profile_info: true,
				show_shoutbox: true,
				show_stats: true,
				show_tags: true,
			},
			ComModels.CategoryForum.prototype.defaults
		),

		initialize: function () {
			var self = this,
				shout_topic_data,
				field_default_pairs = [
					{
						field: "blog_post_comment_text",
						default_field: "blog-default-post-comments",
					},
					{
						field: "blog_comments_text",
						default_field: "blog-default-comments",
					},
					{
						field: "blog_one_comment_text",
						default_field: "blog-default-one-comment",
					},
					{
						field: "blog_no_comments_text",
						default_field: "blog-default-no-comments",
					},
				];

			ComModels.CategoryForum.prototype.initialize.apply(this);

			// Adopt default fields if empty strings sent from back end.
			_.each(field_default_pairs, function (pair) {
				if (!self.has(pair.field) || self.get(pair.field).length === 0) {
					self.set(pair.field, AoPS.Community.Lang[pair.default_field]);
				}
			});
			if (this.has("shout_topic_data")) {
				shout_topic_data = this.get("shout_topic_data");
				shout_topic_data.master = this.get("master");
				this.set(
					"shoutbox_topic",
					new AoPS.Community.Models.Shoutbox(shout_topic_data)
				);
				this.get("master").get("topics").add(this.get("shoutbox_topic"));
				//this.get('master').processPotentialNewTopic(this.get('shout_topic_data'), true));
			}
		},

		topicsComparator: function (topic) {
			return -topic.get("first_post_time");
		},

		/**
		 * Must be a blog_post and must be in this category.
		 **/
		filterTopic: function (topic) {
			return (
				topic.get("topic_type") === "blog_post" &&
				topic.get("category_id") === this.get("category_id")
			);
		},

		/**
		 * Get the 'fetch_before' value for a collection that is a filtering of this category.
		 *  For blogs, we sort by topic_id (as a proxy for first_post_time).
		 *
		 * @param Backbone.Collection of Topics in this category
		 * @return object
		 *  	value int the topic id to search before.
		 *
		 * Originally we passed a 'field' value (which was 'topic_id' here), but
		 *  we are handling determining the field on the back end.
		 */
		getCollectionFetchBefore: function (collection) {
			var value;

			if (collection.length === 0) {
				value = 0;
			} else {
				value = collection.models[collection.length - 1].get("first_post_time");
			}

			return {
				value: value,
			};
		},

		setBitBlogSetting: function (obj) {
			var self = this;
			this.set(obj.setting, obj.value);

			if (this.get("category_id") > 0) {
				cmty_ajax.add({
					a: "set_blog_bit_setting",
					params: {
						category_id: this.get("category_id"),
						setting: obj.setting,
						value: obj.value ? 1 : 0,
					},
					main_handler: function (ok, msg) {
						var user;

						if (ok) {
							if (obj.setting === "is_primary_blog") {
								user = self.get("master").get("current_user");
								user.set(
									"primary_blog_id",
									obj.value ? self.get("category_id") : 0
								);
								user.set(
									"primary_blog_name",
									obj.value ? self.get("category_name") : ""
								);
							}
						}
					},
					extra_handlers: obj,
				});
			}
		},

		setStringBlogSetting: function (obj) {
			this.set(obj.setting, obj.value);

			if (this.get("category_id") > 0) {
				cmty_ajax.add({
					a: "set_blog_string_setting",
					params: {
						category_id: this.get("category_id"),
						setting: obj.setting,
						value: obj.value,
					},
					main_handler: function (ok, msg) {
						// All the action is in the extra handlers.
					},
					extra_handlers: obj,
				});
			}
		},

		setNewCss: function (obj) {
			cmty_ajax.add({
				a: "set_blog_css",
				params: {
					category_id: this.get("category_id"),
					new_css: obj.new_css,
				},
				main_handler: function (ok, msg) {
					// All the action is in the extra handlers.
				},
				extra_handlers: obj,
			});
		},

		deleteCss: function (obj) {
			cmty_ajax.add({
				a: "delete_blog_css",
				params: {
					category_id: this.get("category_id"),
				},
				main_handler: function (ok, msg) {
					// All the action is in the extra handlers.
				},
				extra_handlers: obj,
			});
		},
	});

	/**
	 * ComModels.CategoryViewTags extends ComModels.CategoryWithTopics
	 *  for categories that are views of sets of tags.
	 *
	 * New properties
	 * tags_string : string of tags to use for fetching topics from the database.
	 *
	 * Methods:
	 *
	 * filterTopic (topic)
	 *		Checks if topic fits this view.
	 *
	 * fetchFetchTopicParameters ()
	 *		Fetch the parameters needed to fetch topics for this view.
	 *
	 */
	ComModels.CategoryViewTags = ComModels.CategoryWithTopics.extend({
		initialize: function () {
			this.buildTagsString();

			this.set({
				category_type: "view_tags",
				has_tag_filter: true,
				hide_desc_on_phone: true,
				reset_on_items_change: true,
			});

			ComModels.CategoryWithTopics.prototype.initialize.apply(this);
			// TODO : loadForums on initialize
			// Need to do that after we have a query queue?

			this.listenTo(this, "item_added item_removed", this.onItemsChange);
			// Only bring the line below back if we decide to go back with "remove topics
			//  from tag collections on tag changes in realtime"  That behavior could be really
			//  confusing
			//this.listenTo(this.get('active_topics'), 'change:tags', this.onTopicTagChange);
		},

		/**
		 * When the items are changed (a tag is added or deleted),
		 *  we reset the topics collection and rebuild the tags_string
		 **/
		onItemsChange: function () {
			this.buildTagsString();
			this.set("all_topics_loaded", false);
			this.get("active_topics").reset();
		},

		/**
		 * Categories can force a topic removal from their collections by triggering
		 *  force_remove_topic.
		 *
		 * This isn't used right now.  It was built to pull things out of
		 *  tag collections (and bookmarked tags) on the fly, but I'm not so sure
		 *  we want that behavior.  It could be really confusing to users.
		 ***/
		onTopicTagChange: function (topic) {
			if (!this.filterTopic(topic)) {
				this.get("active_topics").remove(topic, {
					removed_by: "topic_update",
				});
				this.trigger("force_remove_topic", {
					topic: topic,
				});
			}
		},

		/**
		 * Build the tags_string that is used to fetch topics for this
		 *  Category
		 **/
		buildTagsString: function () {
			// Build the string of tags that we use
			// to fetch topics for this view.
			this.set(
				"tags_string",
				_.map(this.get("items"), function (tag) {
					return '"' + tag.item_forum_id + "_" + tag.item_id + '"';
				}).toString()
			);
		},

		/**
		 * filterTopic checks if the input topic fits in this category.
		 *
		 * @param ComModels.Topic
		 */
		filterTopic: function (topic) {
			return topic.hasTagInArray(this.get("items"));
		},

		/**
		 * fetchFetchTopicParameters the object parameters needed to fetch topics for this particular
		 *  view.
		 */
		fetchFetchTopicParameters: function () {
			var params = {
				tags_string: this.get("tags_string"),
			};

			// In place for office hour monitoring
			if (_.contains(Constants.office_hours_ids, this.get("category_id"))) {
				params.category_id = this.get("category_id");
			}
			return params;
		},
	});

	/**
	 * Category of bookmarked tags.  Essentially view_tags with
	 *  an extra flag set as a bookmark category.
	 */
	ComModels.CategoryBookmarkTags = ComModels.CategoryViewTags.extend({
		initialize: function () {
			ComModels.CategoryViewTags.prototype.initialize.apply(this);
			this.set("category_type", "bookmark_tags");
			this.set("is_bookmark_category", true);
		},
	});
	/**
	 * ComModels.Topic is the model for a topic.
	 *
	 *
	 * Properties (for now; we'll want more):
	 * all_posts_fetched : false (Tells if we have all the posts)
	 * category : (optional) Community.Models.Category of the category topic is in
	 * 		Beware; 'category' may not be set if the Category hasn't been loaded
	 *		to the front end.
	 * category_id : category_id of the forum that the topic lives in
	 * category_name : Name of the forum that the topic is in
	 * category_main_color : Dark color of the topic's category
	 * category_secondary_color : Light color of the topic's category
	 * is_bookmarked : boolean for whether or not the topic is bookmarked
	 * is_watched : boolean for whether or not we are watching this topic (email notify)
	 * in_feed : boolean for whether or not this is in the feed.
	 * is_fetching_posts : boolean tells if we're loading right now.
	 * is_read : boolean, true if topic has been read.
	 * last_post_time (unrendered time, used for sorting)
	 * last_poster_name (username of last poster) //TODO ; make sure this is changing on update.
	 * is_restricted_soln : boolean tells if this is a solution topic
	 * last_update_time (unrendered time, used for monitoring)
	 * master: pointer to the master object.
	 * num_posts
	 * participants : array of user_ids of users who participate in this thread.
	 *   This array is not exhaustive; we only log the users that the viewer is watching.
	 *   (This may be changed to all users if we decide it's not too taxing on the server.)
	 * posts : Collection of ComModels.Post,
	 * realtime_monitor : setInterval process when there is realtime watching
	 * tags : Array of {tag_id, tag_text}
	 * tags_processed : have the topic's tags been processed/added to category parent list?
	 * topic_id
	 * topic_title
	 *
	 *
	 *
	 * Methods:
	 *
	 * addTag (tag_id, tag_text)
	 * 		Add a tag to this topic.
	 *
	 * deleteTagFromTagsArray (tag_id, tag_text)
	 *		Remove a tag from the tags array on this Community.Models.Topic (not database)
	 *
	 * removeTag (tag_id, tag_text)
	 *		Remove a tag from this topic (in database, and calls deleteTagFromTagsArray)
	 *
	 * hasTag (tag_id)
	 *		Checks if this topic has a certain tag (assumes tag has right forum_id).
	 *
	 * checkTopicUpdate()
	 * 		Checks if this topic has been updated
	 *
	 * processTopicUpdate(data)
	 * 		Process an update to a topic
	 *
	 * hasTagInArray (tag_array)
	 *		Checks if the topic has at least one tag that is in the submitted array
	 *
	 * setReadStatus (status, options)
	 *		Mark topic read or unread.  Optional argument for logging in the database
	 *
	 * toggleBookmarkStatus ()
	 *		Toggle the bookmark status for this topic.
	 *
	 * METHODS FOR POSTS
	 *
	 * fetchInitialPosts ()
	 *		Fetch the initial batch of posts we want for this topic when we first look at it.
	 *
	 * fetchMorePosts (options)
	 *		Fetch more posts for this topic
	 *
	 * checkAllPostsLoaded()
	 *		Check if, as of last update, the number of posts loaded equals the number
	 *		of posts we think this topic has (doesn't check the database for more recent).
	 *
	 * parseNewArrayOfPosts(post_array)
	 *		Check if the posts described in the array are new; add them if so.
	 *
	 * parsePotentialNewPost(post)
	 *		Check if this particular post is new.  Add it if so.  Return ComModels.Post
	 *
	 * checkPostLoaded (post_id)
	 *		Checks if the post with post_id is already loaded.
	 *
	 * checkPostLoadedBinarySearch (post_id, first, last, posts)
	 *		Binary search support function (will make a general one that replaces this)
	 *
	 *
	 * Triggers
	 *
	 * post_load_complete : A call for fetching more posts is finished (tell front to remove
	 *   	loader).
	 *
	 * tag_added : A tag has been added
	 * tag_removed : A tag has been removed
	 *
	 *
	 * TODO SOON : Decide if pass category object to topic.  That will probably
	 *   depend on whether or not we guarantee the category object is loaded.
	 *   If it is not, addTag will break.  Revisit addTag after making this call.
	 *   Currently, the category is added in the addTag function. (Note that addTag is
	 *   not needed in viewing topics in the feed, but it will be in views.  This
	 *   will probably be a problem?  Maybe we build te category upon
	 *   view of the topic.)
	 *
	 */
	ComModels.Topic = ComModels.Model.extend({
		defaults: {
			all_posts_fetched: false,
			announce_factor: 0,
			can_have_source: false,
			cat_can_target: false,
			deleted: false,
			force_add_to_category: null,
			has_initial_posts_loaded: false,
			//	in_feed : false,
			in_master_topics: true, // Topic models that get built via searches are not in the master topics collection
			//	is_bookmarked : false,
			is_feed_focus: false,
			is_fetching_past_posts: false, // true only for fetching old posts
			is_fetching_posts: false, // true when fetching old or new posts
			is_last_post_time_watched: false, // Is being watched by master for being on timer.
			is_master_focus: false,
			is_search_result: false,
			is_restricted_soln: false,
			//	is_watched : false,
			num_named_watchers: 0,
			num_watchers: 0,
			poll_id: 0,
			read_since_loading: false,
			source: "",
			stretch_category: null,
			tags_processed: false,
			watchers_usernames: "",
		},

		postsComparator: function (post) {
			return parseInt(post.get("post_id"));
		},

		initialize: function () {
			this.setDefault("tags", []);
			this.setDefault("participants", []);
			/**
			 * TODO : Think about how to order the tags on the topics.
			 *  One possibility is to have them match the order in the category array,
			 *   which is presumably by popularity.  Another is alphabetical, which
			 *   is probably expected.
			 */
			_.each(
				this.get("posts_data"),
				_.bind(function (post) {
					post.topic = this;
				}, this)
			);
			if (!this.has("poll_data")) {
				this.set("poll_data", {}); // can't set arrays or objects in defaults or they'll get shared!
			}

			if (this.has("focus_post_data")) {
				this.set("focus_post", new ComModels.Post(this.get("focus_post_data")));
				this.unset("focus_post_data");
				this.set("focus_post_id", this.get("focus_post").get("post_id"));
			}
			this.set(
				"posts",
				new (Backbone.Collection.extend({
					model: ComModels.Post,
					comparator: this.postsComparator /*function (post) {
							return parseInt(post.get('post_id'));
						}*/,
				}))(this.get("posts_data"))
			);

			if (this.get("master").get("is_stretch_class")) {
				this.get("posts").each(function (post) {
					post.set(
						"reported",
						AoPS.Stretch.Utils.isPostReported(post.get("post_id"))
					);
				});
			}

			/*	this.set(this.get('master').fetchBookmarkStatus({
				item_id : this.get('topic_id'),
				item_forum_id : 0,
				item_type : 'topic'
			}));
		*/
			if (this.get("posts").length > 0) {
				this.checkAllPostsLoaded();
			}
			this.parseLastPostTime();
			this.on("change:last_post_time", this.parseLastPostTime);
			this.get("master").checkAddToWatchTimes({
				time_data: {
					model: this,
					int_time_field: "first_post_time",
					rendered_time_field: "first_post_rendered_time",
				},
				is_already_watched: false,
			});

			this.set(
				"first_post_rendered_time",
				AoPS.Community.Utils.makePrettyTimeOldDateOnly(
					this.get("first_post_time")
				)
			);

			if (this.hasSolnTag()) {
				this.set("is_restricted_soln", true);
			}
		},

		isPrivateMessage: function () {
			return (
				this.get("category_id") === AoPS.Community.Constants.private_messages_id
			);
		},

		/**
		 * Is this topic in a class message board (a class community forum)?
		 **/
		isClassForum: function () {
			var category = this.get("master").fetchCategory(this.get("category_id"));
			return !!category && category.get("category_type") === "forum_class";
		},

		/**
		 * For a topic that is a search result, this fetches the search
		 *  string used to find this topic, based on the text_type submitted.
		 *
		 * @param string post_text|title|tags
		 **/
		fetchSearchText: function (text_type) {
			var settings;
			if (!this.has("search_settings")) {
				return "";
			}

			settings = this.get("search_settings");
			if (settings.hasOwnProperty("search_text")) {
				return settings.search_text;
			}
			if (settings.hasOwnProperty(text_type)) {
				return settings[text_type];
			}
			return "";
		},

		/**
		 * Parse the last post time to make a rendered time.
		 * Check if this topic needs to be on a timer. (Master holds a collection of topics
		 *  that need to be monitored for time changes.)
		 **/
		parseLastPostTime: function () {
			this.set(
				"is_last_post_time_watched",
				this.get("master").checkAddToWatchTimes({
					time_data: {
						model: this,
						int_time_field: "last_post_time",
						rendered_time_field: "last_post_rendered_time",
					},
					is_already_watched: this.get("is_last_post_time_watched"),
				})
			);

			this.set(
				"last_post_rendered_time",
				AoPS.Community.Utils.makePrettyTimeOldDateOnly(
					this.get("last_post_time")
				)
			);
		},

		/**
		 * Fetch the permission associated with the given key.
		 *
		 * @param key :
		 * TODO : Behavior if key is not set.
		 **/
		getPermission: function (key) {
			if (!this.has("permissions")) {
				console.log(
					"Permission sought before permissions set for category " +
						this.get("category_name")
				);
				return false;
			}
			if (_.isUndefined(this.get("permissions")[key])) {
				console.log(
					"Permissions have not been set for key " +
						key +
						" of Category " +
						this.get("category_name")
				);
			}

			return this.get("permissions")[key];
		},

		/**
		 * addNewTag adds a tag to the topic.
		 *
		 * @param int : tag_id.
		 * @param string : tag_text
		 *
		 * Currently does not do anything on the front end if the user does not have
		 *  permissions and the tag add fails.  (This should only happen if the user has
		 *  his/her permission revoked during a visit, so we're kinda teasing them by not
		 *  telling them they have lost permission.  That's fun.)
		 */
		addNewTag: function (tag_id, tag_text) {
			if (!this.has("category")) {
				// may just put this in initialize, but what if no category loaded?
				// If I put category in the object at initialize, then need to put change processTags in
				// master
				this.set(
					"category",
					this.get("master").fetchCategory(this.get("category_id"))
				);
			}

			cmty_ajax.add({
				a: "add_tag_to_topic",
				params: {
					topic_id: this.get("topic_id"),
					tag_id: tag_id,
					tag_text: tag_text,
				},
				main_handler: _.bind(function (ok, msg) {
					var data = msg.response;
					if (ok) {
						data = msg.response;
						this.get("tags").push(data.tag);
						if (!_.isUndefined(this.get("category"))) {
							this.get("category").addTag(data.tag);
						}
						this.trigger("tag_added", {
							topic: this,
						});
					}
				}, this),
			});
		},

		/**
		 * deleteTagFromTagsArray removes a tag from this Community.Models.Topic.
		 *
		 * @param int tag_id
		 * @param string tag_text
		 */
		deleteTagFromTagsArray: function (tag_id, tag_text) {
			var current_tags = this.get("tags");
			this.set(
				"tags",
				tag_id > 0
					? _.filter(current_tags, function (tag) {
							return tag.tag_id != tag_id;
						})
					: _.filter(current_tags, function (tag) {
							return tag.tag_text != tag_text;
						})
			);
		},

		/**
		 * removeTag takes a tag off a topic.
		 *
		 * @param int tag_id
		 * @param tag_text
		 *
		 * There's some trickery here.
		 *  We have to deal with the case in which a user types a tag
		 *  that isn't input via the autocomplete, and then immediately deletes it.
		 *  in this case, there's a server call out to add that tag, and right now
		 *  we think this tag has id = 0.  So, we can't yank it by ID.
		 *  Fortunately, this remove is behind the add in the Ajax queue, so
		 *  we send the id and the text to the server.  If the ID is 0,
		 *  then there must be an add in front of the remove.
		 *  So, we can find the new id, and remove from there.
		 *
		 *  Note that we remove the tag from the topic's tags array on the
		 *  client side prior to going to the database; this will help prevent
		 *  confusion on the user's part if the user finishes editing before
		 *  the server process completes.  If we didn't do this, there would
		 *  be a few seconds where the user didn't think the delete took effect.
		 *
		 * I imagine we might implement the tag box in a way that will make these
		 * machinations irrelevant.
		 */
		removeTag: function (tag_id, tag_text) {
			var current_tags = this.get("tags");

			this.deleteTagFromTagsArray(tag_id, tag_text);
			cmty_ajax.add({
				a: "remove_tag_from_topic",
				params: {
					topic_id: this.get("topic_id"),
					tag_id: tag_id,
					tag_text: tag_text,
				},
				main_handler: _.bind(function (ok, msg) {
					if (ok) {
						this.deleteTagFromTagsArray(tag_id, tag_text);
						this.trigger("tag_removed", {
							topic: this,
						});
					} else {
						// What is this?  Ah, if there's a fail, we
						//  want the front end to render right.
						this.set("tags", current_tags, {
							removed_by: "topic_update",
						});
					}
				}, this),
			});
		},

		/**
		 * hasTag checks if a given topic has a tag with a given tag_id.
		 *  Note: it does not check the topic's forum.  This assumes that
		 *  the tag_id is from the topic's forum space.
		 *
		 * @param tag_id int: id of the tag (not forum_id)
		 * @return boolean
		 */
		hasTag: function (tag_id) {
			var i,
				tags = this.get("tags");
			tag_id = parseInt(tag_id);
			for (i = tags.length - 1; i >= 0; i -= 1) {
				if (tags[i].tag_id === tag_id) {
					return true;
				}
			}
			return false;
		},

		hasSolnTag: function () {
			var regex = /\/class\/[a-zA-Z0-9-]+\/(hw|sol)([0-9]+)/gm;

			// Parse tag text and look for both the hw and the sol
			// tags.
			// HW Tag format: /class/{class-id}-{course-id}/hw{problem-id}
			// Sol Tag format: /class/{class-id}/sol{problem-id}

			// If this topic has both, we can assume that this
			// is a restricted solution topic.

			return (
				_.map(this.get("tags"), function (tag) {
					var m = regex.exec(tag.tag_text);
					if (m) {
						return m[1];
					}
					return false;
				}).filter(function (val) {
					return val;
				}).length === 2
			);
		},

		/**
		 * startRealtimePostMonitor launches the regular watching of this topic
		 *  for changes.
		 *
		 * @param object
		 *		source
		 *		hash
		 */
		startRealtimePostMonitor: function (obj) {
			var self = this;
			var last_post_time = this.get("last_post_time");
			var last_topic_fetch_time = this.get("master").get(
				"last_topic_fetch_time"
			);
			var seconds_delta = last_topic_fetch_time - last_post_time;
			var old_topic = seconds_delta > Constants.old_topic_age_in_seconds;

			this.get("master").constructIntervalAjax({
				interval_monitor_model: this,
				interval_id_property: "realtime_monitor" + obj.source + obj.hash,
				interval_property: old_topic
					? "topic_update_interval_long"
					: "topic_update_interval",
				method: function () {
					self.checkTopicUpdate(obj);
				},
			});

			if (old_topic) {
				this.set(
					"post_monitor_id",
					this.listenTo(this, "change:last_post_time", function () {
						self.resetPostMonitor(obj);
					})
				);
			}
		},

		/**
		 * If we start the post monitor on an old topic, we need to watch to see
		 *  if there are any replies while we're watching.  If there are, then we speed
		 *  up the post monitor by stopping and restarting it.  This allows us
		 *  to reduce server hits by slowing down the realtime checking on topics
		 *  that are less likely to have changes.
		 *
		 * TODO: Consider slowing down even more.
		 *
		 * @param object
		 *		source
		 *		hash
		 **/
		resetPostMonitor: function (obj) {
			this.stopRealtimePostMonitor(obj);
			this.startRealtimePostMonitor(obj);
		},

		/**
		 * stopRealtimePostMonitor stops the regular watching of this topic
		 *  for changes.
		 *
		 * @param object
		 *		source
		 *		hash
		 */
		stopRealtimePostMonitor: function (obj) {
			clearTimeout(this.get("realtime_monitor" + obj.source + obj.hash));
			if (this.has("post_monitor_id")) {
				this.stopListening(this.get("post_monitor_id"));
				this.unset("post_monitor_id");
			}
			/*	clearInterval(this.get('realtime_monitor' + obj.source + obj.hash));*/
			this.unset("realtime_monitor" + obj.source + obj.hash);
		},

		/**
		 * In most topics, the posts are loaded in forwards order.  This gets
		 *  overwritten in ComModels.Shoutbox, where posts are in the reverse order.
		 **/
		fetchLastLoadedPostNumber: function () {
			return this.get("posts").last().get("post_number");
		},

		/**
		 * checkTopicUpdate checks if this topic has been updated in the database.
		 *
		 * Gets skipped if there's anything in the Ajax queue; only intended
		 * 	to be used in the cron that makes the topic feel realtime.
		 */
		checkTopicUpdate: function (obj) {
			if (!this.get("is_fetching_posts")) {
				this.set("is_fetching_posts", true);
				cmty_ajax.add({
					a: "fetch_topic_update",
					params: {
						topic_id: this.get("topic_id"),
						last_post_num: this.fetchLastLoadedPostNumber(), //this.get('num_posts'),
						last_update_time: this.get("last_posts_update_time"),
						hash: obj.hash,
						source: obj.source,
					},
					main_handler: _.bind(function (ok, msg) {
						if (ok) {
							this.onFinishTopicUpdateAjax(msg.response);
						} else {
							// What else might we want to do?
							this.set("is_fetching_posts", false);
						}
					}, this),
					queue_limit: 0, // (If anything in the queue, skip this).
				});
			}
		},

		/**
		 * Process the result when we get a topic_update via Ajax.  May get called
		 *  directly from the checkTopicUpdate above, or when there is a change of topic.
		 **/
		onFinishTopicUpdateAjax: function (data) {
			if (data.new_data) {
				this.processTopicUpdate(data);
				this.set("last_posts_update_time", data.last_posts_update_time);
			} else {
				// On every topic update, we at least go get the watchers
				//  data.
				this.set({
					num_watchers: data.num_watchers,
					num_named_watchers: data.num_named_watchers,
					watchers_usernames: data.watchers_usernames,
					watchers_avatars: data.watchers_avatars,
					num_views: data.num_views,
				});
				if (data.hasOwnProperty("poll_data")) {
					this.set("poll_data", data.poll_data);
				}
			}
			this.set("is_fetching_posts", false);
			this.set("is_fetching_past_posts", false);
		},

		/**
		 * processTopicUpdate processes an update to the topic
		 *
		 * @param obj : with following properties
		 *		last_update_time
		 *		last_post_time
		 *		num_posts
		 *		is_read
		 *		posts_data (array of post_data used to create new post objects)
		 *		tags (new tags array).
		 *
		 * This is where some magic happens: when a topic has new posts,
		 *  we remove then add the topic to the master list.  This gets it filtered
		 *  through everything as if it had just been added.
		 *  That puts it in the right place in TopicLists, etc.  We may need additional
		 *	 magic for dealing with changes on the front end.
		 *
		 * TODO : Add change of category
		 */
		processTopicUpdate: function (data) {
			var category,
				refilter_topic = false,
				is_read_parsed = false,
				new_settings = {},
				self = this;

			this.set("last_update_time", data.last_update_time);

			/**
			 * If a topic is updated while I am reading it, then we
			 *  need to flag it as read now.
			 **/
			if (this.get("master").get("focus_topic") === this) {
				this.set("read", true);
				is_read_parsed = true;
			}
			if (
				this.get("master").has("feed") &&
				this.get("master").get("feed").get("focus_topic") === this
			) {
				this.set("read", true);
				is_read_parsed = true;
			}

			/**
			 * If we're on the topic right now, we want to override what comes
			 *  from the back end.
			 **/
			if (!is_read_parsed) {
				this.set("is_read", data.is_read);
			}

			/**
			 * If the last poster name or time have changed,
			 *  then there is a new post here, and the topic list topic
			 *  should be re-rendered.  (Checking both of these defends
			 *  against all sorts of combinations of deletions and replies
			 *  happening that might confound simpler checks.
			 **/
			if (
				this.get("last_post_time") != data.last_post_time ||
				this.get("last_poster_name") != data.last_poster_name
			) {
				refilter_topic = true;
			}

			if (this.get("topic_type") == "private") {
				this.set("status", data.status);
			}

			if (data.hasOwnProperty("announce_type")) {
				if (this.get("announce_type") != data.announce_type) {
					this.set({
						announce_type: data.announce_type,
						announce_factor: data.announce_factor,
					});
					refilter_topic = true;
				}
			}

			// Hacky way of fixing filter for office hours. Fixes T61917.
			// Office hours will break if we refilter because the topic will not
			// be re-addded in because of the filter check on add.
			if (AoPS.bd && AoPS.bd.mode && AoPS.bd.mode === "office_hours") {
				refilter_topic = false;
			}

			/*
			if (data.hasOwnProperty('poll_data')) {
				this.set('poll_data', data.poll_data);
			}

			if (data.hasOwnProperty('topic_title')) {
				this.set('topic_title', data.topic_title);
			}

			if (data.hasOwnProperty('source')) {
				this.set('source', data.source);
			}

			if (data.hasOwnProperty('preview')) {
				this.set({
					preview : data.preview
				});
			}



			// Must set the number of posts prior to parsing new,
			//  since as part of the parsing of new posts, we access the
			//  num_posts variable (when deciding whether or not the new
			//  post is show_from_start).
			this.set({
				'num_posts' : data.num_posts,
				'last_poster_name' : data.last_poster_name,
				'last_post_id' : data.last_post_id,
				'last_poster_id' : data.last_poster_id,
				'last_post_time' : data.last_post_time,
				'last_poster_avatar' : data.last_poster_avatar,
				'num_reports' : data.num_reports,
				'locked' : data.locked,
				'state' : data.state
			});*/

			_.each(
				[
					"poll_data",
					"topic_title",
					"source",
					"preview",
					"num_posts",
					"last_poster_name",
					"last_post_id",
					"last_poster_id",
					"last_post_time",
					"last_poster_avatar",
					"num_reports",
					"locked",
					"target_url",
					"target_text",
					"state",
				],
				function (property) {
					if (data.hasOwnProperty(property)) {
						new_settings[property] = data[property];
					}
				}
			);

			this.set(new_settings);

			// Data updates for individual posts are handled separately from
			//  adding new posts and from updating topics data.
			//  When a topic update occurs via this.checkTopicUpdate above,
			//  we also check for updated posts.  We process those here, and
			//  process potentially new posts separately.
			if (
				data.hasOwnProperty("updated_posts") &&
				data.updated_posts.length > 0
			) {
				_.each(data.updated_posts, function (updated_post) {
					self.parseEditedPost(updated_post);
				});
			}

			// Here we process potentially new posts.
			if (data.hasOwnProperty("posts_data") && data.posts_data.length > 0) {
				if (this.parseNewArrayOfPosts(data.posts_data)) {
					// Don't need something here yet, but maybe someday we will ?
					//  This is where we will say, "HEY, NEW POSTS CAME IN".
					//  But listening to posts will do that.
				}
			}
			if (data.hasOwnProperty("category_num_posts")) {
				category = this.get("master").fetchCategory(this.get("category_id"));
				if (!_.isUndefined(category)) {
					category.set("num_posts", data.category_num_posts);
				}
			}

			// TODO : Think a lot about whether this is correct...
			//  And get it to re-render on the private message view on change
			// This must happen before the remove/add so
			//  that filters watching participants will operate correctly.
			if (data.hasOwnProperty("participants")) {
				this.addParticipants(data.participants);
			}

			if (data.hasOwnProperty("permissions")) {
				this.set("permissions", data.permissions);
			}
			if (data.hasOwnProperty("num_watchers")) {
				this.set({
					num_watchers: data.num_watchers,
					num_named_watchers: data.num_named_watchers,
					watchers_usernames: data.watchers_usernames,
					watchers_avatars: data.watchers_avatars,
					num_views: data.num_views,
				});
			}

			/**
			 * See the documentation throughout Community.Models.FilteredTopicList for how
			 *  we deal with tag changes affecting what shows where.
			 **/
			if (data.hasOwnProperty("tags")) {
				this.checkTagsChanged(data.tags);
			}

			if (refilter_topic && this.get("in_master_topics")) {
				// We mark the source of removal and the add to the master topics list so that
				//  we can check down the line for how this topic was added/removed.
				//  We want to know this in the TopicList Views so that we know how
				//  to handle the given topic if it is on-screen.  See TopicsList.onAddTopicAfterLoad for details.
				this.get("master").get("topics").remove(this, {
					removed_by: "topic_update",
				});
				this.get("master").get("topics").add(this, {
					added_by: "topic_update",
				});
			}

			if (this.get("all_posts_fetched")) {
				if (this.get("num_posts") > this.get("posts").length) {
					this.set("all_posts_fetched", false);
				} else if (
					this.get("last_post_id") > this.get("posts").last().get("post_id")
				) {
					this.set("all_posts_fetched", false);
				}
			}
		},

		/**
		 * Set the tags to the submitted new_tags.  Check if the new_tags have
		 *  any tags the topic didn't already have, and trigger tag_added if so.
		 *	Check if the old tags have any tags that aren't in new_tags, and
		 *	trigger tags_removed if so.
		 *
		 * @param array of tags.
		 */
		checkTagsChanged: function (new_tags) {
			var old_tags = this.get("tags"),
				tags_added = true;

			tags_added = this.checkArrayForNewTags(new_tags);

			this.set("tags", new_tags);

			if (tags_added) {
				this.trigger("tag_added", {
					topic: this,
				});
			}

			// If there are tags among the old tags that aren't among the
			//  tags now, then there were some removed.   Trigger filter accordingly.
			if (this.checkArrayForNewTags(old_tags)) {
				this.trigger("tag_removed", {
					topic: this,
				});
			}
		},

		/**
		 * Compare the input array of tags to the tags on this topic.
		 * Return true if the input array has any tags that aren't on the topic.
		 * Return false otherwise.
		 *
		 * @param array of tags.
		 */
		checkArrayForNewTags: function (tag_array) {
			var i,
				max = tag_array.length;

			if (tag_array.length > this.get("tags").length) {
				return true;
			}

			for (i = 0; i < max; i++) {
				if (
					tag_array[i].item_forum_id === this.get("category_id") &&
					!this.hasTag(tag_array[i].item_id)
				) {
					return true;
				}
			}

			return false;
		},

		/**
		 * hasTagInArray searches an array of tags to see if the topic has any of the tags
		 *  in the array.  We must match the forum_id and the tag_id of the tags.
		 *  (This function checks the tag_id and the category_id)
		 *
		 * Used to filter topics for views.
		 *
		 * @param tag_array: array of objects {item_id, item_forum_id}
		 *	(objects may have other properties, but these two are required).
		 * @return boolean
		 */
		hasTagInArray: function (tag_array) {
			var i,
				max = tag_array.length;

			for (i = 0; i < max; i++) {
				if (
					tag_array[i].item_forum_id === this.get("category_id") &&
					this.hasTag(tag_array[i].item_id)
				) {
					return true;
				}
			}

			return false;
		},

		/**
		 *
		 * @param obj : Explains what settings the back end should fiddle with
		 *		set_mark boolean : true if mark this topic read, false to do nothing
		 * 		update_watcher boolean : true if we need to set the watcher (only on first load)
		 *		increment_views boolean : true if we should increment the view counter (only on topic loads)
		 *		hash int : code to track this particular watcher on the back end.
		 *		source string : Where this topic is being read ('feed' or 'master'), so
		 *			we can track these separately for counting and for marking where people are.
		 *
		 **/
		onReadTopic: function (obj) {
			this.set("is_read", true);
		},

		/**
		 * Set the topic state.
		 *
		 * @param object
		 * 		state string
		 **/
		setState: function (obj) {
			var self = this;
			if (obj.state == this.get("state")) {
				return;
			}

			// Shuffle the tags appropriately.
			this.deleteTagFromTagsArray(0, "/" + this.get("state"));
			this.get("tags").push({
				tag_id: Constants.monitored_topic_tag_ids[obj.state],
				tag_text: "/" + obj.state,
				is_visible: false,
			});
			this.trigger("tag_removed", {
				topic: this,
			});
			this.trigger("tag_added", {
				topic: this,
			});

			var old_state = this.get("state");
			this.set("state", obj.state);

			if (this.has("set_state_timeout")) {
				clearTimeout(this.get("set_state_timeout"));
			}
			this.set(
				"set_state_timeout",
				setTimeout(function () {
					cmty_ajax.add({
						a: "set_topic_state",
						params: {
							topic_id: self.get("topic_id"),
							state: obj.state,
						},
						main_handler: function (ok, msg) {
							// If set topic state fails, lets log it for further
							// investigation regarding T24918
							if (!ok) {
								console.error(
									"E_CMTY_SET_STATE_FAILED",
									"Failed to update topic state.",
									{
										error_code: msg.error_code,
										old_state: old_state,
										new_state: obj.state,
										topic_id: self.get("topic_id"),
									}
								);
								self.set("state", old_state);
							}
						},
						// Disable canceling to try and resolve T24918
						never_cancel: true,
						// Disable filtering to try and resolve T24918
						extra_ajax_runner_options: {
							no_filter: true,
						},
					});
				}, 600)
			);
		},

		/**
		 * Set my cmty_topic_participants status (for the currently logged-in user)
		 *
		 * @param obj :
		 *		status string archived|active|removed
		 *		onFinish function optional
		 **/
		setMyStatus: function (obj) {
			var master = this.get("master");

			cmty_ajax.add({
				a: "set_participant_status",
				params: {
					topic_id: this.get("topic_id"),
					status: obj.status,
				},
				main_handler: function (ok, msg) {},
				never_cancel: true,
				extra_handlers: obj,
			});

			if (this.isPrivateMessage()) {
				master.get("topics").remove(this);
				if (obj.status === "removed") {
					this.destroy();
				} else {
					this.set("status", obj.status);
					master.get("topics").add(this);
				}
			} else {
				_.each(this.get("participants"), function (user) {
					if (user.user_id === AoPS.session.user_id) {
						user.removed = obj.status === "removed";
					}
				});
			}
		},

		/**
		 * Toggle the bookmark status of this topic.
		 *
		 * @return boolean false if there are no bookmarks for topics for this user.
		 */
		setBookmarkState: function (state) {
			return this.get("master").setBookmarkState({
				state: state,
				category_string: "bookmarked_topic_category",
				bookmarked_item: this,
				item_id: this.get("topic_id"),
				item_type: "topic",
				item_text: "",
			});
		},

		resetBookmarkState: function (state) {
			var self = this;
			this.get("master").setBookmarkState({
				state: {
					is_bookmarked: false,
					in_feed: false,
					is_watched: false,
				},
				category_string: "bookmarked_topic_category",
				bookmarked_item: this,
				item_id: this.get("topic_id"),
				item_type: "topic",
				item_text: "",
				onFinish: function () {
					self.setBookmarkState(state);
				},
			});
		},

		/**
		 * Process the result of an initial post fetch.
		 */
		processInitialPostFetch: function (data) {
			var self = this,
				is_stretch_class = this.get("master").get("is_stretch_class");
			_.each(data.posts, function (post) {
				post.topic = self;
				if (is_stretch_class) {
					post.reported = AoPS.Stretch.Utils.isPostReported(post.post_id);
				}
			});
			this.get("posts").add(data.posts);
			if (data.hasOwnProperty("participants")) {
				this.set("participants", data.participants);
			}
			if (data.hasOwnProperty("permissions")) {
				this.set("permissions", data.permissions);
			}
			this.set("last_posts_update_time", data.initialization_time);

			this.checkTagsChanged(data.tags);
			this.set(data.data_to_set_direct_on_topic);
			// Must come after setting data direct on topic
			this.checkAllPostsLoaded();
			this.set("is_fetching_posts", false);
			this.set("is_fetching_past_posts", false);

			// Must come after "is_fetching_posts" is set to false
			this.trigger("post_load_complete");
		},

		/**
		 * fetchMorePosts fetches posts for this topic.
		 *
		 * @param options: object that describes what to fetch
		 *     start_post_id : post_id of the starting point
		 *	   start_post_num : post_num of the starting point
		 *     direction: 'forwards' to go forward from the start_post_number
		 *                'backwards' to go backwards
		 *				  'both' to go both ways
		 *     show_from_setting 'show_from_start'
		 *						 'show_from_end'
		 *						 'show_from_middle'
		 *
		 *
		 * TODO: Write a long, thorough document about how the posts are managed for a topic
		 */
		fetchMorePosts: function (settings) {
			var number_to_fetch = AoPS.Community.Constants.num_posts_to_fetch,
				options = _.extend(
					{
						source: "master",
					},
					settings
				);
			if (this.get("all_posts_fetched")) {
				return;
			}
			/*	options = _.defaults(options, {
				direction : 'forwards'
			});
			if (options.direction === 'backwards') {
				first_post_to_fetch = Math.max(0,
					options.last_loaded - number_to_fetch);
			} else {
				first_post_to_fetch = options.last_loaded;
			}*/

			this.set("is_fetching_posts", true);
			this.set("is_fetching_past_posts", true);

			cmty_ajax.add({
				a: "fetch_posts_for_topic",
				params: {
					topic_id: this.get("topic_id"),
					direction: options.hasOwnProperty("direction")
						? options.direction
						: "forwards",
					start_post_id: options.hasOwnProperty("start_post_id")
						? options.start_post_id
						: -1,
					start_post_num: options.hasOwnProperty("start_post_num")
						? options.start_post_num
						: -1,
					show_from_time: options.hasOwnProperty("show_from_time")
						? options.show_from_time
						: -1,
					num_to_fetch: number_to_fetch,
				},
				source: options.source,
				main_handler: _.bind(function (ok, msg) {
					if (ok) {
						var i,
							max = msg.response.posts.length,
							post_parse_result,
							high_num = 0,
							low_num = 999999,
							show_from_start = false,
							show_from_end = false,
							loaded_posts = [];

						this.trigger("post_load_complete");
						for (i = 0; i < max; i++) {
							msg.response.posts[i][options.show_from_setting] = true;
							post_parse_result = this.parsePotentialNewPost(
								msg.response.posts[i]
							);
							loaded_posts.push(post_parse_result.post_model);
							/**
							 * If we are loading from the middle and hit a post that has already
							 *  been loaded as "show from end", then mark all the posts
							 *  we just loaded as "show from end".
							 **/
							if (options.show_from_setting === "show_from_middle") {
								if (
									!show_from_start &&
									post_parse_result.post_model.get("show_from_start")
								) {
									show_from_start = true;
								}
								if (
									!show_from_end &&
									post_parse_result.post_model.get("show_from_end")
								) {
									show_from_end = true;
								}

								if (post_parse_result.post_model.get("post_number") < low_num) {
									low_num = post_parse_result.post_model.get("post_number");
								}
								if (
									post_parse_result.post_model.get("post_number") > high_num
								) {
									high_num = post_parse_result.post_model.get("post_number");
								}
							}
						}

						if (show_from_start) {
							_.each(loaded_posts, function (post) {
								post.set("show_from_start", true);
							});
						}

						if (show_from_end) {
							_.each(loaded_posts, function (post) {
								post.set("show_from_end", true);
							});
						}

						// We've loaded 'em all.  Set them to all visible.  We'll have to do something
						// cleverer here when we start loading from the middle, but we are smart doggos
						// so we'll figure out how to do that.
						this.checkAllPostsLoaded();

						this.set("is_fetching_posts", false);
						this.set("is_fetching_past_posts", false);

						msg.response.low_num = low_num;
						msg.response.high_num = high_num;
						msg.response.target_post_number = msg.response.hasOwnProperty(
							"target_post_number"
						)
							? msg.response.target_post_number
							: null;
						/*	if (options.hasOwnProperty('onFinish')) {
							options.onFinish({
								low_num : low_num,
								high_num : high_num,
								target_post_number : msg.response.hasOwnProperty('target_post_number') ?
									msg.response.target_post_number : null
							});
						}*/
						this.trigger("topic_updated");
					}

					// In here twice because I want it set before the onFinish fires
					this.set("is_fetching_posts", false);
				}, this),
				extra_handlers: options,
			});
		},

		/**
		 * checkAllPostsLoaded checks if all the posts for this topic have been loaded.
		 *  This doesn't perform a database check -- we are merely checking if, as of
		 *  last update, the number of posts in the topic matches the number that has been loaded.
		 */
		checkAllPostsLoaded: function () {
			/**
			 * We need <= here because the removal of deleted posts is
			 * currently performed separately from the addition of
			 * of new posts.  Maybe we should change that?
			 *
			 * But, with deleted posts separate, there will come times when
			 *  the num_posts exceeds loaded length, because the
			 *  new posts come in before the deletes are registered.
			 */
			if (this.get("num_posts") <= this.get("posts").length) {
				this.get("posts").each(function (post) {
					post.set("show_from_start", true);
					post.set("show_from_end", true);
				});
				// Very important to update the number of posts on topic update
				this.set("all_posts_fetched", true);
			} else {
				this.set("all_posts_fetched", false);
			}
		},

		/**
		 * parseNewArrayOfPosts takes an array of post objects that have been returned
		 *   from the database during a topic update, and checks if they're new.  If so,
		 *   it adds the post to this topic.  At end, we check if we can mark all visible.
		 * Must run this after resetting num_posts.
		 *
		 * Note: Updated posts are handled separately.  See processTopicUpdate for more details.
		 *
		 * @param array of objects that can be used to instantiate a new ComModels.Post.
		 * @return boolean tells whether or not there is a new post
		 */
		parseNewArrayOfPosts: function (post_array) {
			var self = this,
				parse_result,
				new_post_found = false;
			_.each(post_array, function (post) {
				parse_result = self.parsePotentialNewPost(post);
				if (parse_result.new_post_found) {
					new_post_found = true;
				}
			});
			this.checkAllPostsLoaded();

			return new_post_found;
		},

		/**
		 * parsePotentialNewPost checks if a new post object from the database for this
		 *  topic has already been added, and then adds it if the post is new to this client.
		 *
		 * @param post: object used to instantiate a ComModels.Post
		 * @return: object:
		 * 		post_model : the ComModels.Post for this post
		 *		new_post_found : boolean tells if this is new
		 */
		parsePotentialNewPost: function (post) {
			var post_obj = this.checkPostLoaded(post.post_id),
				new_post = false;

			if (_.isNull(post_obj)) {
				post.topic = this;
				if (this.get("master").get("is_stretch_class")) {
					post.reported = AoPS.Stretch.Utils.isPostReported(post.post_id);
				}
				post_obj = new ComModels.Post(post);

				this.get("posts").add(post_obj);
				new_post = true;
			}
			return {
				new_post_found: new_post,
				post_model: post_obj,
			};
		},

		/**
		 * When we delete a post, we need to check if it was the last post, in
		 *  which case we have to check for resetting is_read, and
		 *  reset the topic in its lists with a remove/add
		 *
		 * @param object Post details from fetchNewTopics
		 **/
		checkRemoveLastPost: function (edited_post) {
			if (edited_post.delete_status !== "none") {
				/**
				 * This takes care of a delete of a post needing to turn a topic
				 *  "read".
				 **/
				if (this.get("last_post_time") <= this.get("db_mark_time")) {
					this.set("is_read", true);
				}
				if (
					edited_post.post_time >= this.get("last_post_time") &&
					this.get("in_master_topics")
				) {
					this.get("master").get("topics").remove(this, {
						removed_by: "topic_update",
					});
					this.get("master").get("topics").add(this, {
						added_by: "topic_update",
					});
				}
			}
		},

		/**
		 * Parse an edited/deleted post.
		 *
		 * @param obj for instantiating a post, plus a couple extra properties.
		 *
		 * Ignore if this post has not yet been loaded.
		 */
		parseEditedPost: function (edited_post) {
			var post_obj,
				can_read_deleted = this.getPermission("c_can_read_deleted");

			if (can_read_deleted) {
				edited_post.topic_data.num_posts += edited_post.topic_data.num_deleted;
			}
			delete edited_post.topic_data.num_deleted;
			this.set(edited_post.topic_data);

			this.checkRemoveLastPost(edited_post);
			// If we have never loaded any posts for this topic,
			//  then do nothing here.  We'll get this post when the time comes
			//  if we need it.
			//  (There are checks on the length of posts in other places.
			//   We don't want those to suddenly say that this topic
			// 	 has real data loaded before we go get the initial bacth of posts.)
			if (this.get("posts").length === 0) {
				return;
			}
			post_obj = this.checkPostLoaded(edited_post.post_id);

			if (!_.isNull(post_obj)) {
				if (edited_post.delete_status == "hard") {
					post_obj.trigger("hard_delete");
					this.get("posts").remove(post_obj);
				} else if (edited_post.delete_status == "soft") {
					if (!can_read_deleted) {
						post_obj.trigger("hard_delete");
						this.get("posts").remove(post_obj);
					} else {
						post_obj.set("deleted", true);
					}
				} else {
					post_obj.parseEdits(edited_post);
					/*					post_obj.set('deleted', false);
					// TODO : Make sure the edit watcher is working.
					post_obj.set('html', edited_post.html);
					post_obj.set('canonical', edited_post.canonical);*/
				}
			} else if (edited_post.delete_status == "none") {
				// The main purpose of this section is for un-deleting posts...
				// On un-delete, we'll load the post to the topic if other
				// posts have been loaded.  It will be set to visible
				// if all the posts for the thread have been loaded.
				// We only add the post if we have already fetched everything for this topic.
				//  Otherwise, weird errors may occur in fetches based on what posts are already
				//  loaded.  We may make this smarter later by looking for nearby posts, but
				//  probably don't need to.
				if (this.get("all_posts_fetched")) {
					edited_post.show_from_start = true;
					edited_post.show_from_end = true;
					edited_post.topic = this;
					if (this.get("master").get("is_stretch_class")) {
						edited_post.reported = AoPS.Stretch.Utils.isPostReported(
							edited_post.post_id
						);
					}
					post_obj = new ComModels.Post(edited_post);
					this.get("posts").add(post_obj);
				}
			}
		},

		/**
		 * checkPostLoaded checks if the post with the given post_id
		 *  is in this topic
		 *
		 * @param post_id: post to search for.
		 *
		 * TODO : make a generic binary search on collections so I don't have
		 *  to make these two functions a zillion times.
		 */
		checkPostLoaded: function (post_id) {
			var posts = this.get("posts");
			if (posts.length === 0) {
				return null;
			} else {
			}

			return this.checkPostLoadedBinarySearch(
				post_id,
				0,
				posts.length - 1,
				posts.models
			);
		},

		/**
		 * This is just a support function for checkPostLoaded to apply a binary
		 *  search to make the post hunt faster.  (We do this search a lot...)
		 */
		checkPostLoadedBinarySearch: function (post_id, first, last, posts) {
			var mid, mid_id;
			if (last < first) {
				return null;
			}
			mid = Math.floor((first + last) / 2);
			mid_id = posts[mid].get("post_id");

			if (post_id < mid_id) {
				return this.checkPostLoadedBinarySearch(post_id, first, mid - 1, posts);
			} else if (post_id > mid_id) {
				return this.checkPostLoadedBinarySearch(post_id, mid + 1, last, posts);
			} else {
				return posts[mid];
			}
		},

		/***
		 * Submit a new participant for this topic (private conversations only)
		 *
		 * @param obj:
		 *		user object (required) :
		 *			user_id (int)
		 *			username (string)
		 *		onFinish function (optional)
		 */
		submitNewParticipant: function (obj) {
			if (!obj.user.hasOwnProperty("user_id")) {
				obj.user.user_id = 0;
			}
			cmty_ajax.add({
				a: "add_topic_participant",
				params: _.extend(
					{
						topic_id: this.get("topic_id"),
					},
					obj.user
				),
				main_handler: _.bind(function (ok, msg) {
					if (ok) {
						if (msg.response.hasOwnProperty("participants")) {
							this.set("participants", msg.response.participants);
						}
					} else {
						msg.response.username = obj.user.username;
					}
				}, this),
				extra_handlers: obj,
			});
		},

		/**
		 * Check if the inputted string is a valid username.
		 * Ajax returns object
		 *		is_valid_recipient boolean
		 *		is_admin 0|1
		 *		user_id 0|valid user id
		 *
		 * @param obj
		 *		username string
		 *		onFinish/onError
		 */
		checkValidPrivateRecipient: function (obj) {
			cmty_ajax.add({
				a: "check_valid_private_recipient",
				params: {
					username: obj.username,
				},
				main_handler: function (ok, msg) {}, //all the action is passed in
				extra_handlers: obj,
			});
		},

		/**
		 * Add participants to this conversation.
		 *
		 * @param array of participants.
		 *
		 * Algorithm: Set the passed-in array as the participants in any of the following:
		 *	- participants not set yet
		 *  - passed-in array larger than existing (new person added)
		 *  - new people in passed-in array (some added, some removed, shouldn't happen)
		 *  - 'removed' property changes on one of the users (someone removed self)
		 */
		addParticipants: function (participants) {
			var current_participant_entry,
				i,
				participant,
				max = participants.length;

			// New participants not sent in; go with the ones we have.
			// (Don't think we need the participants check, but just in case...)
			if (max === 0 && this.has("participants")) {
				return;
			}

			if (
				!this.has("participants") ||
				this.get("participants").length !== max
			) {
				this.set("participants", participants);
			} else {
				for (i = 0; i < max; i++) {
					participant = participants[i];
					current_participant_entry = _.findWhere(this.get("participants"), {
						user_id: participant.user_id,
					});

					if (
						_.isUndefined(current_participant_entry) ||
						current_participant_entry.removed !== participant.removed
					) {
						this.set("participants", participants);
						return;
					}
				}
			}
		},

		delete: function (obj) {
			cmty_ajax.add({
				a: "delete_topic",
				params: {
					topic_id: this.get("topic_id"),
					delete_type: obj.delete_type,
					reason: obj.reason || "",
				},
				main_handler: _.bind(function (ok, msg) {
					if (ok) {
						Backbone.trigger("destroy_topic_view", {
							category_id: this.get("category_id"),
							topic_id: this.get("topic_id"),
						});
						this.set("deleted", true, {
							deleted_by_me: true,
						});

						this.destroy();
					}
				}, this),
				extra_handlers: obj,
			});
		},

		move: function (obj) {
			var old_category_id = this.get("category_id");

			cmty_ajax.add({
				a: "move_topic",
				params: {
					topic_id: this.get("topic_id"),
					new_category_id: obj.new_category_id,
					old_category_id: this.get("category_id"),
				},
				main_handler: _.bind(function (ok, msg) {
					if (ok) {
						this.set(msg.response.new_topic_data);
						Backbone.trigger("destroy_topic_view", {
							category_id: old_category_id,
							topic_id: this.get("topic_id"),
						});
						this.get("master").get("topics").remove(this);
						this.get("master").get("topics").add(this);

						// RR fixed the issue below (maybe) on 1/4/15
						//  with onDestroyTopic in the router
						// If pulling something out of the trash, we
						//  don't want to trigger a move to the topic; we want to rebuild
						//  from scratch.  This is because we might have deleted it during
						//  this page view, in which case various views have been
						//  closed, but Page.js will still have a cached
						this.get("master").trigger("move_to_topic", {
							category_id: obj.new_category_id,
							topic_id: this.get("topic_id"),
							replace: true,
						});
					}
				}, this),
				extra_handlers: obj,
			});
		},

		lock: function (obj) {
			this.setLockStatus(_.extend({lock_status: true}, obj));
		},

		unlock: function (obj) {
			this.setLockStatus(_.extend({lock_status: false}, obj));
		},

		setLockStatus: function (obj) {
			this.set("locked", obj.lock_status);
			cmty_ajax.add({
				a: "set_lock_status",
				params: {
					topic_id: this.get("topic_id"),
					lock_status: obj.lock_status ? 1 : 0,
					reason: obj.reason || "",
				},
				main_handler: function (ok, msg) {},
			});
		},

		setAnnounceType: function (obj) {
			var self = this;
			cmty_ajax.add({
				a: "set_announce_type",
				params: {
					topic_id: this.get("topic_id"),
					announce_type: obj.type,
					announce_through: obj.announce_through,
				},
				main_handler: function (ok, msg) {
					var category;
					if (ok) {
						var announce_factor = 2;
						if (obj.type === "none") {
							announce_factor = 0;
						} else if (obj.type === "local") {
							announce_factor = 1;
						}
						self.set({
							announce_type: obj.type,
							announce_factor: announce_factor,
						});
						self.get("master").get("topics").remove(self);
						self.get("master").get("topics").add(self);
						category = self
							.get("master")
							.fetchCategory(self.get("category_id"));
						/**
						 * There are a few weird edge cases here.  If the category has no
						 *  topics, then our onAddMasterTopic won't automatically add the topic
						 *  to the category.  That's bad.  So, we'll have to take care of it
						 *  here.  This assumes that this setAnnounceType method will only ever
						 *  get called when a mod is setting an announce on the front end -- that
						 *  is, the topic will have its category loaded already.
						 **/
						if (!_.isUndefined(category)) {
							if (category.get("active_topics").length == 0) {
								category.get("active_topics").add(self);
							}
						}
					}
				},
				extra_handlers: obj,
			});
		},

		/**
		 * This topic has been moved.  Here, we parse the data regarding that move
		 *  to figure out what to do for this user.
		 **/
		parsePotentialMove: function (move_data) {
			var category;
			if (this.get("category_id") == move_data.new_category_id) {
				// Already took care of this one
				return;
			}

			// Topic moved somewhere this user can't access; delete it.
			if (!move_data.can_read) {
				this.set("deleted", true);
				this.destroy();
				return;
			}

			// Set the new category data
			this.set({
				category_id: move_data.new_category_id,
				category_name: move_data.category_name,
				category_main_color: move_data.category_main_color,
				category_secondary_color: move_data.category_secondary_color,
			});

			// Not a perfect fix, but close.  Set the permissions for the new category.
			//  Will fail if user hasn't visited that category yet.  We can live with that,
			//  since we'll check the permissions on the back end, too.
			category = this.get("master").fetchCategory(move_data.new_category_id);
			if (!_.isUndefined(category)) {
				this.set("permissions", category.get("permissions"));
			}

			// Remove and add the topic so that it resets in the categories.
			//  Flag why this is being removed and added so that topic lists and such
			//  will know how handle it.
			this.get("master")
				.get("topics")
				.remove(
					this,
					_.extend(
						{
							removed_by: "topic_move",
						},
						typeof move_data.extra_data === "object" ? move_data.extra_data : {}
					)
				);

			this.get("master")
				.get("topics")
				.add(
					this,
					_.extend(
						{
							removed_by: "topic_move",
						},
						typeof move_data.extra_data === "object" ? move_data.extra_data : {}
					)
				);
		},

		/**
		 * Compute total number of votes and the percentages and bar scales
		 *  for each option in a poll.
		 *
		 * After this function, poll_data has the structure
		 *		question string
		 *		start int
		 *		length int
		 *		allow_revote boolean
		 *		num_selections int
		 *		num_votes int
		 *		poll_closed boolean
		 *		can_vote boolean
		 * 		has_voted boolean
		 *		options array of
		 * 			id int
		 *			text string
		 *			total int
		 *			selected boolean
		 *			pct int
		 *			bar_scale int
		 *
		 **/
		computeDerivedPollData: function () {
			var poll_data,
				i,
				vote_total = 0,
				max,
				has_voted = false,
				max_pct = 0;

			if (!this.has("poll_data")) {
				return;
			}

			poll_data = this.get("poll_data");
			max = Object.keys(poll_data.options).length;

			for (i = 0; i < max; i++) {
				vote_total += poll_data.options[i].total;
			}
			poll_data.num_votes = vote_total;
			if (vote_total == 0) {
				for (i = 0; i < max; i++) {
					poll_data.options[i].pct = 0;
					poll_data.options[i].bar_scale = 0;
				}
			} else {
				for (i = 0; i < max; i++) {
					poll_data.options[i].pct = Math.round(
						(100 * poll_data.options[i].total) / vote_total
					);
					max_pct = Math.max(max_pct, poll_data.options[i].pct);
					if (poll_data.options[i].selected) {
						has_voted = true;
					}
				}

				for (i = 0; i < max; i++) {
					poll_data.options[i].bar_scale = Math.round(
						(100 * poll_data.options[i].pct) / max_pct
					);
				}
			}
			poll_data.has_voted = has_voted;
			poll_data.can_vote =
				AoPS.session.logged_in_and_initialized &&
				AoPS.hasFreeResourceAccess() &&
				!poll_data.poll_closed &&
				(!has_voted || poll_data.allow_revote);
		},

		/**
		 * Cast a vote on the poll in this topic.
		 *
		 * @param object
		 *		votes required array of int
		 *		standard extra handlers.
		 * Resets the poll_data for this topic on return from Ajax
		 **/
		castVote: function (obj) {
			var self = this;
			cmty_ajax.add({
				a: "cast_vote",
				params: {
					topic_id: this.get("topic_id"),
					votes: obj.votes.join(),
				},
				main_handler: function (ok, msg) {
					if (ok) {
						self.set("poll_data", msg.response.poll_data);
					}
				},
				extra_handlers: obj,
			});
		},

		/**
		 *  Remove the target url of this topic
		 *
		 * @param obj the usual extra handlers
		 *
		 **/
		removeTarget: function (obj) {
			var self = this;
			cmty_ajax.add({
				a: "remove_target_url",
				params: {
					topic_id: this.get("topic_id"),
				},
				main_handler: function (ok, msg) {
					if (ok) {
						self.deleteTagFromTagsArray(0, self.get("target_url"));
						self.set("target_url", "");
					}
				},
				extra_handlers: obj,
			});
		},

		/**
		 * Change the target URL of this topic.
		 *
		 * @param obj
		 *		new_target string
		 *		new_target_text string
		 *		is_restricted boolean
		 *		onFinish, onError
		 **/
		changeTargetUrl: function (obj) {
			var self = this,
				new_url;
			// Time for some lazy man's url cleaning
			new_url = _.last(obj.new_target.split(".com"));
			var new_target_text = obj.new_target_text;
			cmty_ajax.add({
				a: "change_target_url",
				params: {
					topic_id: this.get("topic_id"),
					new_target: new_url,
					new_target_text: new_target_text,
					is_restricted: obj.is_restricted ? 1 : 0,
				},
				main_handler: function (ok, msg) {
					if (ok) {
						self.deleteTagFromTagsArray(0, self.get("target_url"));
						self.get("tags").push({
							tag_id: msg.response.new_tag.tag_id,
							tag_text: msg.response.new_tag.tag_text,
							is_visible: msg.response.new_tag.is_visible,
							is_public: msg.response.new_tag.is_public,
						});
						self.set({
							target_url: msg.response.new_tag.tag_text,
							target_text: msg.response.new_tag.new_target_text,
						});
					}
				},
				extra_handlers: obj,
			});
		},

		/**
		 * Add a hidden tag.
		 *
		 * @param obj
		 *		new_text string
		 *		is_restricted boolean
		 *		onFinish, onError
		 **/
		addHiddenTag: function (obj) {
			var self = this,
				new_url;
			// Time for some lazy man's url cleaning
			new_url = _.last(obj.new_text.split(".com"));
			cmty_ajax.add({
				a: "add_hidden_tag",
				params: {
					topic_id: this.get("topic_id"),
					new_text: new_url,
					is_restricted: obj.is_restricted ? 1 : 0,
				},
				main_handler: function (ok, msg) {
					if (ok) {
						if (!self.hasTag(msg.response.new_tag.tag_id)) {
							self.get("tags").push({
								tag_id: msg.response.new_tag.tag_id,
								tag_text: msg.response.new_tag.tag_text,
								is_visible: msg.response.new_tag.is_visible,
								is_public: msg.response.new_tag.is_public,
							});
						}
					}
				},
				extra_handlers: obj,
			});
		},

		/**
		 * Check if this object is linked to something on the site, and
		 *  whether or not the user can get to that object.
		 * We have some real hackery here to deal with students in classes
		 *  who don't have access to ebooks.
		 **/
		checkShowTargetLink: function () {
			var target_url_arr, ebook_arr;

			if (this.get("target_url").length === 0) {
				return false;
			}
			// HERE COMES HACKERY!!!
			target_url_arr = this.get("target_url").split("/");
			if (
				target_url_arr.length > 3 &&
				target_url_arr[0] === "class" &&
				target_url_arr[2] === "ebook"
			) {
				ebook_arr = this.get("master").get("ebooks_available");
				return (
					AoPS.session.logged_in_and_initialized &&
					_.indexOf(ebook_arr, parseInt(target_url_arr[3])) > -1
				);
			}
			return true;
		},
	});

	ComModels.Shoutbox = ComModels.Topic.extend({
		postsComparator: function (post) {
			return -parseInt(post.get("post_id"));
		},

		/**
		 * In a shoutbox, the posts are in reverse order, with most recent first.
		 **/
		fetchLastLoadedPostNumber: function () {
			return this.get("posts").first().get("post_number");
		},

		/**
		 * This is just a support function for checkPostLoaded to apply a binary
		 *  search to make the post hunt faster.  (We do this search a lot...)
		 *
		 * Posts are ordered in the opposite direction in shoutboxes.  That's funny.
		 */
		checkPostLoadedBinarySearch: function (post_id, first, last, posts) {
			var mid, mid_id;
			if (last < first) {
				return null;
			}
			mid = Math.floor((first + last) / 2);
			mid_id = posts[mid].get("post_id");

			if (post_id > mid_id) {
				return this.checkPostLoadedBinarySearch(post_id, first, mid - 1, posts);
			} else if (post_id < mid_id) {
				return this.checkPostLoadedBinarySearch(post_id, mid + 1, last, posts);
			} else {
				return posts[mid];
			}
		},
	});

	/**
	 * A FilteredTopicList is a Collection of ComModels.Topic that satisfy a
	 *  set of criteria.  Each FilteredTopicList is currently a property
	 *  of a ComModels.TopicList, which holds the criteria that define this list.
	 *  See note in ComModels.TopicList for some more info, though there's plenty below.
	 *  This Collection is the actual list of topics, and is where all the work gets done.
	 *
	 * Properties:
	 *
	 * all_topics_fetched : boolean tells us if we have all the topics.
	 * category : ComModels.CategoryWithTopics that all topics in list must be visible in
	 * fetch_settings : {category_id, tag_ids} defines how to get more topics
	 * filter : the function that filters topics and determines if they fit this list
	 * master : ComModels.Master
	 * topics_loading : boolean tells us if we're in the process of loading already.
	 *
	 * Methods:
	 *
	 * refilterActiveTopic (topic)
	 *		Refilters a topic that is in the active_topics of this.category when it changes.
	 *
	 * removeTopic (topic)
	 *		Removes a topic from this list.
	 *
	 * checkNewTopic (topic)
	 *		Checks a topic to see if it should be added to this list.
	 *
	 * fetchMoreTopics (options)
	 *		Fetch more topics for this list
	 *
	 * announceDataLoaded ()
	 *		Currently deprecated
	 *
	 * fetchTopicById (topic_id)
	 *		Fetch a topic from list by its id.
	 */
	ComModels.FilteredTopicList = Backbone.Collection.extend({
		model: ComModels.Topic,

		// need to check which direction this sorts.  I want highest first, may need to flip sign
		/*comparator : function (topic) {
			return -topic.get('last_post_time');
		},*/

		initialize: function (models, options) {
			this.topics_loading = false;
			if (!options.hasOwnProperty("master")) {
				console.log(
					"You created a filtered topic list without setting master. " +
						" You deserve what happens next."
				);
				return;
			}
			if (!options.hasOwnProperty("filter")) {
				console.log(
					"You created a filtered topic list without setting filter. " +
						" You really deserve what happens next."
				);
			}
			$.extend(this, options);

			this.category = options.category;

			this.all_topics_fetched = this.category.get("all_topics_loaded");
			// Do I need an error condition on fetch_settings?
			//  Will there be lists for which we won't want to fetch more topics?
			this.listenTo(
				this.category.get("active_topics"),
				"add",
				this.checkNewTopic
			);
			this.listenTo(
				this.category.get("active_topics"),
				"reset",
				this.emptyList
			);
			this.fetch_settings = _.pick(options, "category_id", "tag_ids");

			/**
			 * If this list is filtered by tags, then we need to set up some checks
			 *  for tag changes causing adds or removals.
			 **/
			if (this.hasOwnProperty("tag_ids") && this.tag_ids.length > 0) {
				/***
				 * If an active_topic has a tag added, the topic may suddenly fall into this
				 * list.  So, we check that.  There is a small hole: if a tag is added to a topic
				 *  that is more recent than the oldest topic in this filtered list,
				 *  but the topic is older than the oldest active_topic in the category, then we'll
				 *  miss adding it to this filtered list.  We can live with that.  (This is because
				 *  the active_topics of the category are only those loaded when searching the category
				 *  without filter.)
				 **/
				this.listenTo(
					this.category.get("active_topics"),
					"tag_added",
					this.refilterActiveTopic
				);

				/**
				 * If a tag is removed from any topic in this collection, then it may fall out of the
				 *  filtered list.
				 */
				this.listenTo(this, "tag_removed", this.refilterActiveTopic);
			}

			//We have to watch master for removes instead of the category, because
			//  this filtered list can be created and filled without the category even having topics.
			//  Consider the user navigating directly to a forum filtered by a tag.  The parent
			//  category's active_topics gets no topics, but this list gets filled.  So, the remove
			//  event never gets called.
			this.listenTo(this.master.get("topics"), "remove", this.removeTopic);
			this.listenTo(this.category, "force_remove_topic", this.forceRemoveTopic);
		},

		/**
		 * Categories can force a topic removal from their collections by triggering
		 *  force_remove_topic.
		 *
		 * This isn't used right now.  It was built to pull things out of
		 *  tag collections (and bookmarked tags) on the fly, but I'm not so sure
		 *  we want that behavior.  It could be really confusing to users.
		 ***/
		forceRemoveTopic: function (obj) {
			this.remove(obj.topic, {
				removed_by: "topic_update",
			});
		},

		/**
		 * Some actions cause a filteredTopicList to need to be entirely reset.
		 *  Views will have to handle the clean up.
		 **/
		emptyList: function () {
			this.all_topics_fetched = false;
			this.reset();
		},

		/**
		 * For most changes of a topic, we remove the topic from the master topic list,
		 *  then add it back.  That will automatically refilter it for all filtered topic
		 *  collections.  However, when a topic's tags change, we don't bother
		 *  removing and re-adding it to master, so we do the refiltering manually here.
		 *
		 * TODO : reconsider this; maybe we just always re-filter for tags changes, too.
		 *		Separating that filtering is silly.  But it's also expensive.  Tags will
		 *		change a lot, and we don't want to trigger remove/adds on all of them.
		 *		We want to confine the action to the categories that might care.
		 *
		 * @param ComModels.Topic: the topic that we have to check.
		 */
		refilterActiveTopic: function (trigger_options) {
			if (
				!this.checkNewTopic(trigger_options.topic, null, {
					added_by: "topic_update",
				})
			) {
				this.remove(trigger_options.topic, {
					removed_by: "topic_update",
				});
			}
		},

		/**
		 * removeTopic removes a topic from this Collection.
		 *  Made a separate function in case there's other stuff we need to do on remove.
		 *
		 * @param ComModels.Topic
		 * @param of ComModels.Topic ; collection passed by the event watcher.
		 * @param object; optional properties that were submitted on the removal that triggered
		 *     this remove.  (We need to handle removals of different types in different ways
		 *     on the front end.)
		 *
		 */
		removeTopic: function (topic, collection, options) {
			this.remove(topic, options); //propagate remove options
		},

		/**
		 * checkNewTopic checks if a topic should be added to this list.
		 *  One subtle item here: since each topic is uniquely stored as
		 *  a Model, and a Backbone Collection won't add the same item to
		 *  a collection twice, this automatically deals with the issue
		 *  of mistakenly adding a topic twice.
		 *
		 * @param ComModels.Topic
		 * @param of ComModels.Topic ; collection passed by the event watcher.
		 * @param object; optional properties that were submitted on the add event that triggered
		 *     this add.  (We need to handle additions of different types in different ways
		 *     on the front end.)
		 * @return boolean true if topic is in list.
		 */
		checkNewTopic: function (topic, collection, options) {
			if (
				options.hasOwnProperty("calling_list") &&
				options.calling_list === this
			) {
				return false;
			}
			if (this.filter(topic)) {
				this.add(topic, options); // propagate the add options
				return true;
			}
			return false;
		},

		/**
		 * Construct the parameters to be sent to the fetchMoreTopics call
		 *  of the category's fetchTopics ajax call.  We separate
		 *  this from the actual call because we sometimes need to be able to
		 *  combine this call with others in a run_multiple_ajax_calls call.
		 *
		 * Note that we set the flag "add_in_bulk" when we add the topics to this collection.
		 * 		We then trigger "fetched_topics_added" on this list.  The views that are based on
		 *		this list will track if the fetch_topics call that brought these topics in
		 *		was made by this list (we do so with the "calling_list" property).  These
		 *		views will then queue the new topics to be added to the DOM en masse.
		 *		The trigger will tell the view to get going on that.
		 *
		 * @param options : optional object.  Supported parameters:
		 *		onFinish : function to fire once all finished
		 **/
		constructFetchMoreTopicsParams: function (options) {
			var self = this,
				length_heading_in = this.length,
				return_data,
				fetch_before;
			/**
			 * If this list's category's topics are all loaded, then
			 *  we don't need to go looking.
			 **/
			if (this.category.get("all_topics_loaded")) {
				this.all_topics_fetched = true;
				if (options.hasOwnProperty("onFinish")) {
					options.onFinish();
				}
			}

			fetch_before = this.category.getCollectionFetchBefore(this);
			// TODO : Do I need to check if the topics are loading and block
			//   another fetch if true; if not, do I need this flag at all?
			this.topics_loading = true; // we may push this up to the TopicList
			return_data = _.extend(
				{
					fetch_before: fetch_before.value,
					calling_list: this,
					never_cancel:
						typeof options.never_cancel === "boolean"
							? options.never_cancel
							: false,
					onFinish: _.bind(function (obj) {
						this.add(obj.new_topics, {
							add_in_bulk: true,
							force_add: options.hasOwnProperty("force_add")
								? options.force_add
								: false,
						});

						this.topics_loading = false;
						/**
						 * There may be a hole here.  I believe that there is only one
						 *  way the following can happen:
						 *	1) Some topics are found
						 *	2) None of them are new for this collection.
						 *  3) The fetch_before is 0.
						 * This can only happen (I think) if this collection only has
						 *  announcements in it.  The announcements are ignored in the
						 *  fetch_before computation, but they will be returned by the
						 *  fetch.  So, if the only topics for a given tag are announcements,
						 *  we need the second check below (after the ||) to mark
						 *  everything read.
						 * This all assumes that there is always a pass of filtering
						 *  through the category for topics prior to the first fetch.
						 *
						 * There is one itty bitty hole: if the most recent 10 topics
						 *  with a particular tag happen to be announcements. I can live with that.
						 **/
						/**
						 * For good measure, we only mark everything fetched if the
						 *  number of topics post-search matches that pre-search.
						 * Heck, maybe we should let that replace all the other checks?
						 **/
						if (
							obj.no_more_topics ||
							!obj.topics_found ||
							(fetch_before.value === 0 &&
								obj.new_topics.length === 0 &&
								length_heading_in === this.length)
						) {
							this.all_topics_fetched = true;
						}

						this.trigger("bulk_topics_added");

						/* Must come after the check for whether or not we are going to seek more topics */
						if (!_.isUndefined(options) && options.hasOwnProperty("onFinish")) {
							options.onFinish();
						}
					}, this),
					onError: function (msg) {
						self.topics_loading = false;
						if (!_.isUndefined(options) && options.hasOwnProperty("onError")) {
							options.onError(msg);
						}
					},
				},
				this.fetch_settings
			);
			if (arguments.length > 0 && options.hasOwnProperty("source")) {
				return_data.source = options.source;
			}

			return return_data;
		},

		/**
		 * Build the object we would pass to cmty_ajax.add for making the Ajax call
		 *  to add more topics to this list.  We use this when building the
		 *	array of call objects in a run_multiple_ajax_calls call.
		 *
		 * @param options : optional object.  Supported parameters:
		 *		onFinish : function to fire once all finished
		 **/
		constructAjaxCall: function (options) {
			return this.category.constructFetchTopicsArguments(
				this.constructFetchMoreTopicsParams(options)
			);
		},

		/**
		 * fetchMoreTopics goes and gets more topics for this filtered list.  There's some
		 *  trickery here.  First, we need to figure out what the oldest topic is that
		 *  has already been added to this list.  Then, we tell the category
		 *  of this list to get more topics that match the fetch_settings we send.
		 *
		 * If there is no filtering by tag in the fetch_settings, then the added
		 *  topics are added directly to the category's active_topics, and thereby
		 *  get automatically added to this list.
		 * If there is filtering by tag, they get added to a "new_topics" array of
		 *  Topic Models, which are then added to this filtered list in the onFinish method.
		 *
		 * @param options : optional object.  Supported parameters:
		 *		onFinish : function to fire once all finished
		 */
		fetchMoreTopics: function (options) {
			if (arguments.length === 0) {
				options = {};
			}
			this.category.fetchTopics(this.constructFetchMoreTopicsParams(options));
		},

		/**
		 * fetchTopicById pulls a topic object out of our Collection by its ID.
		 *
		 * @param int topic_id
		 * @return ComModels.Topic
		 */
		fetchTopicById: function (topic_id) {
			// Make binary search eventually?  Probably not, since the comparator is by time
			topic_id = parseInt(topic_id);
			return this.find(function (topic) {
				return topic.get("topic_id") === topic_id;
			});
		},
	});

	/**
	 * ComModels.TopicList is a model that holds a list of topics that satisfy some set of criteria.
	 *
	 * Properties:
	 *    category_id : if nonzero, all topics in this list must be visible in this category.
	 *        (So, if the category is a forum, the topic must be in the forum.  If the category is
	 *         a view, then the topic has one of the view's tags or forums.)
	 *    tag_ids (array) : If nonempty, then every topic in this list has all of these tags.
	 *    filtered_topic_list : The Backbone Collection of Topics.
	 *
	 * Note: We have this TopicList model as a step between the ComModels.Master property
	 *  topic_lists and ComModels.FilteredTopicList because ComModels.Master.get("topic_lists")
	 *  is a collection, and we cannot have a Collection of Collections in Backbone.
	 *  Hence the model in-between.
	 *
	 *  There's a very good chance we can make ComModels.Master.get("topic_lists") simply
	 *   an array.  If we don't need watchers for adds, removals, or changes to the topic_lists,
	 *   then I think we can simplify stuff by cutting out the middleman
	 *
	 */
	ComModels.TopicList = ComModels.Model.extend({
		defaults: {
			category_id: 0,
		},

		initialize: function (options) {
			var filtered_list;

			this.setDefault("tag_ids", []);

			if (!options.hasOwnProperty("master")) {
				console.log(
					"You created a filtered topic list without setting master. " +
						" You deserve what happens next."
				);
			}
			if (!options.hasOwnProperty("filter")) {
				console.log(
					"You created a filtered topic list without setting filter. " +
						" You really deserve what happens next."
				);
			}

			filtered_list = new ComModels.FilteredTopicList([], {
				category_id: this.get("category_id"),
				category: this.get("category"),
				tag_ids: this.get("tag_ids"),
				master: options.master,
				filter: options.filter,
			});
			filtered_list.comparator = this.get("category").topicsComparator;

			filtered_list.add(
				this.get("category").get("active_topics").filter(options.filter),
				{sort: false}
			);

			filtered_list.sort();
			this.set("filtered_topic_list", filtered_list);
			/*this.set('filtered_topic_list', new ComModels.FilteredTopicList(this.get('category').get('active_topics').filter(options.filter), { //options.master.get('topics').filter(options.filter), {
				comparator : this.get('category').topicsComparator,
				category_id : this.get('category_id'),
				category : this.get('category'),
				tag_ids : this.get('tag_ids'),
				master : options.master,
				filter : options.filter
			}));*/
		},
	});

	/**
	 * ComModels.Post is the model for a post. We may ultimately decide
	 *  we don't need a Backbone model for this and just use objects to carry around the data.
	 *  But we likely want models if there will be realtime updates to posts, like
	 *  deletions/edits/etc.  Right now, this model just functions as a repository of
	 *  of data to push through a view to display the post.
	 *
	 * post_rendered
	 * username
	 * post_canonical
	 * date_rendered
	 * avatar
	 * post_number
	 * show_from_start : show this post if topic is loaded from first post
	 * show_from_end : show this post if topic is loaded from last post
	 */
	ComModels.Post = Backbone.Model.extend({
		defaults: {
			can_target: false, // Can this post have a target url?
			// Is this post deletable if it is the last post of the topic?
			// Note: set to true if current user_id = poster_id and post_time not greater than delete_time_limit
			//  we check at time of rendering whether or not the post is the last one in the topic
			deletable: false,
			editable: false,
			is_edit_time_watched: false,
			is_forum_admin: false,
			is_forum_mod: false,
			last_edit_time_rendered: "",
			has_target: false,
			real_poster_id: 0, // Only sent forward if user has permission to see it.
			real_poster_username: "",
		},

		initialize: function () {
			if (this.has("topic")) {
				this.get("topic")
					.get("master")
					.checkAddToWatchTimes({
						time_data: {
							model: this,
							int_time_field: "post_time",
							rendered_time_field: "date_rendered",
						},
						is_already_watched: false,
					});
				if (
					this.get("post_number") === 1 &&
					this.get("topic").get("cat_can_target")
				) {
					this.set("can_target", true);
					this.listenTo(
						this.get("topic"),
						"change:target_url",
						this.onChangeTopicTarget
					);

					if (this.get("topic").get("target_url").length > 0) {
						this.set("has_target", true);
					}
				}
			}

			this.set(
				"date_rendered",
				AoPS.Community.Utils.makePrettyTime(this.get("post_time"))
			);
			this.set(
				"last_edit_time_rendered",
				AoPS.Community.Utils.makePrettyTime(this.get("last_edit_time"))
			);
			this.parseEditData();
			this.on("change:last_edit_time_rendered", this.parseEditData);
			if (!this.get("attachment")) {
				this.set("attachments", []);
			}
			this.set("original_attachments", this.get("attachments"));
		},

		onChangeTopicTarget: function () {
			this.set("has_target", this.get("topic").get("target_url").length > 0);
		},

		parseEditData: function () {
			if (this.has("topic") && this.get("num_edits") > 0) {
				this.set(
					"is_edit_time_watched",
					this.get("topic")
						.get("master")
						.checkAddToWatchTimes({
							time_data: {
								model: this,
								int_time_field: "last_edit_time",
								rendered_time_field: "last_edit_time_rendered",
							},
							is_already_watched: this.get("is_edit_time_watched"),
						})
				);
			}
		},

		report: function (reason, details) {
			cmty_ajax.add({
				a: "report_post",
				params: {
					reason_short: reason,
					details: details,
					post_id: this.get("post_id"),
				},
				main_handler: _.bind(function (ok, msg) {
					if (ok) {
						this.set("reported", true);
					} else {
						// TODO : ERROR?
					}
				}, this),
			});
		},

		/**
		 * Can this be deleted by a regular user?
		 **/
		isDeletableByUser: function () {
			var topic = this.get("topic");
			if (_.isUndefined(topic)) {
				return false;
			}
			if (
				this.get("deletable") &&
				this.get("post_id") === topic.get("last_post_id") &&
				topic.getPermission("c_can_edit_own_posts")
			) {
				if (this.get("poster_id") === Constants.halp_user_id) {
					if (
						this.has("real_poster_id") &&
						this.get("real_poster_id") === AoPS.session.user_id &&
						topic.getPermission("c_can_edit_own_posts")
					) {
						return true;
					} else {
						return false;
					}
				} else {
					return this.get("poster_id") === AoPS.session.user_id;
				}
			} else {
				return false;
			}
		},

		/**
		 * Delete this post.
		 *
		 * @param obj
		 *		hard_delete boolean : true for a hard delete, false for soft.
		 *		onFinish function (optional) : what we do when we finish
		 */
		delete: function (obj) {
			cmty_ajax.add({
				a: "delete_post",
				params: {
					hard_delete: obj.hard_delete ? 1 : 0,
					topic_id: this.get("topic_id"),
					post_id: this.get("post_id"),
					reason: obj.reason || "",
				},
				never_cancel: true,
				main_handler: _.bind(function (ok, msg) {
					if (ok) {
						if (
							msg.response.hasOwnProperty("topic_deleted") &&
							msg.response.topic_deleted
						) {
							this.get("topic").set("deleted", true, {
								deleted_by_me: true,
							});
							this.get("topic").destroy();
						} else {
							// ADD RIGHT HERE
							//  The call to the function that cleans out reports.
							this.get("topic")
								.get("master")
								.closePostReports(this.get("post_id"));
							this.set("deleted", true);
							this.set("reported", false);
							if (msg.response.topic_updated) {
								this.get("topic").processTopicUpdate(msg.response.topic_data);
							}
							if (obj.hard_delete) {
								this.trigger("hard_delete");
							}
						}
					} else {
						if (msg.error_code === "E_HARD_DELETE") {
							this.trigger("hard_delete");
						}
					}
				}, this),
				extra_handlers: obj,
			});
		},

		/**
		 * Undelete this post.
		 */
		undelete: function (obj) {
			cmty_ajax.add({
				a: "undelete_post",
				params: {
					topic_id: this.get("topic_id"),
					post_id: this.get("post_id"),
				},
				never_cancel: true,
				main_handler: _.bind(function (ok, msg) {
					if (ok) {
						this.set("deleted", false);
						if (msg.response.topic_updated) {
							this.get("topic").processTopicUpdate(msg.response.topic_data);
						}
					} else {
						if (msg.error_code === "E_HARD_DELETE") {
							this.trigger("hard_delete");
						}
					}
				}, this),
				extra_handlers: obj,
			});
		},

		/**
		 * Set the Thank status of this post
		 **/
		setThankStatus: function (obj) {
			this.set("is_thanked", obj.new_status == 1);
			this.set("is_nothanked", obj.new_status == -1);
			cmty_ajax.add({
				a: "set_thank_status", // was thank_post
				params: {
					post_id: this.get("post_id"),
					thank_status: obj.new_status,
				},
				main_handler: _.bind(function (ok, msg) {
					if (ok) {
						if (msg.response.hasOwnProperty("post_thank_count")) {
							this.set("thanks_received", msg.response.post_thank_count);
						}
						if (msg.response.hasOwnProperty("post_nothank_count")) {
							this.set("nothanks_received", msg.response.post_nothank_count);
						}
						if (typeof msg.response.thankers === "string") {
							this.set("thankers", msg.response.thankers);
						}
					} else {
						this.trigger("error", {error_code: msg.error_code});
						if (msg.error_code === "E_TOO_FAST") {
							AoPS.Ui.Flyout.display(AoPS.Community.Lang["err-too-fast"]);
						} else if (msg.error_code === "E_AJAX_FILTERED") {
							// Client side rate limiting. Intentionally ignored. Just kids spam clicking.
						} else if (msg.error_code) {
							AoPS.Ui.Flyout.display(msg.error_code);
						}
					}
				}, this),
			});
		},

		/**
		 * Edit this post.
		 *
		 * @param object
		 *		edited_text : string (required) new text
		 *		edit_reason : string (required)
		 *		topic_title string required (may be blank)
		 *		source string required (may be blank)
		 *		allow_latex_errors boolean true to let latex/asy errors get parsed in red rather than throw error
		 *		onError : function (optional) what to do if something goes wrong.
		 **/
		edit: function (obj) {
			var post_format =
					obj.hasOwnProperty("disable_bbcode") && obj.disable_bbcode
						? "none"
						: "bbcode",
				is_first_post = this.get("post_number") === 1,
				orig_att = this.get("attachment")
					? this.get("original_attachments")
					: [],
				attachments_changed = false;

			// Check if attachments have changed.

			if (orig_att.length === obj.attachments.length) {
				_.each(obj.attachments, function (att) {
					if (att.existing === 0) {
						attachments_changed = true;
					}
				});
			} else {
				attachments_changed = true;
			}

			// Check if post text changed only if the attachments haven't changed
			if (
				!attachments_changed &&
				$.trim(obj.edited_text) == this.get("post_canonical") &&
				post_format === this.get("format")
			) {
				// Now check topic_title and source, but only if we are the first post and have a source.
				if (
					!is_first_post ||
					!this.has("topic") ||
					(this.get("topic").get("topic_title") === $.trim(obj.topic_title) &&
						this.get("topic").get("source") === $.trim(obj.source))
				) {
					if (obj.hasOwnProperty("onError")) {
						obj.onError({
							error_code: "E_NO_EDIT_MADE",
						});
					}

					return;
				}
			}

			cmty_ajax.add({
				a: "edit_post",
				params: {
					post_id: this.get("post_id"),
					edited_text: obj.edited_text,
					source: obj.source,
					attachments: JSON.stringify(obj.attachments),
					topic_title: obj.topic_title,
					edit_reason: obj.edit_reason,
					format: post_format,
					allow_latex_errors: obj.allow_latex_errors ? 1 : 0,
				},
				never_cancel: true,
				main_handler: _.bind(function (ok, msg) {
					if (ok) {
						if (msg.response.post_id === this.get("post_id")) {
							// Retain visibility
							msg.response.show_from_start = this.get("show_from_start");
							msg.response.show_from_end = this.get("show_from_end");
							this.parseEdits(msg.response);
							if (this.has("topic") && is_first_post) {
								this.get("topic").set({
									topic_title: msg.response.topic_title,
									source: obj.source,
								});
							}
						}
					} else {
					}
				}, this),
				extra_handlers: obj,
			});
		},

		parseEdits: function (new_post_object) {
			if (new_post_object.last_edit_time > 0) {
				new_post_object.last_edit_time_rendered =
					AoPS.Community.Utils.makePrettyTime(new_post_object.last_edit_time);
			}
			if (!new_post_object.attachment && this.get("attachment")) {
				this.set("original_attachments", []);
				new_post_object.attachments = [];
			}
			// On post edit, we shouldn't change the
			//  editable status of the post.  We aren't reading the editable/deletable
			//  status of the post on the back end on post edit, so it won't
			//  be passed forward accurately.
			new_post_object.deletable = this.get("deletable");
			new_post_object.editable = this.get("editable");
			this.set(new_post_object);
		},

		checkShowTargetLink: function () {
			if (!this.get("has_target")) {
				return false;
			}
			return this.get("topic").checkShowTargetLink();
		},

		fetchIP: function (obj) {
			cmty_ajax.add({
				a: "fetch_ip",
				params: {
					post_id: this.get("post_id"),
				},
				main_handler: function (ok, msg) {},
				extra_handlers: obj,
			});
		},
	});

	/**
	 * Model for reports of posts.
	 *
	 * Loaded in Community.Models.Master.fetchReportedPosts()
	 *
	 * post : Community.Models.Post of the reported post
	 *
	 */
	ComModels.PostReport = Backbone.Model.extend({
		initialize: function () {},

		/**
		 * Settle a post report.
		 *
		 * @param object
		 *		onFinish (optional): function to fire upon finishing
		 * 		onError (optional) : function to fire upon Ajax error
		 *		notes string : notes about resolution of report
		 **/
		settle: function (obj) {
			var self = this;
			cmty_ajax.add({
				a: "settle_post_report",
				params: {
					id: this.get("id"),
					notes: obj.hasOwnProperty("notes") ? obj.notes : "",
				},
				never_cancel: true,
				main_handler: function (ok, msg) {
					if (ok) {
						self
							.get("post")
							.get("topic")
							.get("master")
							.resetTopicReports({
								topic_id: self.get("topic_id"),
								post_id: self.get("post_id"),
								topic_num_reports: msg.response.topic_num_reports,
							});
						self.get("post").set("reported", false);
						self
							.get("post")
							.get("topic")
							.get("master")
							.closePostReports(self.get("post_id"));
					}
				},
				extra_handlers: obj,
			});
		},

		/**
		 * If we delete the post via the Reported Posts page, then the back end will
		 *  take care of the post report.  Up here on the front end, we need
		 *  to find the master topic if it exists, and decrement the topic's number
		 *  of reports.
		 *  (Note: the topic model of the reported post is not in the master model's topics
		 *	collection; it is merely a tool that gets passed to the front end to have access
		 *	to some Topic model methods when interacting with the post report.)
		 **/
		decrementNumReports: function () {
			var topic_id = this.get("topic_id"),
				topic = this.get("post")
					.get("topic")
					.get("master")
					.fetchTopicById(topic_id);

			if (
				!_.isUndefined(topic) &&
				!_.isNull(topic) &&
				topic.get("num_reports") > 0
			) {
				topic.set("num_reports", topic.get("num_reports") - 1);
			}
		},
	});

	/**
	 * Shell model that allows us to make boxes that operate
	 *  as if they are holding the items of a Category.  Currently
	 *  only used for holding the containers of a Category.  Allows
	 *  us to use the Itembox View for containers, which is nice.
	 **/
	ComModels.ItemsHolder = Backbone.Model.extend({
		initialize: function () {},

		fetchMoreItems: function () {
			return;
		},
	});

	ComModels.ContainerHolder = ComModels.ItemsHolder.extend({
		addItem: function (obj) {
			var item = this.fetchItem(obj.item);
			if (!_.isUndefined(item)) {
				if (obj.hasOwnProperty("onError")) {
					obj.onError({
						error_code: "E_ALREADY_ADDED",
					});
				}
			} else {
				this.get("items").push(obj.item);
				this.trigger("item_added", obj.item);

				/**
				 * We are adding the category that holds this
				 *  container_model to the item that is being
				 *  passed to "addItem" here.  So, the category_id
				 *  and item_id fields below are the opposite of
				 *  what you might expect.
				 **/
				if (this.get("category").get("category_id") > 0) {
					cmty_ajax.add({
						a: "add_item_to_category",
						params: {
							category_id: obj.item.item_id,
							item_id: this.get("category").get("category_id"),
							item_forum_id: 0,
							item_type: this.get("category").get("category_type"),
						},
						main_handler: function (ok, msg) {},
					});
				}
			}
		},

		fetchItem: function (fetch_item) {
			return _.find(this.get("items"), function (item) {
				return (
					item.item_id === fetch_item.item_id &&
					item.item_forum_id === fetch_item.item_forum_id &&
					item.item_type === fetch_item.item_type
				);
			});
		},

		removeItem: function (removed_item) {
			var current_item = this.fetchItem(removed_item);

			if (_.isUndefined(current_item)) {
				return;
			}

			this.set("items", _.without(this.get("items"), current_item));
			this.trigger("item_removed");
			if (this.get("category").get("category_id") > 0) {
				/**
				 * We are removing the category that holds this
				 *  container_model from the item that is being
				 *  passed to "removeItem" here.  So, the category_id
				 *  and item_id fields below are the opposite of
				 *  what you might expect.
				 **/
				cmty_ajax.add({
					a: "remove_item_from_category",
					params: {
						category_id: current_item.item_id,
						item_id: this.get("category").get("category_id"),
						item_forum_id: 0,
						item_type: this.get("category").get("category_type"),
					},
					main_handler: function (ok, msg) {},
				});
			}
		},
	});

	/**
	 * Model for a single user.
	 *
	 * Primarily used for the profile page.
	 */
	ComModels.User = Backbone.Model.extend({
		defaults: {
			all_friends_loaded: false,
			all_requests_loaded: false,
			avatar: "",
			can_pm: false,
			email: "",
			friends_initialized: false,
			goals: "",
			has_classes: false,
			has_ebooks: false,
			hide_avatars: false,
			hide_tags_on_topic: false,
			interests: "",
			is_banned: false,
			is_bookmarked: false,
			is_coppa_blocked: false,
			has_parent_controller: false,
			is_limited: false,
			is_new_user: false,
			is_online: false,
			joined_at: 0, // Unix time
			loading_friends: false,
			location: "",
			num_posts: 0,
			occupation: "",
			posting_subscribe_reply: false,
			school: "",
			show_last_visit: true,
			show_tags_on_feed: false,
			status: "",
			warn_on_snipes: false,
			website: "",
		},

		initialize: function () {
			this.set(
				"joined_at",
				moment(this.get("joined_at"), "X").format("MMMM D, YYYY")
			);

			if (this.has("last_visit") && this.get("last_visit") > 0) {
				if (this.get("is_online")) {
					this.set(
						"last_visit_pretty",
						AoPS.Community.Lang["user-item-online"]
					);
				} else {
					this.set(
						"last_visit_pretty",
						AoPS.Community.Utils.makePrettyTimeStatic(this.get("last_visit"))
					);
				}
			} else {
				this.set("last_visit_pretty", this.get("joined_at"));
			}

			if (!this.has("friends")) {
				this.set("friends", []);
			} else {
				this.set("friends_initialized", true);
			}
			if (!this.has("friend_requests")) {
				this.set("friend_requests", []);
			}

			//friends added by friend request acceptances during this page load.
			this.set("new_friends", []);
		},

		/**
		 * User has left the friends system.  Empty everything.
		 **/
		emptyFriends: function () {
			this.set("friends", []);
			this.set("friend_requests", []);
			this.set("all_friends_loaded", false);
			this.set("friends_initialized", false);
		},

		/**
		 * Delete this user's avatar.
		 *
		 * @param obj
		 * 		optional extra handlers.
		 **/
		deleteAvatar: function (obj) {
			cmty_ajax.add({
				a: "delete_avatar",
				params: {
					user_id: this.get("user_id"),
				},
				main_handler: function (ok, msg) {},
				extra_handlers: obj,
			});
		},

		/**
		 * Fetch friends and/or friend_requests of this user.
		 *
		 * @param obj
		 *		fetch_type string initial|friends|friend_requests
		 *
		 * We only use fetch_type initial if this user is the currently logged in user.
		 *
		 **/
		fetchFriends: function (obj) {
			var self = this,
				last_friend;

			if (obj.fetch_type === "initial") {
				last_friend = "";
			} else {
				last_friend = _.last(this.get(obj.fetch_type)).username;
			}

			this.set("loading_friends", true);

			cmty_ajax.add({
				a: "fetch_friends",
				params: {
					user_id: this.get("user_id"),
					last_friend: last_friend,
					fetch_type: obj.fetch_type,
				},
				main_handler: function (ok, msg) {
					if (ok) {
						if (msg.response.hasOwnProperty("all_friends_loaded")) {
							self.set("all_friends_loaded", msg.response.all_friends_loaded);
						}

						/**
						 * If we have accepted friend requests during this page load, then
						 *  we want to check any later fetched friends during scroll down
						 *  against those who have just been accepted, to make sure we don't
						 *	build multiple boxes.
						 **/
						if (msg.response.hasOwnProperty("friends")) {
							msg.response.loaded_friends = [];
							if (
								self.has("new_friends") &&
								self.get("new_friends").length === 0
							) {
								msg.response.loaded_friends = msg.response.friends;
							} else {
								_.each(msg.response.friends, function (friend) {
									if (!self.wasFriendAddedDuringThisPageLoad(friend.user_id)) {
										msg.response.loaded_friends.push(friend);
									}
								});
							}
							self.set(
								"friends",
								self.get("friends").concat(msg.response.loaded_friends)
							);
						}
						if (msg.response.hasOwnProperty("friend_requests")) {
							self.set(
								"friend_requests",
								self.get("friend_requests").concat(msg.response.friend_requests)
							);
						}
						if (msg.response.hasOwnProperty("all_requests_loaded")) {
							self.set("all_requests_loaded", msg.response.all_requests_loaded);
						}
					} else {
					}
					self.set("loading_friends", false);
				},
				extra_handlers: obj,
			});
		},

		fetchBlockedUsers: function (obj) {
			if (!obj) {
				obj = {};
			}

			var self = this;

			cmty_ajax.add({
				a: "fetch_blocked_users",
				params: {
					user_id: this.get("user_id"),
				},
				main_handler: function (ok, msg) {
					if (ok) {
						self.set("blocked_users", msg.response.blocked_users);
					}
				},
				extra_handlers: obj,
			});
		},

		blockUser: function (obj) {
			if (!obj) {
				obj = {};
			}

			var self = this;
			var user_id = this.get("user_id");
			var blocked_user_id = obj.blocked_user_id;
			var blocked_username = obj.blocked_username;

			cmty_ajax.add({
				a: "block_user",
				params: {
					user_id: user_id,
					blocked_user_id: blocked_user_id,
					blocked_username: blocked_username,
				},
				main_handler: function (ok) {
					if (ok) {
						self.fetchBlockedUsers();
					}
				},
				extra_handlers: obj,
			});
		},

		unblockUser: function (obj) {
			if (!obj) {
				obj = {};
			}

			var self = this;
			var user_id = this.get("user_id");
			var blocked_user_id = obj.blocked_user_id;
			var blocked_username = obj.blocked_username;

			cmty_ajax.add({
				a: "unblock_user",
				params: {
					user_id: user_id,
					blocked_user_id: blocked_user_id,
					blocked_username: blocked_username,
				},
				main_handler: function (ok, msg) {
					if (ok) {
						self.fetchBlockedUsers();
					}
				},
				extra_handlers: obj,
			});
		},

		fetchTopFora: function (obj) {
			var self = this;

			cmty_ajax.add({
				a: "fetch_top_fora",
				params: {
					user_id: this.get("user_id"),
				},
				main_handler: function (ok, msg) {
					if (ok) {
						self.set("top_fora", msg.response.top_fora);
					}
				},
				extra_handlers: obj,
			});
		},

		/**
		 * We track what friends are added during this load so that
		 *  we won't build multiple boxes for the same user.
		 *
		 * @param int user_id of friend to check.
		 **/
		wasFriendAddedDuringThisPageLoad: function (user_id) {
			return !_.isUndefined(
				_.findWhere(this.get("new_friends"), {
					user_id: user_id,
				})
			);
		},

		/**
		 * Remove a friend.
		 *
		 * @param object
		 *		user_id int friend to remove
		 **/
		unFriend: function (obj) {
			var self = this,
				friend;

			friend = _.findWhere(self.get("friends"), {
				user_id: obj.user_id,
			});

			if (!_.isUndefined(friend)) {
				self.set("friends", _.without(self.get("friends"), friend));
			}
			cmty_ajax.add({
				a: "unfriend",
				params: {
					user_id: obj.user_id,
				},
				main_handler: function (ok, msg) {},
			});
		},

		/**
		 * Set a user's setting (used for profile and community settings).
		 *
		 * @param obj
		 *		field string field that is changing
		 *		value string value to change to
		 *		set_from optional string identifier of page that is making the profile change.
		 *
		 * Triggers status_changed if the status is the changed field, and sends the
		 *	set_from value as a parameter in the trigger.
		 **/
		setUserSetting: function (obj) {
			var self = this,
				is_boolean;

			is_boolean = typeof this.get(obj.field) === "boolean";

			cmty_ajax.add({
				a: "set_profile_field",
				params: {
					field: obj.field,
					value: obj.value,
					user_id: this.get("user_id"),
				},
				main_handler: function (ok, msg) {
					if (ok) {
						if (is_boolean) {
							obj.value = parseInt(obj.value) === 1;
						}
						if (obj.field === "friends_exclude" && obj.value) {
							self.emptyFriends();
						}
						if (obj.field !== "email") {
							self.set(obj.field, obj.value);
						}
						if (obj.field === "status") {
							self.trigger("status_changed", {
								set_from: obj.hasOwnProperty("set_from") ? obj.set_from : "",
							});
						}
					} else {
					}
				},
				extra_handlers: obj,
			});
		},

		/***
		 * Submit a new password for this user.
		 *
		 * @param object
		 *		new_password string
		 *		old_password string
		 *		onError function error handler.
		 *
		 * Does not run on cmty_ajax rails so that we can encrypt the ajax call.
		 **/
		submitNewPassword: function (obj) {
			$.ajax({
				url: AoPS.protected_url + "m/community/ajax.php",
				timeout: 10000,
				type: "post",
				data: {
					a: "reset_password",
					new_password: obj.new_password,
					aops_session_id: AoPS.session.id,
					current_password: obj.old_password,
				},
				crossDomain: true,
				xhrFields: {
					withCredentials: true,
				},
				error: function (data) {},
				success: function (data) {
					if (data.hasOwnProperty("error_code")) {
						//ERROR!
						if (obj.hasOwnProperty("onError")) {
							obj.onError(data);
						}
					} else {
						if (obj.hasOwnProperty("onFinish")) {
							obj.onFinish(data.response);
						}
					}
				},
			});
		},

		/**
		 * Close a friend request.
		 *
		 * @param obj
		 *		user_id	requester user_id
		 *		action string decline|accept
		 *		regular extra handlers.
		 **/
		closeFriendRequest: function (obj) {
			var self = this;
			cmty_ajax.add({
				a: "close_friend_request",
				params: {
					user_id: obj.user_id,
					action: obj.action,
				},
				main_handler: function (ok, msg) {
					var friend;
					if (ok) {
						friend = msg.response.new_friend_data;

						if (obj.action === "accepted") {
							self.get("new_friends").push(friend);
							// Want the new friends at the front because
							//  we use the last friend to fetch the rest.
							//  Small hole: user deletes last friend and then accepts
							//  new friends in same page load.  I can live with that.
							self.get("friends").unshift(friend);
						}
					} else {
					}
				},
				extra_handlers: obj,
			});
			this.set(
				"friend_requests",
				_.reject(this.get("friend_requests"), function (req) {
					return req.user_id === obj.user_id;
				})
			);
		},

		/**
		 * Archive all private messages for the currently logged in user
		 **/
		archiveAllPrivates: function () {
			var master = this.get("master"),
				i,
				message,
				privates = master.get("my_privates").get("active_topics"),
				len = privates.length;

			// Only call for current user (should this function be moved to master?)
			if (master.get("current_user") !== this) {
				return;
			}

			for (i = len - 1; i >= 0; i--) {
				message = privates.models[i];
				message.set("status", "archived");
				master.get("topics").remove(message);
				master.get("topics").add(message);
			}
			master.get("my_privates_archive").set("all_topics_loaded", false);
			cmty_ajax.add({
				a: "archive_all_privates",
				params: {},
				main_handler: function (ok, msg) {},
			});
		},

		/**
		 * Remove from all private messages for the currently logged in user
		 **/
		removeFromAllPrivates: function () {
			var master = this.get("master"),
				i,
				message,
				privates = master.get("my_privates").get("active_topics"),
				privates_archive = master
					.get("my_privates_archive")
					.get("active_topics"),
				len_privates = privates.length,
				len_privates_archive = privates_archive.length;

			// Only call for current user (should this function be moved to master?)
			if (master.get("current_user") !== this) {
				return;
			}

			for (i = len_privates - 1; i >= 0; i--) {
				message = privates.models[i];
				master.get("topics").remove(message);
				message.destroy();
			}

			for (i = len_privates_archive - 1; i >= 0; i--) {
				message = privates_archive.models[i];
				master.get("topics").remove(message);
				message.destroy();
			}

			cmty_ajax.add({
				a: "remove_from_all_privates",
				params: {},
				main_handler: function (ok, msg) {},
			});
		},

		/**
		 * Clean out a bookmark category.  Wipe everything, clean out the feed,
		 *  and/or unsubscribe from all.
		 *
		 * @param object
		 *		bookmark_section string tags|topics|forums
		 *		clear_type all|feed|email
		 **/
		clearBookmarks: function (obj) {
			cmty_ajax.add({
				a: "clear_bookmarks",
				params: {
					user_id: this.get("user_id"),
					bookmark_section: obj.bookmark_section,
					clear_type: obj.clear_type,
				},
				main_handler: function (ok, msg) {
					// Page reloads when this is finished.
				},
				extra_handlers: obj,
			});
		},

		/**
		 * Add an admin note to this user
		 **/
		addNote: function (obj) {
			cmty_ajax.add({
				a: "add_user_note",
				params: {
					user_id: this.get("user_id"),
					note_text: obj.note_text,
				},
				main_handler: function (ok, msg) {},
				extra_handlers: obj,
			});
		},

		/**
		 * Make an object for an EditableItemList for this user.
		 **/
		makeItemOfThis: function () {
			return {
				is_admin: this.get("is_admin"),
				is_visible: true,
				label: this.get("username"),
				user_id: this.get("user_id"),
				value: this.get("username"),
			};
		},

		setBlogSubscriptionStatus: function (obj) {
			cmty_ajax.add({
				a: "set_blog_subscription",
				params: {
					blog_id: obj.blog_id,
					status: obj.status ? 1 : 0,
				},
				main_handler: function (ok, msg) {},
			});
		},
	});

	ComModels.CategoryUser = ComModels.User.extend({
		getPermission: function (key) {
			if (key === "c_can_read") {
				return true;
			} else {
				return false;
			}
		},
	});

	/***
	 * Managing model for the administrative tag-term stuff
	 **/
	ComModels.TagTermManager = ComModels.Model.extend({
		defaults: {
			focus_tag: null,
			focus_term: null,
		},

		initialize: function () {
			this.set(
				"tags",
				new (Backbone.Collection.extend({
					model: ComModels.Tag,
				}))()
			);

			this.get("tags").comparator = function (tag) {
				return tag.get("tag_text").toLowerCase();
			};

			this.set(
				"terms",
				new (Backbone.Collection.extend({
					model: ComModels.Term,
				}))()
			);
			this.get("terms").comparator = function (term) {
				return term.get("term_text").toLowerCase();
			};
		},

		/**
		 * Fetch all the terms, and fetch any tag that goes with the term.
		 **/
		fetch_map: function (obj) {
			var self = this;
			cmty_ajax.add({
				a: "fetch_tag_term_map",
				params: {},
				main_handler: function (ok, msg) {
					if (ok) {
						self.get("terms").add(msg.response.terms);
						self.get("tags").add(msg.response.tags);
						_.each(msg.response.maps, function (map) {
							var tag, term;

							tag = self.findTagById(map.tag_id);
							term = self.findTermById(map.term_id);

							if (!_.isUndefined(tag) && !_.isUndefined(term)) {
								tag.get("mapped_terms").add(term);
								term.get("mapped_tags").add(tag);
							}
						});
					}
				},
				extra_handlers: obj,
			});
		},

		findTagById: function (tag_id) {
			return this.get("tags").findWhere({tag_id: tag_id});
		},

		findTermById: function (term_id) {
			return this.get("terms").findWhere({term_id: term_id});
		},

		/**
		 * Delete a mapping between a term and tag.  On front end and back.
		 *
		 * @param obj
		 *		term ComModels.Term
		 *		tag ComModels.Tag
		 **/
		deleteMap: function (obj) {
			obj.term.get("mapped_tags").remove(obj.tag);
			obj.tag.get("mapped_terms").remove(obj.term);
			cmty_ajax.add({
				a: "remove_tag_term_map",
				params: {
					tag_id: obj.tag.get("tag_id"),
					term_id: obj.term.get("term_id"),
				},
				main_handler: function (ok, msg) {},
			});
		},

		/**
		 * Delete a term entirely.  Removes from database as well.
		 *	Destroys the term model on the front end, removes
		 *	from all the tag collections of mapped terms.
		 *
		 * @param object
		 *		term : ComModels.Term
		 **/
		deleteTerm: function (obj) {
			obj.term.get("mapped_tags").each(function (tag) {
				tag.get("mapped_terms").remove(obj.term);
			});
			this.get("terms").remove(obj.term);
			cmty_ajax.add({
				a: "delete_term",
				params: {
					term_id: obj.term.get("term_id"),
				},
				main_handler: function (ok, msg) {
					if (ok) {
						obj.term.destroy();
					}
				},
			});
		},

		/**
		 * Add a tag to the current focus term
		 *
		 * @param object
		 *		item_id int tag_id
		 *		label string tag_text
		 **/
		addTagToFocusTerm: function (tag) {
			var existing_tag = this.get("tags").findWhere({
				tag_id: tag.item_id,
			});

			if (_.isUndefined(existing_tag)) {
				existing_tag = new AoPS.Community.Models.Tag({
					tag_id: tag.item_id,
					tag_text: tag.label,
				});
			}

			this.get("tags").add(existing_tag);
			this.mapTagTerm(existing_tag, this.get("focus_term"));

			this.saveTagTermMap({
				tag_id: tag.item_id,
				term_id: this.get("focus_term").get("term_id"),
			});
		},

		/**
		 * Add a term to the focus tag by Term model.
		 *
		 * @param ComModels.Term
		 **/
		addTermToFocusTag: function (term) {
			this.mapTagTerm(this.get("focus_tag"), term);

			this.saveTagTermMap({
				tag_id: this.get("focus_tag").get("tag_id"),
				term_id: term.get("term_id"),
			});
		},

		/**
		 * Add a term to the focus tag by the term's text.
		 *
		 * @param object
		 *		term_text string
		 *		onFinish,onError
		 **/
		addTermTextToFocusTag: function (obj) {
			var self = this,
				term = this.get("terms").findWhere({
					text_lc: obj.term_text.toLowerCase(),
				});
			if (_.isUndefined(term)) {
				cmty_ajax.add({
					a: "add_new_term_text_to_tag",
					params: {
						term_text: obj.term_text,
						tag_id: this.get("focus_tag").get("tag_id"),
					},
					main_handler: function (ok, msg) {
						var new_term;
						if (ok) {
							new_term = new ComModels.Term({
								term_id: msg.response.term_id,
								term_text: obj.term_text,
							});
							self.get("terms").add(new_term);
							self.mapTagTerm(self.get("focus_tag"), new_term);
						}
					},
					extra_handlers: obj,
				});
			} else {
				this.addTermToFocusTag(term);
			}
		},

		/**
		 * Save a tag-term mapping to the database.
		 *
		 * @param obj
		 *		term_id int
		 *		tag_id int
		 **/
		saveTagTermMap: function (obj) {
			cmty_ajax.add({
				a: "add_tag_term_map",
				params: {
					tag_id: obj.tag_id,
					term_id: obj.term_id,
				},
				main_handler: function (ok, msg) {},
			});
		},

		/**
		 * Map a tag and a term to each other.
		 *
		 * @param ComModels.Tag
		 * @param ComModels.Term
		 **/
		mapTagTerm: function (tag, term) {
			tag.get("mapped_terms").add(term);
			term.get("mapped_tags").add(tag);
		},

		/**
		 * Construct an autocomplete source array from the current terms.
		 **/
		constructTermAutocompleteSource: function () {
			return this.get("terms").map(function (term) {
				return {
					value: term.get("term_text"),
					label: term.get("term_text"),
					term: term,
				};
			});
		},

		buildNewTerm: function (obj) {
			var term_text_lc = obj.term_text.toLowerCase(),
				term,
				self = this;

			term = this.get("terms").findWhere({
				text_lc: term_text_lc,
			});

			if (!_.isUndefined(term)) {
				if (obj.hasOwnProperty("onFinish")) {
					obj.onFinish({
						term: term,
					});
				}
			}
			cmty_ajax.add({
				a: "construct_new_term",
				params: {
					term_text: obj.term_text,
				},
				main_handler: function (ok, msg) {
					var new_term;
					if (ok) {
						new_term = new ComModels.Term({
							term_text: obj.term_text,
							term_id: msg.response.term_id,
						});
						self.get("terms").add(new_term);
						msg.response.term = new_term;
					}
				},
				extra_handlers: obj,
			});
		},

		loadTagById: function (obj) {
			var existing_tag = this.get("tags").findWhere({
					tag_id: obj.tag_id,
				}),
				self = this;

			if (!_.isUndefined(existing_tag)) {
				if (typeof obj.onFinish === "function") {
					obj.onFinish({
						tag_id: obj.tag_id,
					});
				}
				return;
			}

			cmty_ajax.add({
				a: "load_tag_by_id",
				params: {
					tag_id: obj.tag_id,
				},
				main_handler: function (ok, msg) {
					if (ok) {
						self.get("tags").add({
							tag_id: msg.response.tag_id,
							tag_text: msg.response.tag_text,
						});
					}
				},
				extra_handlers: obj,
			});
		},

		deleteFocusTerm: function () {
			this.deleteTerm({
				term: this.get("focus_term"),
			});
			this.set("focus_term", null);
		},

		addNewTagTextToFocusTerm: function (obj) {
			var self = this;
			cmty_ajax.add({
				a: "add_new_tag_text_to_term",
				params: {
					term_id: this.get("focus_term").get("term_id"),
					tag_text: obj.tag_text,
				},
				main_handler: function (ok, msg) {
					var tag;
					if (ok) {
						tag = self.get("tags").findWhere({
							tag_id: msg.response.tag_id,
						});

						if (_.isUndefined(tag)) {
							tag = new ComModels.Tag({
								tag_id: msg.response.tag_id,
								tag_text: obj.tag_text,
							});
						}

						self.get("tags").add(tag);
						self.mapTagTerm(tag, self.get("focus_term"));
					}
				},
				extra_handlers: obj,
			});
		},

		fetchItemAutocompleteMatches: function (obj) {
			this.makeItemAutocompleteCall(
				"fetch_tag_term_autocomplete",
				{
					text_stub: obj.request.term,
					fetch_type: obj.additional_params.type,
				},
				obj
			);
		},

		/**
		 * Given text, go get the tag id.
		 *
		 * @param
		 *		tag_text string
		 *		onFinish, onError; all the action is almsot always in the handlers.
		 **/
		fetchTagIdByText: function (obj) {
			var self = this;
			cmty_ajax.add({
				a: "fetch_tag_by_text",
				params: {
					tag_text: obj.tag_text,
					create_new:
						obj.hasOwnProperty("create_new") && obj.create_new ? 1 : 0,
					suppress_clean:
						obj.hasOwnProperty("suppress_clean") && obj.suppress_clean ? 1 : 0,
				},
				main_handler: function (ok, msg) {
					var tag;
					// Action is always in the handlers.
					if (ok) {
						tag = self.findTagById(msg.response.tag_id);
						if (_.isUndefined(tag)) {
							tag = new AoPS.Community.Models.Tag({
								tag_id: msg.response.tag_id,
								tag_text: obj.tag_text,
							});
							self.get("tags").add(tag);
						}
						msg.response.tag = tag;
					}
				},
				extra_handlers: obj,
			});
		},

		makeItemAutocompleteCall:
			ComModels.Category.prototype.makeItemAutocompleteCall,
	});

	/**
	 * Used only for the tag-term manager and the tag admin; not used in general cmty
	 **/
	ComModels.Tag = ComModels.Model.extend({
		initialize: function () {
			this.set("text_lc", this.get("tag_text").toLowerCase());
			this.set(
				"mapped_terms",
				new (Backbone.Collection.extend({
					model: ComModels.Term,
				}))()
			);
			this.get("mapped_terms").comparator = function (term) {
				return term.get("text_lc");
			};
		},

		fetchForumData: function (obj) {
			var self = this;
			cmty_ajax.add({
				a: "fetch_tag_forum_data",
				params: {
					tag_id: this.get("tag_id"),
				},
				main_handler: function (ok, msg) {
					if (ok) {
						self.set("forum_data", msg.response.forum_data);
					}
				},
				extra_handlers: obj,
			});
		},

		recapitalize: function (obj) {
			cmty_ajax.add({
				a: "recapitalize_tag",
				params: {
					tag_id: this.get("tag_id"),
					new_text: obj.new_text,
				},
				main_handler: function (ok, msg) {
					// All the action in the extras; we reload on success
				},
				extra_handlers: obj,
			});
		},

		mergeToTag: function (obj) {
			var merged_categories = obj.hasOwnProperty("affected_categories")
				? obj.affected_categories
				: [];
			cmty_ajax.add({
				a: "merge_tags",
				params: {
					merge_from: this.get("tag_id"),
					merge_to: obj.new_tag_id,
					affected_categories: JSON.stringify(merged_categories),
				},
				main_handler: function (ok, msg) {
					// Not going to bother doing anything drastic here
					//  because this is only used in admin, and the page reloads on finish.
				},
				extra_ajax_runner_options: {
					timeout: 240000,
				},
				extra_handlers: obj,
			});
		},

		/**
		 * Delete this tag from certain categories
		 *
		 * @param object
		 *		delete_type string all_fora|all
		 *		affected_categories optional array of category ids to which to restrict deletion
		 **/
		deleteTag: function (obj) {
			var affected_categories = obj.hasOwnProperty("affected_categories")
				? obj.affected_categories
				: [];

			cmty_ajax.add({
				a: "delete_tag_admin",
				params: {
					tag_id: this.get("tag_id"),
					delete_type: obj.delete_type,
					affected_categories: JSON.stringify(affected_categories),
				},
				main_handler: function (ok, msg) {
					if (ok) {
						// Not going to bother doing anything drastic here
						//  because this is only used in admin, and the page reloads on finish.
					}
				},
				extra_ajax_runner_options: {
					timeout: 240000,
				},
				extra_handlers: obj,
			});
		},
	});

	/**
	 * Used only for the tag-term manager; not used in general cmty
	 **/
	ComModels.Term = ComModels.Model.extend({
		initialize: function () {
			this.set("text_lc", this.get("term_text").toLowerCase());
			this.set(
				"mapped_tags",
				new (Backbone.Collection.extend({
					model: ComModels.Tag,
				}))()
			);

			this.get("mapped_tags").comparator = function (tag) {
				return tag.get("text_lc");
			};
		},
	});

	return ComModels;
})(AoPS.Community.Models || {});

/* eslint-enable eqeqeq */
